import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,

} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import CkEditor from '../../constants/CkEditor';
const API_URL = process.env.REACT_APP_API_BASE_URL;


const AddSystemRecordsMaster = () => {

  const [editorLoaded, setEditorLoaded] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewCompanyLogo, setPreviewCompanyLogo] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState('');
  const [System_RecordsData, setSystem_RecordsData] = useState({

    home_state_code: '',
    default_tax_name: '',
    default_tax_per: '',
    default_unit: '',
    default_hsn_code: '',
    default_company_no: '',
    company_name: '',
    company_address: '',
    company_address_1: '',
    company_phone: '',
    sale_retrun_code: null,
    sale_return_name_default: '',
    sale_code: null,
    sale_name_default: '',
    bank_code: null,
    bank_name_default: '',
    cash_name_default: '',
    cash_code: null,
    year_from: null,
    year_to: null,
    display_height: '',
    saledatabaselock: '',
    database_1_path: '',
    database_2_path: '',
    auto_raw_yes_no: '',
    weekly_off_day: '',
    sale_format: '',
    home_state: '',
    email_sender: '',
    email_receiver: '',
    ch_bill_header_name: '',
    ss_bill_header_name: '',
    sr_bill_header_name: '',
    pp_bill_header_name: '',
    pr_bill_header_name: '',
    po_bill_header_name: '',
    so_bill_header_name: '',
    rc_bill_header_name: '',
    qu_bill_header_name: '',
    rounded_off: '',
    c_rta_id: '',
    c_operator_id: '',
    p_register_comp_add: '',
    data_validation_check_yn: '',
    bill_type_method: "",
    cart_tcs_value: null,
    batch_no: '',
    style: '',
    brand: '',
    color: '',
    agent: '',
    dealer: '',
    irflag: "system"

  });
  const [stateTable, setStateTable] = useState([])
  const [editMode, setEditMode] = useState(false)
  const [flagMaster, setFlagMaster] = useState("")
  // const  []



  const [issuePurchaseKey, setIssuePurchaseKey] = useState({
    irflag: "issue_purchase"
  })
  const [issueSaleKey, setIssueSaleKey] = useState({
    irflag: "issue_sale"
  })

  const [issueChallanAgoKey, setIssueChallanAgoKey] = useState({
    irflag: "issue_challan_agr"
  })

  const [issueChallanSingleKey, setIssueChallanSingleKey] = useState({
    irflag: "issue_challan_single"
  })

  const [issueReciptedKey, setIssueReciptedKey] = useState({
    irflag: "issue_recipted"
  })

  const [issueReciptedAgoKey, setIssueReciptedAgoKey] = useState({
    irflag: "issue_recipted_agr"
  })





  const [issuePurchaseReturnKey, setIssuePurchaseReturnKey] = useState({
    irflag: "issue_purchase_return"
  });

  const [issueSaleReturnKey, setIssueSaleReturnKey] = useState({
    irflag: "issue_sale_return"
  });

  const [issueChallanOpticalKey, setIssueChallanOpticalKey] = useState({
    irflag: "issue_challan_optical"
  });

  const [voucherRecipted, setVoucherRecipted] = useState({
    irflag: "voucher_recipted"
  });

  const [voucherPayment, setVoucherPayment] = useState({
    irflag: "voucher_payment"
  });

  const [voucherContra, setVoucherContra] = useState({
    irflag: "voucher_contra"
  });

  const [voucherJournal, setVoucherJournal] = useState({
    irflag: "voucher_journal"
  });

  const [voucherCredit, setVoucherCredit] = useState({
    irflag: "voucher_credit"
  });

  const [voucherDebit, setVoucherDebit] = useState({
    irflag: "voucher_debit"
  });

  const [housekeeper, setHousekeeper] = useState({
    irflag: "housekeeper"
  });

  const [bookRoomService, setBookRoomService] = useState({
    irflag: "book_room_service"
  });

  const [partyDetail, setPartyDetail] = useState({
    irflag: "party_detail"
  });

  const [itemDetail, setItemDetail] = useState({
    irflag: "item_detail"
  });

  const [genChallanKey, setGenChallanKey] = useState({
    irflag: flagMaster
  })

  const [helperMasterSystemMasterYNTable, setHelperMasterSystemMasterYNTable] = useState([])
  const [helperMasterSaleMethodTable, setHelperMasterSaleMethodTable] = useState([])


  // Generic function to fetch helper master data
  const getHelperMasterData = async (formName, setStateCallback) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/HelperMaster/allOption?fromName=${formName}`, config);

      if (response.response?.data?.errors) {
        toast.success(response.response?.data?.errors);
        return;
      }

      if (response.status === true) {
        setStateCallback(response.helperMasterData);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`Something went wrong!!`);
    }
  };

  useEffect(() => {
    getHelperMasterData("system_record_yn", setHelperMasterSystemMasterYNTable);
    getHelperMasterData("system_record_sale_method", setHelperMasterSaleMethodTable);
  }, [])


  const getState = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/HelperMaster/allState`, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setStateTable(response.state_Master)
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
  }

  const getSystemRecords = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/System_Records/GetSystem_RecordsById`, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setSystem_RecordsData(response.system_RecordsDataById)
        setPreviewImage(API_URL + response.system_RecordsDataById.company_image)
        setPreviewCompanyLogo(API_URL + response.system_RecordsDataById.company_logo)

        if (response.system_RecordsDataById) {
          setEditMode(true)
        }
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
  }

  const getSystemRecordsWithFlag = async (flag, uiFlag) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/System_Records/GetSystem_RecordsByIdWithFlag?flag=${flag}`, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }


      if (response.status === true) {
        if (flag == "issue_sale") {
          setIssueSaleKey(response.system_RecordsDataById)
        }
        if (flag == "issue_purchase") {
          setIssuePurchaseKey(response.system_RecordsDataById)
        }

        if (flag == "issue_recipted") {
          setIssueReciptedKey(response.system_RecordsDataById)
        }
        if (flag == "issue_recipted_agr") {
          setIssueReciptedAgoKey(response.system_RecordsDataById)
        }

        if (flag == "issue_challan_agr") {
          setIssueChallanAgoKey(response.system_RecordsDataById)
        }

        if (flag == "issue_challan_single") {
          setIssueChallanSingleKey(response.system_RecordsDataById)
        }

        if (flag == "issue_sale_return") {
          setIssueSaleReturnKey(response.system_RecordsDataById)
        }
        if (flag == "issue_purchase_return") {
          setIssuePurchaseReturnKey(response.system_RecordsDataById)
        }

        if (flag == "voucher_recipted") {
          setVoucherRecipted(response.system_RecordsDataById)
        }
        if (flag == "voucher_payment") {
          setVoucherPayment(response.system_RecordsDataById)
        }
        if (flag == "voucher_contra") {
          setVoucherContra(response.system_RecordsDataById)
        }
        if (flag == "voucher_journal") {
          setVoucherJournal(response.system_RecordsDataById)
        }
        if (flag == "voucher_credit") {
          setVoucherCredit(response.system_RecordsDataById)
        }
        if (flag == "voucher_debit") {
          setVoucherDebit(response.system_RecordsDataById)
        }

        if (flag == "housekeeper") {
          setHousekeeper(response.system_RecordsDataById)
        }

        if (flag == "book_room_service") {
          setBookRoomService(response.system_RecordsDataById)
        }

        if (flag == "party_detail") {
          setPartyDetail(response.system_RecordsDataById)
        }

        if (flag == "item_detail") {
          setItemDetail(response.system_RecordsDataById)
        }

        if (flag == "issue_challan_optical") {
          setIssueChallanOpticalKey(response.system_RecordsDataById)
        }

        if (uiFlag == "challan") {
          setGenChallanKey(response.system_RecordsDataById)
        }
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
  }




  // const [slugFlag, setSlugFlag] = useState("");
  const [slugUiFlag, setSlugUiFlag] = useState("");
  const [title, setTitle] = useState("");

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const flag = searchParams.get('flag');
    const title = searchParams.get('title');
    const uiFlag = searchParams.get('uiFlag');

    // setSlugFlag(flag);
    setTitle(title);
    setSlugUiFlag(uiFlag);

    if (flag) {
      setFlagMaster(flag)


      getSystemRecords()
      // getSystemRecordsWithFlag("issue_sale");
      // getSystemRecordsWithFlag("issue_purchase");
      // getSystemRecordsWithFlag("issue_recipted");
      // getSystemRecordsWithFlag("issue_recipted_agr");
      // getSystemRecordsWithFlag("issue_challan_agr");
      // getSystemRecordsWithFlag("issue_challan_single");
      // getSystemRecordsWithFlag("issue_challan_optical");
      // getSystemRecordsWithFlag("issue_purchase_return");
      // getSystemRecordsWithFlag("issue_sale_return");

      getSystemRecordsWithFlag("housekeeper");
      getSystemRecordsWithFlag("book_room_service");
      getSystemRecordsWithFlag("party_detail");
      getSystemRecordsWithFlag("item_detail");


      if (flag == "voucher") {
        getSystemRecordsWithFlag("voucher_recipted");
        getSystemRecordsWithFlag("voucher_payment");
        getSystemRecordsWithFlag("voucher_contra");
        getSystemRecordsWithFlag("voucher_journal");
        getSystemRecordsWithFlag("voucher_credit");
        getSystemRecordsWithFlag("voucher_debit");
      }

      if (uiFlag == "challan") {
        getSystemRecordsWithFlag(flag, uiFlag);
      }
      getState();

      if (uiFlag == "challan") {
        setGenChallanKey((preState) => ({
          ...preState,
          irflag: flag
        }))

      }

    }
  }, [])


  const onHandleBackParty = () => {
    navigate(-1);
  };

  // const onChangeHandle = (e) => {
  //   const { name, value } = e.target;

  //   if (name == "home_state") {

  //     let findArray = stateTable.find(data => data.state_Name == value);

  //     setSystem_RecordsData((prevData) => ({
  //       ...prevData,
  //       [name]: value,
  //       "home_state_code": findArray?.state_Code
  //     }));


  //   } else {
  //     setSystem_RecordsData((prevData) => ({
  //       ...prevData,
  //       [name]: value,
  //     }));

  //   }
  const onChangeHandle = (e) => {
    const { name, value, type, files } = e.target;

    if (type === 'file') {

      if (name == "company_logo") {

        const file = files[0];
        setSystem_RecordsData((prevData) => ({
          ...prevData,
          [name]: file,
        }));

        // Create a preview URL for the image
        const filePreviewURL = URL.createObjectURL(file);
        setPreviewCompanyLogo(filePreviewURL);

      }
      if (name == 'company_image') {
        const file = files[0];
        setSystem_RecordsData((prevData) => ({
          ...prevData,
          [name]: file,
        }));

        // Create a preview URL for the image
        const filePreviewURL = URL.createObjectURL(file);
        setPreviewImage(filePreviewURL);

      }
    }
    else if (name === 'home_state') {
      let findArray = stateTable.find(data => data.state_Name === value);

      setSystem_RecordsData((prevData) => ({
        ...prevData,
        [name]: value,
        "home_state_code": findArray?.state_Code,
      }));

    } else {
      setSystem_RecordsData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    setErrorMessage((prevErrors) => ({
      ...prevErrors,
      [name]: '', // Clear the previous error when the user starts typing
    }));
  };

  //   setErrorMessage((prevErrors) => ({
  //     ...prevErrors,
  //     [name]: '', // Clear the previous error when the user starts typing
  //   }));
  // };

  const validateInputs = () => {
    const errors = {};

    if (!System_RecordsData.home_state_code) {
      errors.home_state_code = 'home_state_code is required';
    }
    if (!System_RecordsData.default_tax_name) {
      errors.default_tax_name = 'default_tax_name is required';
    }
    if (!System_RecordsData.default_tax_per) {
      errors.default_tax_per = 'default_tax_per is required';
    }
    if (!System_RecordsData.default_unit) {
      errors.default_unit = 'default_unit is required';
    }
    if (!System_RecordsData.default_hsn_code) {
      errors.default_hsn_code = 'default_hsn_code is required';
    }
    if (!System_RecordsData.default_company_no) {
      errors.default_company_no = 'default_company_no is required';
    }
    if (!System_RecordsData.company_name) {
      errors.company_name = 'company_name is required';
    }
    if (!System_RecordsData.company_address) {
      errors.company_address = 'company_address is required';
    }
    if (!System_RecordsData.company_address_1) {
      errors.company_address_1 = 'company_address_1 is required';
    }
    if (!System_RecordsData.company_phone) {
      errors.company_phone = 'company_phone is required';
    }
    if (!System_RecordsData.sale_retrun_code) {
      errors.sale_retrun_code = 'sale_retrun_code is required';
    }
    if (!System_RecordsData.sale_return_name_default) {
      errors.sale_return_name_default = 'sale_return_name_default is required';
    }
    if (!System_RecordsData.sale_code) {
      errors.sale_code = 'sale_code is required';
    }
    if (!System_RecordsData.sale_name_default) {
      errors.sale_name_default = 'sale_name_default is required';
    }
    if (!System_RecordsData.bank_code) {
      errors.bank_code = 'bank_code is required';
    }
    if (!System_RecordsData.bank_name_default) {
      errors.bank_name_default = 'bank_name_default is required';
    }
    if (!System_RecordsData.cash_name_default) {
      errors.cash_name_default = 'cash_name_default is required';
    }
    if (!System_RecordsData.cash_code) {
      errors.cash_code = 'cash_code is required';
    }
    if (!System_RecordsData.year_from) {
      errors.year_from = 'year_from is required';
    }
    if (!System_RecordsData.year_to) {
      errors.year_to = 'year_to is required';
    }
    if (!System_RecordsData.display_height) {
      errors.display_height = 'display_height is required';
    }
    if (!System_RecordsData.saledatabaselock) {
      errors.saledatabaselock = 'saledatabaselock is required';
    }
    if (!System_RecordsData.database_1_path) {
      errors.database_1_path = 'database_1_path is required';
    }
    if (!System_RecordsData.database_2_path) {
      errors.database_2_path = 'database_2_path is required';
    }
    if (!System_RecordsData.auto_raw_yes_no) {
      errors.auto_raw_yes_no = 'auto_raw_yes_no is required';
    }
    if (!System_RecordsData.weekly_off_day) {
      errors.weekly_off_day = 'weekly_off_day is required';
    }
    // if (!System_RecordsData.other2) {
    //   errors.other2 = 'other2 is required';
    // }
    // if (!System_RecordsData.other3) {
    //   errors.other3 = 'other3 is required';
    // }
    // if (!System_RecordsData.other4) {
    //   errors.other4 = 'other4 is required';
    // }
    // if (!System_RecordsData.other5) {
    //   errors.other5 = 'other5 is required';
    // }
    // if (!System_RecordsData.other6) {
    //   errors.other6 = 'other6 is required';
    // }
    // if (!System_RecordsData.other7) {
    //   errors.other7 = 'other7 is required';
    // }
    // if (!System_RecordsData.other8) {
    //   errors.other8 = 'other8 is required';
    // }
    // if (!System_RecordsData.other9) {
    //   errors.other9 = 'other9 is required';
    // }
    // if (!System_RecordsData.other10) {
    //   errors.other10 = 'other10 is required';
    // }
    // if (!System_RecordsData.other11) {
    //   errors.other11 = 'other11 is required';
    // }
    // if (!System_RecordsData.other12) {
    //   errors.other12 = 'other12 is required';
    // }
    // if (!System_RecordsData.other13) {
    //   errors.other13 = 'other13 is required';
    // }
    // if (!System_RecordsData.other14) {
    //   errors.other14 = 'other14 is required';
    // }
    // if (!System_RecordsData.other15) {
    //   errors.other15 = 'other15 is required';
    // }
    // if (!System_RecordsData.other16) {
    //   errors.other16 = 'other16 is required';
    // }
    // if (!System_RecordsData.other17) {
    //   errors.other17 = 'other17 is required';
    // }
    // if (!System_RecordsData.other18) {
    //   errors.other18 = 'other18 is required';
    // }
    // if (!System_RecordsData.other19) {
    //   errors.other19 = 'other19 is required';
    // }
    // if (!System_RecordsData.other20) {
    //   errors.other20 = 'other20 is required';
    // }
    if (!System_RecordsData.sale_format) {
      errors.sale_format = 'sale_format is required';
    }
    if (!System_RecordsData.home_state) {
      errors.home_state = 'home_state is required';
    }
    if (!System_RecordsData.email_sender) {
      errors.email_sender = 'email_sender is required';
    }
    if (!System_RecordsData.email_receiver) {
      errors.email_receiver = 'email_receiver is required';
    }
    if (!System_RecordsData.ch_bill_header_name) {
      errors.ch_bill_header_name = 'ch_bill_header_name is required';
    }
    if (!System_RecordsData.ss_bill_header_name) {
      errors.ss_bill_header_name = 'ss_bill_header_name is required';
    }
    if (!System_RecordsData.sr_bill_header_name) {
      errors.sr_bill_header_name = 'sr_bill_header_name is required';
    }
    if (!System_RecordsData.pp_bill_header_name) {
      errors.pp_bill_header_name = 'pp_bill_header_name is required';
    }
    if (!System_RecordsData.pr_bill_header_name) {
      errors.pr_bill_header_name = 'pr_bill_header_name is required';
    }
    if (!System_RecordsData.po_bill_header_name) {
      errors.po_bill_header_name = 'po_bill_header_name is required';
    }
    if (!System_RecordsData.so_bill_header_name) {
      errors.so_bill_header_name = 'so_bill_header_name is required';
    }
    if (!System_RecordsData.rc_bill_header_name) {
      errors.rc_bill_header_name = 'rc_bill_header_name is required';
    }
    if (!System_RecordsData.qu_bill_header_name) {
      errors.qu_bill_header_name = 'qu_bill_header_name is required';
    }
    if (!System_RecordsData.rounded_off) {
      errors.rounded_off = 'rounded_off is required';
    }
    if (!System_RecordsData.c_rta_id) {
      errors.c_rta_id = 'c_rta_id is required';
    }
    if (!System_RecordsData.c_operator_id) {
      errors.c_operator_id = 'c_operator_id is required';
    }
    if (!System_RecordsData.p_register_comp_add) {
      errors.p_register_comp_add = 'p_register_comp_add is required';
    }
    if (!System_RecordsData.data_validation_check_yn) {
      errors.data_validation_check_yn = 'data_validation_check_yn is required';
    }

    return errors;
  };


  async function uploadImagesFromArrayWithIndex(obj) {

    if (obj.company_image && typeof obj.company_image === 'object' && obj.company_image !== null && 'name' in obj.company_image) {
      try {
        const imageUrl = await uploadImage(obj.company_image);
        obj.company_image = imageUrl;
      } catch (error) {
        console.error(`Error uploading image`, error);
      }

    }

    if (obj.company_logo && typeof obj.company_logo === 'object' && obj.company_logo !== null && 'name' in obj.company_logo) {
      try {
        const imageUrl = await uploadImage(obj.company_logo);
        obj.company_logo = imageUrl;
      } catch (error) {
        console.error(`Error uploading image`, error);
      }

    }
  }

  async function uploadImage(image) {
    const uploadData = new FormData();
    uploadData.append('signature', image);

    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'accept': 'application/json'
      }
    };

    try {
      const response = await apiService.post("/api/CategoryMaster/uploadfile", uploadData, config);
      if (response.status === true) {
        return response.data;
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      throw new Error("Failed to upload image: " + error.message);
    }
  }


  const System_Records_Add_Edit_Screen = async () => {
    try {
      let config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const data = {
        ...System_RecordsData,
        System_Records_Issue_Purchase_Request: issuePurchaseKey,
        System_Records_Issue_Sale_Request: issueSaleKey,
        System_Records_Issue_Recipted_Request: issueReciptedKey,
        System_Records_Issue_Recipted_Ago_Request: issueReciptedAgoKey,

        System_Records_Issue_Challan_Ago_Request: issueChallanAgoKey,
        System_Records_Issue_Challan_Request: issueChallanSingleKey,

        System_Records_Issue_Challan_Optical_Request: issueChallanOpticalKey,

        System_Records_Issue_Sale_Return_Request: issueSaleReturnKey,
        System_Records_Issue_Purchase_Return_Request: issuePurchaseReturnKey,

        System_Records_Voucher_Recipted_Request: voucherRecipted,
        System_Records_Voucher_Payment_Request: voucherPayment,
        System_Records_Voucher_Contra_Request: voucherContra,
        System_Records_Voucher_Journal_Request: voucherJournal,
        System_Records_Voucher_Credit_Request: voucherCredit,
        System_Records_Voucher_Debit_Request: voucherDebit,

        System_Records_Housekeeper_Request: housekeeper,
        System_Records_Book_Room_Service_Request: bookRoomService,


        System_Records_Paty_Detail_Request: partyDetail,
        System_Records_Item_Detail_Request: itemDetail,

        System_Records_General_Challan_Request: genChallanKey,


      }

      await uploadImagesFromArrayWithIndex(data)

      let response;

      if (System_RecordsData.id) {
        response = await apiService.put(
          `/api/System_Records/UpdateSystem_Records?id=${System_RecordsData.id}`,
          data,
          config
        );

        // setSystem_RecordsData({
        //   home_state_code: '',
        //   default_tax_name: '',
        //   default_tax_per: '',
        //   default_unit: '',
        //   default_hsn_code: '',
        //   default_company_no: '',
        //   company_name: '',
        //   company_address: '',
        //   company_address_1: '',
        //   company_phone: '',
        //   sale_retrun_code: null,
        //   sale_return_name_default: '',
        //   sale_code: null,
        //   sale_name_default: '',
        //   bank_code: null,
        //   bank_name_default: '',
        //   cash_name_default: '',
        //   cash_code: null,
        //   year_from: null,
        //   year_to: null,
        //   display_height: '',
        //   saledatabaselock: '',
        //   database_1_path: '',
        //   database_2_path: '',
        //   auto_raw_yes_no: '',
        //   weekly_off_day: '',
        //   sale_format: '',
        //   home_state: '',
        //   email_sender: '',
        //   email_receiver: '',
        //   ch_bill_header_name: '',
        //   ss_bill_header_name: '',
        //   sr_bill_header_name: '',
        //   pp_bill_header_name: '',
        //   pr_bill_header_name: '',
        //   po_bill_header_name: '',
        //   so_bill_header_name: '',
        //   rc_bill_header_name: '',
        //   qu_bill_header_name: '',
        //   rounded_off: '',
        //   c_rta_id: '',
        //   c_operator_id: '',
        //   p_register_comp_add: '',
        //   data_validation_check_yn: ''
        // })

      } else {
        response = await apiService.post(
          '/api/System_Records/AddSystem_Records',
          data,
          config
        );
      }

      // if (response.response && response.response.data.errors) {
      //   toast.success(response.response?.data?.errors);;
      // }

      if (response.status === true) {
        toast.success(response.message);
        // setSystem_RecordsData({
        //   field_names: '',
        // });
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      alert('Something went wrong"');
    }
  };



  const onChangeIssueSaleHandle = (flag) => (e) => {

    const { name, value } = e.target;
    if (flag == "issue_sale") {
      setIssueSaleKey((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (flag == "issue_purchase") {
      setIssuePurchaseKey((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (flag == "issue_recipted") {
      setIssueReciptedKey((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }



    if (flag == "issue_recipted_agr") {
      setIssueReciptedAgoKey((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (flag == "issue_challan_agr") {
      setIssueChallanAgoKey((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (flag == "issue_challan_single") {
      setIssueChallanSingleKey((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }



    if (flag == "issue_purchase_return") {
      setIssuePurchaseReturnKey((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (flag == "issue_sale_return") {
      setIssueSaleReturnKey((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }


    if (flag == "voucher_recipted") {
      setVoucherRecipted((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (flag == "voucher_payment") {
      setVoucherPayment((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (flag == "voucher_contra") {
      setVoucherContra((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (flag == "voucher_journal") {
      setVoucherJournal((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (flag == "voucher_credit") {
      setVoucherCredit((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (flag == "voucher_debit") {
      setVoucherDebit((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (flag == "housekeeper") {
      setHousekeeper((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (flag == "book_room_service") {
      setBookRoomService((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (flag == "party_detail") {
      setPartyDetail((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (flag == "issue_challan_optical") {
      setIssueChallanOpticalKey((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (flag == "challan") {
      setGenChallanKey((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (flag == "item_detail") {
      setItemDetail((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  }



  const insertIssueDetail = async (flag) => {

    let params

    if (flag == "issue_sale") {
      params = { ...issueSaleKey, irflag: "issue_sale" }
    }
    if (flag == "issue_purchase") {
      params = { ...issuePurchaseKey, irflag: "issue_purchase" }
    }

    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.post(`/api/System_Records/AddSystem_Records`, params, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        alert(response.message)
        // setPartyTable(response.partyMasterDetailData)
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
  }

  // =========================================   CK EDITOR CODE   =========================================


  useEffect(() => {
    setEditorLoaded(true);
  }, []);



  return (
    <Row>
      <Col>
        <Card className='bg-white pd-10 card-box mb-30'>
          <CardTitle
            tag='h6'
            className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
          >
            <div className='d-flex align-items-center'>
              <i className='bi bi-bell mr-2'></i>
              System Parameters
            </div>
            <Button
              color='warning'
              size='bg'
              onClick={onHandleBackParty}
              className='ml-auto'
            >
              Back
            </Button>
          </CardTitle>

          {flagMaster == "system_old" && <CardBody>
            <Form>
              <div
                className='accordion accordion-flush'
                id='accordionFlushExample'
              >
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='flush-headingOne'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#flush-collapseOne'
                      aria-expanded='false'
                      aria-controls='flush-collapseOne'
                    >
                      System Detail
                    </button>
                  </h2>
                  <div
                    id='flush-collapseOne'
                    className='accordion-collapse collapse'
                    aria-labelledby='flush-headingOne'
                    data-bs-parent='#accordionFlushExample'
                  >
                    <div className='accordion-body'>
                      <FormGroup>
                        <Label for='home_state'>home_state</Label>
                        <Input
                          id='home_state'
                          name='home_state'
                          value={System_RecordsData.home_state}
                          onChange={onChangeHandle}
                          type="select" className="custom-select"
                        >
                          <option value="">Select</option>
                          {stateTable.map((option) => (
                            <option key={option.state_Id} value={option.state_Name}>
                              {option.state_Name}
                            </option>
                          ))}
                        </Input>
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.home_state}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='home_state_code'>home_state_code</Label>
                        <Input
                          id='home_state_code'
                          name='home_state_code'
                          value={System_RecordsData.home_state_code}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.home_state_code}
                          </FormText>
                        )}
                      </FormGroup>

                      <FormGroup>
                        <Label for='default_tax_name'>default_tax_name</Label>
                        <Input
                          id='default_tax_name'
                          name='default_tax_name'
                          value={System_RecordsData.default_tax_name}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.default_tax_name}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='default_tax_per'>default_tax_per</Label>
                        <Input
                          id='default_tax_per'
                          name='default_tax_per'
                          value={System_RecordsData.default_tax_per}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.default_tax_per}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='default_unit'>default_unit</Label>
                        <Input
                          id='default_unit'
                          name='default_unit'
                          value={System_RecordsData.default_unit}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.default_unit}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='default_hsn_code'>default_hsn_code</Label>
                        <Input
                          id='default_hsn_code'
                          name='default_hsn_code'
                          value={System_RecordsData.default_hsn_code}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.default_hsn_code}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='default_company_no'>default_company_no</Label>
                        <Input
                          id='default_company_no'
                          name='default_company_no'
                          value={System_RecordsData.default_company_no}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.default_company_no}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='company_name'>company_name</Label>
                        <Input
                          id='company_name'
                          name='company_name'
                          value={System_RecordsData.company_name}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.company_name}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='company_address'>company_address</Label>
                        <Input
                          id='company_address'
                          name='company_address'
                          value={System_RecordsData.company_address}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.company_address}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='company_address_1'>company_address_1</Label>
                        <Input
                          id='company_address_1'
                          name='company_address_1'
                          value={System_RecordsData.company_address_1}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.company_address_1}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='company_phone'>company_phone</Label>
                        <Input
                          id='company_phone'
                          name='company_phone'
                          value={System_RecordsData.company_phone}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.company_phone}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='sale_retrun_code'>sale_retrun_code</Label>
                        <Input
                          type='number'
                          id='sale_retrun_code'
                          name='sale_retrun_code'
                          value={System_RecordsData.sale_retrun_code}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.sale_retrun_code}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='sale_return_name_default'>sale_return_name_default</Label>
                        <Input
                          id='sale_return_name_default'
                          name='sale_return_name_default'
                          value={System_RecordsData.sale_return_name_default}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.sale_return_name_default}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='sale_code'>sale_code</Label>
                        <Input
                          type="number"
                          id='sale_code'
                          name='sale_code'
                          value={System_RecordsData.sale_code}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.sale_code}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='sale_name_default'>sale_name_default</Label>
                        <Input
                          id='sale_name_default'
                          name='sale_name_default'
                          value={System_RecordsData.sale_name_default}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.sale_name_default}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='bank_code'>bank_code</Label>
                        <Input
                          type='number'
                          id='bank_code'
                          name='bank_code'
                          value={System_RecordsData.bank_code}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.bank_code}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='bank_name_default'>bank_name_default</Label>
                        <Input
                          id='bank_name_default'
                          name='bank_name_default'
                          value={System_RecordsData.bank_name_default}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.bank_name_default}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='cash_name_default'>cash_name_default</Label>
                        <Input
                          id='cash_name_default'
                          name='cash_name_default'
                          value={System_RecordsData.cash_name_default}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.cash_name_default}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='cash_code'>cash_code</Label>
                        <Input
                          type='number'
                          id='cash_code'
                          name='cash_code'
                          value={System_RecordsData.cash_code}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.cash_code}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='year_from'>year_from</Label>
                        <Input
                          type='date'
                          id='year_from'
                          name='year_from'
                          value={System_RecordsData.year_from}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.year_from}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='year_to'>year_to</Label>
                        <Input
                          type='date'
                          id='year_to'
                          name='year_to'
                          value={System_RecordsData.year_to}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.year_to}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='display_height'>display_height</Label>
                        <Input
                          id='display_height'
                          name='display_height'
                          value={System_RecordsData.display_height}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.display_height}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='saledatabaselock'>saledatabaselock</Label>
                        <Input
                          id='saledatabaselock'
                          name='saledatabaselock'
                          value={System_RecordsData.saledatabaselock}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.saledatabaselock}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='database_1_path'>database_1_path</Label>
                        <Input
                          id='database_1_path'
                          name='database_1_path'
                          value={System_RecordsData.database_1_path}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.database_1_path}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='database_2_path'>database_2_path</Label>
                        <Input
                          id='database_2_path'
                          name='database_2_path'
                          value={System_RecordsData.database_2_path}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.database_2_path}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='auto_raw_yes_no'>auto_raw_yes_no</Label>
                        <Input
                          id='auto_raw_yes_no'
                          name='auto_raw_yes_no'
                          value={System_RecordsData.auto_raw_yes_no}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.auto_raw_yes_no}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='weekly_off_day'>weekly_off_day</Label>
                        <Input
                          id='weekly_off_day'
                          name='weekly_off_day'
                          value={System_RecordsData.weekly_off_day}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.weekly_off_day}
                          </FormText>
                        )}
                      </FormGroup>


                      <FormGroup>
                        <Label for='sale_format'>sale_format</Label>
                        <Input
                          id='sale_format'
                          name='sale_format'
                          value={System_RecordsData.sale_format}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.sale_format}
                          </FormText>
                        )}
                      </FormGroup>

                      <FormGroup>
                        <Label for='email_sender'>email_sender</Label>
                        <Input
                          id='email_sender'
                          name='email_sender'
                          value={System_RecordsData.email_sender}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.email_sender}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='email_receiver'>email_receiver</Label>
                        <Input
                          id='email_receiver'
                          name='email_receiver'
                          value={System_RecordsData.email_receiver}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.email_receiver}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='ch_bill_header_name'>ch_bill_header_name</Label>
                        <Input
                          id='ch_bill_header_name'
                          name='ch_bill_header_name'
                          value={System_RecordsData.ch_bill_header_name}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.ch_bill_header_name}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='ss_bill_header_name'>ss_bill_header_name</Label>
                        <Input
                          id='ss_bill_header_name'
                          name='ss_bill_header_name'
                          value={System_RecordsData.ss_bill_header_name}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.ss_bill_header_name}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='sr_bill_header_name'>sr_bill_header_name</Label>
                        <Input
                          id='sr_bill_header_name'
                          name='sr_bill_header_name'
                          value={System_RecordsData.sr_bill_header_name}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.sr_bill_header_name}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='pp_bill_header_name'>pp_bill_header_name</Label>
                        <Input
                          id='pp_bill_header_name'
                          name='pp_bill_header_name'
                          value={System_RecordsData.pp_bill_header_name}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.pp_bill_header_name}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='pr_bill_header_name'>pr_bill_header_name</Label>
                        <Input
                          id='pr_bill_header_name'
                          name='pr_bill_header_name'
                          value={System_RecordsData.pr_bill_header_name}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.pr_bill_header_name}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='po_bill_header_name'>po_bill_header_name</Label>
                        <Input
                          id='po_bill_header_name'
                          name='po_bill_header_name'
                          value={System_RecordsData.po_bill_header_name}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.po_bill_header_name}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='so_bill_header_name'>so_bill_header_name</Label>
                        <Input
                          id='so_bill_header_name'
                          name='so_bill_header_name'
                          value={System_RecordsData.so_bill_header_name}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.so_bill_header_name}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='rc_bill_header_name'>rc_bill_header_name</Label>
                        <Input
                          id='rc_bill_header_name'
                          name='rc_bill_header_name'
                          value={System_RecordsData.rc_bill_header_name}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.rc_bill_header_name}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='qu_bill_header_name'>qu_bill_header_name</Label>
                        <Input
                          id='qu_bill_header_name'
                          name='qu_bill_header_name'
                          value={System_RecordsData.qu_bill_header_name}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.qu_bill_header_name}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='rounded_off'>rounded_off</Label>
                        <Input
                          id='rounded_off'
                          name='rounded_off'
                          value={System_RecordsData.rounded_off}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.rounded_off}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='c_rta_id'>c_rta_id</Label>
                        <Input
                          id='c_rta_id'
                          name='c_rta_id'
                          value={System_RecordsData.c_rta_id}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.c_rta_id}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='c_operator_id'>c_operator_id</Label>
                        <Input
                          id='c_operator_id'
                          name='c_operator_id'
                          value={System_RecordsData.c_operator_id}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.c_operator_id}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='p_register_comp_add'>p_register_comp_add</Label>
                        <Input
                          id='p_register_comp_add'
                          name='p_register_comp_add'
                          value={System_RecordsData.p_register_comp_add}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.p_register_comp_add}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for='data_validation_check_yn'>data_validation_check_yn</Label>
                        <Input
                          id='data_validation_check_yn'
                          name='data_validation_check_yn'
                          value={System_RecordsData.data_validation_check_yn}
                          onChange={onChangeHandle}
                        />
                        {errorMessage.name && (
                          <FormText color='danger'>
                            {errorMessage.data_validation_check_yn}
                          </FormText>
                        )}
                      </FormGroup>

                      <FormGroup row>

                        <Label for="bill_type_method">Sale Bill Method</Label>
                        <Col >

                          <Input
                            id="bill_type_method"
                            name="bill_type_method"
                            value={System_RecordsData.bill_type_method}
                            onChange={onChangeHandle}
                            type="select" className="custom-select"
                          >
                            <option value="">Select</option>
                            <option value="single">Single Entry</option>
                            <option value="item">Item Selection</option>
                            <option value="challan">Challan Wise</option>


                          </Input>
                        </Col>
                      </FormGroup>



                      <FormGroup>
                        <Label for="otp_req_deletion_yn">Otp Deletion option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="otp_req_deletion_yn"
                          id="otp_req_deletion_yn"
                          value={System_RecordsData.otp_req_deletion_yn}
                          onChange={onChangeHandle}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="system_invoice">Invoice Formate</Label>
                        <Input
                          type="select" className="custom-select"
                          name="system_invoice"
                          id="system_invoice"
                          value={System_RecordsData.system_invoice}
                          onChange={onChangeHandle}
                        >
                          <option value="">Select Invoice Format</option>
                          <option value="invoice">Invoice Format 1</option>
                          <option value="invoice2">Invoice Format 2</option>
                          <option value="invoice3">Invoice Format 3</option>
                          <option value="invoice4">Invoice Format 4</option>
                          <option value="invoice5">Invoice Format 5</option>
                          <option value="invoice5_landscape">Invoice Format 5 Landscape</option>
                          <option value="invoice6">Invoice Format 6</option>
                          <option value="invoice7">Invoice Format 7</option>
                          <option value="invoice8_optical">Invoice Format 7 Optical</option>
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="company_about">Company About</Label>

                        <CkEditor
                          name="company_about"
                          onChange={(data) => {
                            setSystem_RecordsData((prevData) => ({
                              ...prevData,
                              company_about: data,
                            }));
                          }}
                          editorLoaded={editorLoaded}
                          value={System_RecordsData?.company_about}
                        />

                      </FormGroup>

                      <FormGroup>
                        <Label for="company_image">Company Image</Label>

                        {previewImage && (
                          <img
                            src={previewImage}
                            style={{
                              width: '100px',
                              height: '100px',
                              borderRadius: '50%',
                              marginBottom: '10px',
                              marginLeft: 10
                            }}
                            alt="Preview"
                          />
                        )}
                        <Input
                          type="file"
                          name="company_image"
                          id="company_image"
                          // value={System_RecordsData.company_image}
                          onChange={onChangeHandle}
                        />

                      </FormGroup>



                      <FormGroup>
                        <Label for="company_logo">Company Logo</Label>

                        {previewCompanyLogo && (
                          <img
                            src={previewCompanyLogo}
                            style={{
                              width: '100px',
                              height: '100px',
                              borderRadius: '50%',
                              marginBottom: '10px',
                              marginLeft: 10
                            }}
                            alt="Preview"
                          />
                        )}
                        <Input
                          type="file"
                          name="company_logo"
                          id="company_logo"
                          // value={System_RecordsData.company_image}
                          onChange={onChangeHandle}
                        />

                      </FormGroup>

                      <FormGroup>
                        <Label for="facebook_link">FaceBook Link</Label>
                        <Input
                          type="text"
                          name="facebook_link"
                          id="facebook_link"
                          value={System_RecordsData.facebook_link}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label for="twitter_link">Twitter Link</Label>
                        <Input
                          type="text"
                          name="twitter_link"
                          id="twitter_link"
                          value={System_RecordsData.twitter_link}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>


                      <FormGroup>
                        <Label for="youtube_link">Youtube Link</Label>
                        <Input
                          type="text"
                          name="youtube_link"
                          id="youtube_link"
                          value={System_RecordsData.youtube_link}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label for="linkedin_link">Linkedin Link</Label>
                        <Input
                          type="text"
                          name="linkedin_link"
                          id="linkedin_link"
                          value={System_RecordsData.linkedin_link}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>



                      <FormGroup>
                        <Label for="map_link">Site/Map Link</Label>
                        <Input
                          type="text"
                          name="map_link"
                          id="map_link"
                          value={System_RecordsData.map_link}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>


                      <FormGroup>
                        <Label for="private_policy">Private Policy</Label>

                        <CkEditor
                          name="private_policy"
                          onChange={(data) => {
                            setSystem_RecordsData((prevData) => ({
                              ...prevData,
                              private_policy: data,
                            }));
                          }}
                          editorLoaded={editorLoaded}
                          value={System_RecordsData?.private_policy}
                        />

                      </FormGroup>








                      {/* // add item  master keyword  */}






                      <FormGroup>
                        <Label for="batch_no">Batch/Serial No</Label>
                        <Input
                          type="select" className="custom-select"
                          name="batch_no"
                          id="batch_no"
                          value={System_RecordsData.batch_no}
                          onChange={onChangeHandle}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                      <FormGroup>
                        <Label for="style">Style</Label>
                        <Input
                          type="select" className="custom-select"
                          name="style"
                          id="style"
                          value={System_RecordsData.style}
                          onChange={onChangeHandle}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                      <FormGroup>
                        <Label for="brand">Multiple Brand Allow</Label>
                        <Input
                          type="select" className="custom-select"
                          name="brand"
                          id="brand"
                          value={System_RecordsData.brand}
                          onChange={onChangeHandle}
                        >

                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                          {/* <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))} */}
                        </Input>
                      </FormGroup>
                      <FormGroup>
                        <Label for="color">Color</Label>
                        <Input
                          type="select" className="custom-select"
                          name="color"
                          id="color"
                          value={System_RecordsData.color}
                          onChange={onChangeHandle}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                      <FormGroup>
                        <Label for="agent">Agent</Label>
                        <Input
                          type="select" className="custom-select"
                          name="agent"
                          id="agent"
                          value={System_RecordsData.agent}
                          onChange={onChangeHandle}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                      <FormGroup>
                        <Label for="dealer">Dealer</Label>
                        <Input
                          type="select" className="custom-select"
                          name="dealer"
                          id="dealer"
                          value={System_RecordsData.dealer}
                          onChange={onChangeHandle}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                      <h4>Party Group Code</h4>

                      <FormGroup>
                        <Label for="gst_yn">Gst Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_yn"
                          id="gst_yn"
                          value={System_RecordsData.gst_yn}
                          onChange={onChangeHandle}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="cash_group_code">Cash Group Code</Label>
                        <Input
                          type="text"
                          name="cash_group_code"
                          id="cash_group_code"
                          value={System_RecordsData.cash_group_code}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label for="bank_group_code">Bank Group Code</Label>
                        <Input
                          type="text"
                          name="bank_group_code"
                          id="bank_group_code"
                          value={System_RecordsData.bank_group_code}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>



                      <FormGroup>
                        <Label for="hotel_group_code">Hotel Group Code</Label>
                        <Input
                          type="text"
                          name="hotel_group_code"
                          id="hotel_group_code"
                          value={System_RecordsData.hotel_group_code}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>


                      <FormGroup>
                        <Label for="hotel_expense_comm_group_code">Hotel Expense Commission Group Code</Label>
                        <Input
                          type="text"
                          name="hotel_expense_comm_group_code"
                          id="hotel_expense_comm_group_code"
                          value={System_RecordsData.hotel_expense_comm_group_code}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>



                      <FormGroup>
                        <Label for="sale_group_code">Sale Party Code</Label>
                        <Input
                          type="text"
                          name="sale_group_code"
                          id="sale_group_code"
                          value={System_RecordsData.sale_group_code}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>













                      <FormGroup>
                        <Label for="user_profile_code">User Profile Code</Label>
                        <Input
                          type="number"
                          name="user_profile_code"
                          id="user_profile_code"
                          value={System_RecordsData.user_profile_code}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="hotel_direct_group_code">Hotel Direct Group Code</Label>
                        <Input
                          type="number"
                          name="hotel_direct_group_code"
                          id="hotel_direct_group_code"
                          value={System_RecordsData.hotel_direct_group_code}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="igst_group_code">IGST Party Code</Label>
                        <Input
                          type="number"
                          name="igst_group_code"
                          id="igst_group_code"
                          value={System_RecordsData.igst_group_code}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="cgst_group_code">CGST Party Code</Label>
                        <Input
                          type="number"
                          name="cgst_group_code"
                          id="cgst_group_code"
                          value={System_RecordsData.cgst_group_code}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="sgst_group_code">SGST Party Code</Label>
                        <Input
                          type="number"
                          name="sgst_group_code"
                          id="sgst_group_code"
                          value={System_RecordsData.sgst_group_code}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>


                      <FormGroup>
                        <Label for="commission_party_code">Commission Party Code</Label>
                        <Input
                          type="number"
                          name="commission_party_code"
                          id="commission_party_code"
                          value={System_RecordsData.commission_party_code}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>


                      <FormGroup>
                        <Label for="extra_service_party_code">Extra Service Party Code</Label>
                        <Input
                          type="number"
                          name="extra_service_party_code"
                          id="extra_service_party_code"
                          value={System_RecordsData.extra_service_party_code}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>



                      <FormGroup>
                        <Label for="commission_dist_party_code">Commission Distibuted Party Code</Label>
                        <Input
                          type="number"
                          name="commission_dist_party_code"
                          id="commission_dist_party_code"
                          value={System_RecordsData.commission_dist_party_code}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>



                      <FormGroup>
                        <Label for="customer_party_code">Customer Party Code</Label>
                        <Input
                          type="number"
                          name="customer_party_code"
                          id="customer_party_code"
                          value={System_RecordsData.customer_party_code}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>

                    </div>
                  </div>
                </div>
              </div>

              {/* <Button
                className='mt-2'
                color='primary'
                onClick={System_Records_Add_Edit_Screen}
              >
                Save
              </Button> */}
            </Form>
          </CardBody>}


          {flagMaster === "system" && (
            <CardBody>
              <Form>
                <div id="accordionExample1">
                  <div className="card">
                    <div className="card-header p-2" id="headingItemDetail">
                      <h2 className="mb-0">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseItemDetail"
                          aria-expanded="false"
                          aria-controls="collapseItemDetail"
                        >
                          <i className="bi bi-list-ul mr-2"></i>
                          System Detail
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapseItemDetail"
                      className="collapse"
                      aria-labelledby="headingItemDetail"
                      data-parent="#accordionExample1"
                    >
                      <div className="card-body">
                        <FormGroup>
                          <Label for='home_state'>home_state</Label>
                          <Input
                            id='home_state'
                            name='home_state'
                            value={System_RecordsData.home_state}
                            onChange={onChangeHandle}
                            type="select" className="custom-select"
                          >
                            <option value="">Select</option>
                            {stateTable.map((option) => (
                              <option key={option.state_Id} value={option.state_Name}>
                                {option.state_Name}
                              </option>
                            ))}
                          </Input>
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.home_state}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='home_state_code'>home_state_code</Label>
                          <Input
                            id='home_state_code'
                            name='home_state_code'
                            value={System_RecordsData.home_state_code}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.home_state_code}
                            </FormText>
                          )}
                        </FormGroup>

                        <FormGroup>
                          <Label for='default_tax_name'>default_tax_name</Label>
                          <Input
                            id='default_tax_name'
                            name='default_tax_name'
                            value={System_RecordsData.default_tax_name}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.default_tax_name}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='default_tax_per'>default_tax_per</Label>
                          <Input
                            id='default_tax_per'
                            name='default_tax_per'
                            value={System_RecordsData.default_tax_per}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.default_tax_per}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='default_unit'>default_unit</Label>
                          <Input
                            id='default_unit'
                            name='default_unit'
                            value={System_RecordsData.default_unit}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.default_unit}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='default_hsn_code'>default_hsn_code</Label>
                          <Input
                            id='default_hsn_code'
                            name='default_hsn_code'
                            value={System_RecordsData.default_hsn_code}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.default_hsn_code}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='default_company_no'>default_company_no</Label>
                          <Input
                            id='default_company_no'
                            name='default_company_no'
                            value={System_RecordsData.default_company_no}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.default_company_no}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='company_name'>company_name</Label>
                          <Input
                            id='company_name'
                            name='company_name'
                            value={System_RecordsData.company_name}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.company_name}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='company_address'>company_address</Label>
                          <Input
                            id='company_address'
                            name='company_address'
                            value={System_RecordsData.company_address}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.company_address}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='company_address_1'>company_address_1</Label>
                          <Input
                            id='company_address_1'
                            name='company_address_1'
                            value={System_RecordsData.company_address_1}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.company_address_1}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='company_phone'>company_phone</Label>
                          <Input
                            id='company_phone'
                            name='company_phone'
                            value={System_RecordsData.company_phone}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.company_phone}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='sale_retrun_code'>sale_retrun_code</Label>
                          <Input
                            type='number'
                            id='sale_retrun_code'
                            name='sale_retrun_code'
                            value={System_RecordsData.sale_retrun_code}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.sale_retrun_code}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='sale_return_name_default'>sale_return_name_default</Label>
                          <Input
                            id='sale_return_name_default'
                            name='sale_return_name_default'
                            value={System_RecordsData.sale_return_name_default}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.sale_return_name_default}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='sale_code'>sale_code</Label>
                          <Input
                            type="number"
                            id='sale_code'
                            name='sale_code'
                            value={System_RecordsData.sale_code}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.sale_code}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='sale_name_default'>sale_name_default</Label>
                          <Input
                            id='sale_name_default'
                            name='sale_name_default'
                            value={System_RecordsData.sale_name_default}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.sale_name_default}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='bank_code'>bank_code</Label>
                          <Input
                            type='number'
                            id='bank_code'
                            name='bank_code'
                            value={System_RecordsData.bank_code}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.bank_code}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='bank_name_default'>bank_name_default</Label>
                          <Input
                            id='bank_name_default'
                            name='bank_name_default'
                            value={System_RecordsData.bank_name_default}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.bank_name_default}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='cash_name_default'>cash_name_default</Label>
                          <Input
                            id='cash_name_default'
                            name='cash_name_default'
                            value={System_RecordsData.cash_name_default}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.cash_name_default}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='cash_code'>cash_code</Label>
                          <Input
                            type='number'
                            id='cash_code'
                            name='cash_code'
                            value={System_RecordsData.cash_code}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.cash_code}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='year_from'>year_from</Label>
                          <Input
                            type='date'
                            id='year_from'
                            name='year_from'
                            value={System_RecordsData.year_from}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.year_from}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='year_to'>year_to</Label>
                          <Input
                            type='date'
                            id='year_to'
                            name='year_to'
                            value={System_RecordsData.year_to}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.year_to}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='display_height'>display_height</Label>
                          <Input
                            id='display_height'
                            name='display_height'
                            value={System_RecordsData.display_height}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.display_height}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='saledatabaselock'>saledatabaselock</Label>
                          <Input
                            id='saledatabaselock'
                            name='saledatabaselock'
                            value={System_RecordsData.saledatabaselock}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.saledatabaselock}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='database_1_path'>database_1_path</Label>
                          <Input
                            id='database_1_path'
                            name='database_1_path'
                            value={System_RecordsData.database_1_path}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.database_1_path}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='database_2_path'>database_2_path</Label>
                          <Input
                            id='database_2_path'
                            name='database_2_path'
                            value={System_RecordsData.database_2_path}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.database_2_path}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='auto_raw_yes_no'>auto_raw_yes_no</Label>
                          <Input
                            id='auto_raw_yes_no'
                            name='auto_raw_yes_no'
                            value={System_RecordsData.auto_raw_yes_no}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.auto_raw_yes_no}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='weekly_off_day'>weekly_off_day</Label>
                          <Input
                            id='weekly_off_day'
                            name='weekly_off_day'
                            value={System_RecordsData.weekly_off_day}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.weekly_off_day}
                            </FormText>
                          )}
                        </FormGroup>


                        <FormGroup>
                          <Label for='sale_format'>sale_format</Label>
                          <Input
                            id='sale_format'
                            name='sale_format'
                            value={System_RecordsData.sale_format}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.sale_format}
                            </FormText>
                          )}
                        </FormGroup>

                        <FormGroup>
                          <Label for='email_sender'>email_sender</Label>
                          <Input
                            id='email_sender'
                            name='email_sender'
                            value={System_RecordsData.email_sender}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.email_sender}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='email_receiver'>email_receiver</Label>
                          <Input
                            id='email_receiver'
                            name='email_receiver'
                            value={System_RecordsData.email_receiver}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.email_receiver}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='ch_bill_header_name'>ch_bill_header_name</Label>
                          <Input
                            id='ch_bill_header_name'
                            name='ch_bill_header_name'
                            value={System_RecordsData.ch_bill_header_name}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.ch_bill_header_name}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='ss_bill_header_name'>ss_bill_header_name</Label>
                          <Input
                            id='ss_bill_header_name'
                            name='ss_bill_header_name'
                            value={System_RecordsData.ss_bill_header_name}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.ss_bill_header_name}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='sr_bill_header_name'>sr_bill_header_name</Label>
                          <Input
                            id='sr_bill_header_name'
                            name='sr_bill_header_name'
                            value={System_RecordsData.sr_bill_header_name}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.sr_bill_header_name}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='pp_bill_header_name'>pp_bill_header_name</Label>
                          <Input
                            id='pp_bill_header_name'
                            name='pp_bill_header_name'
                            value={System_RecordsData.pp_bill_header_name}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.pp_bill_header_name}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='pr_bill_header_name'>pr_bill_header_name</Label>
                          <Input
                            id='pr_bill_header_name'
                            name='pr_bill_header_name'
                            value={System_RecordsData.pr_bill_header_name}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.pr_bill_header_name}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='po_bill_header_name'>po_bill_header_name</Label>
                          <Input
                            id='po_bill_header_name'
                            name='po_bill_header_name'
                            value={System_RecordsData.po_bill_header_name}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.po_bill_header_name}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='so_bill_header_name'>so_bill_header_name</Label>
                          <Input
                            id='so_bill_header_name'
                            name='so_bill_header_name'
                            value={System_RecordsData.so_bill_header_name}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.so_bill_header_name}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='rc_bill_header_name'>rc_bill_header_name</Label>
                          <Input
                            id='rc_bill_header_name'
                            name='rc_bill_header_name'
                            value={System_RecordsData.rc_bill_header_name}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.rc_bill_header_name}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='qu_bill_header_name'>qu_bill_header_name</Label>
                          <Input
                            id='qu_bill_header_name'
                            name='qu_bill_header_name'
                            value={System_RecordsData.qu_bill_header_name}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.qu_bill_header_name}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='rounded_off'>rounded_off</Label>
                          <Input
                            id='rounded_off'
                            name='rounded_off'
                            value={System_RecordsData.rounded_off}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.rounded_off}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='c_rta_id'>c_rta_id</Label>
                          <Input
                            id='c_rta_id'
                            name='c_rta_id'
                            value={System_RecordsData.c_rta_id}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.c_rta_id}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='c_operator_id'>c_operator_id</Label>
                          <Input
                            id='c_operator_id'
                            name='c_operator_id'
                            value={System_RecordsData.c_operator_id}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.c_operator_id}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='p_register_comp_add'>p_register_comp_add</Label>
                          <Input
                            id='p_register_comp_add'
                            name='p_register_comp_add'
                            value={System_RecordsData.p_register_comp_add}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.p_register_comp_add}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for='data_validation_check_yn'>data_validation_check_yn</Label>
                          <Input
                            id='data_validation_check_yn'
                            name='data_validation_check_yn'
                            value={System_RecordsData.data_validation_check_yn}
                            onChange={onChangeHandle}
                          />
                          {errorMessage.name && (
                            <FormText color='danger'>
                              {errorMessage.data_validation_check_yn}
                            </FormText>
                          )}
                        </FormGroup>

                        <FormGroup row>

                          <Label for="bill_type_method">Sale Bill Method</Label>
                          <Col >

                            <Input
                              id="bill_type_method"
                              name="bill_type_method"
                              value={System_RecordsData.bill_type_method}
                              onChange={onChangeHandle}
                              type="select" className="custom-select"
                            >
                              <option value="">Select</option>
                              <option value="single">Single Entry</option>
                              <option value="item">Item Selection</option>
                              <option value="challan">Challan Wise</option>


                            </Input>
                          </Col>
                        </FormGroup>



                        <FormGroup>
                          <Label for="otp_req_deletion_yn">Otp Deletion option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="otp_req_deletion_yn"
                            id="otp_req_deletion_yn"
                            value={System_RecordsData.otp_req_deletion_yn}
                            onChange={onChangeHandle}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="system_invoice">Invoice Formate</Label>
                          <Input
                            type="select" className="custom-select"
                            name="system_invoice"
                            id="system_invoice"
                            value={System_RecordsData.system_invoice}
                            onChange={onChangeHandle}
                          >
                            <option value="">Select Invoice Format</option>
                            <option value="invoice">Invoice Format 1</option>
                            <option value="invoice2">Invoice Format 2</option>
                            <option value="invoice3">Invoice Format 3</option>
                            <option value="invoice4">Invoice Format 4</option>
                            <option value="invoice5">Invoice Format 5</option>
                            <option value="invoice5_landscape">Invoice Format 5 Landscape</option>
                            <option value="invoice6">Invoice Format 6</option>
                            <option value="invoice7">Invoice Format 7</option>
                            <option value="invoice8_optical">Invoice Format 7 Optical</option>
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="company_about">Company About</Label>

                          <CkEditor
                            name="company_about"
                            onChange={(data) => {
                              setSystem_RecordsData((prevData) => ({
                                ...prevData,
                                company_about: data,
                              }));
                            }}
                            editorLoaded={editorLoaded}
                            value={System_RecordsData?.company_about}
                          />

                        </FormGroup>

                        <FormGroup>
                          <Label for="company_image">Company Image</Label>

                          {previewImage && (
                            <img
                              src={previewImage}
                              style={{
                                width: '100px',
                                height: '100px',
                                borderRadius: '50%',
                                marginBottom: '10px',
                                marginLeft: 10
                              }}
                              alt="Preview"
                            />
                          )}
                          <Input
                            type="file"
                            name="company_image"
                            id="company_image"
                            // value={System_RecordsData.company_image}
                            onChange={onChangeHandle}
                          />

                        </FormGroup>



                        <FormGroup>
                          <Label for="company_logo">Company Logo</Label>

                          {previewCompanyLogo && (
                            <img
                              src={previewCompanyLogo}
                              style={{
                                width: '100px',
                                height: '100px',
                                borderRadius: '50%',
                                marginBottom: '10px',
                                marginLeft: 10
                              }}
                              alt="Preview"
                            />
                          )}
                          <Input
                            type="file"
                            name="company_logo"
                            id="company_logo"
                            // value={System_RecordsData.company_image}
                            onChange={onChangeHandle}
                          />

                        </FormGroup>

                        <FormGroup>
                          <Label for="facebook_link">FaceBook Link</Label>
                          <Input
                            type="text"
                            name="facebook_link"
                            id="facebook_link"
                            value={System_RecordsData.facebook_link}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>

                        <FormGroup>
                          <Label for="twitter_link">Twitter Link</Label>
                          <Input
                            type="text"
                            name="twitter_link"
                            id="twitter_link"
                            value={System_RecordsData.twitter_link}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>


                        <FormGroup>
                          <Label for="youtube_link">Youtube Link</Label>
                          <Input
                            type="text"
                            name="youtube_link"
                            id="youtube_link"
                            value={System_RecordsData.youtube_link}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>

                        <FormGroup>
                          <Label for="linkedin_link">Linkedin Link</Label>
                          <Input
                            type="text"
                            name="linkedin_link"
                            id="linkedin_link"
                            value={System_RecordsData.linkedin_link}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>



                        <FormGroup>
                          <Label for="map_link">Site/Map Link</Label>
                          <Input
                            type="text"
                            name="map_link"
                            id="map_link"
                            value={System_RecordsData.map_link}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>


                        <FormGroup>
                          <Label for="private_policy">Private Policy</Label>

                          <CkEditor
                            name="private_policy"
                            onChange={(data) => {
                              setSystem_RecordsData((prevData) => ({
                                ...prevData,
                                private_policy: data,
                              }));
                            }}
                            editorLoaded={editorLoaded}
                            value={System_RecordsData?.private_policy}
                          />

                        </FormGroup>








                        {/* // add item  master keyword  */}






                        <FormGroup>
                          <Label for="batch_no">Batch/Serial No</Label>
                          <Input
                            type="select" className="custom-select"
                            name="batch_no"
                            id="batch_no"
                            value={System_RecordsData.batch_no}
                            onChange={onChangeHandle}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="style">Style</Label>
                          <Input
                            type="select" className="custom-select"
                            name="style"
                            id="style"
                            value={System_RecordsData.style}
                            onChange={onChangeHandle}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="brand">Multiple Brand Allow</Label>
                          <Input
                            type="select" className="custom-select"
                            name="brand"
                            id="brand"
                            value={System_RecordsData.brand}
                            onChange={onChangeHandle}
                          >

                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                            {/* <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))} */}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="color">Color</Label>
                          <Input
                            type="select" className="custom-select"
                            name="color"
                            id="color"
                            value={System_RecordsData.color}
                            onChange={onChangeHandle}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="agent">Agent</Label>
                          <Input
                            type="select" className="custom-select"
                            name="agent"
                            id="agent"
                            value={System_RecordsData.agent}
                            onChange={onChangeHandle}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="dealer">Dealer</Label>
                          <Input
                            type="select" className="custom-select"
                            name="dealer"
                            id="dealer"
                            value={System_RecordsData.dealer}
                            onChange={onChangeHandle}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <h4>Party Group Code</h4>

                        <FormGroup>
                          <Label for="gst_yn">Gst Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_yn"
                            id="gst_yn"
                            value={System_RecordsData.gst_yn}
                            onChange={onChangeHandle}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="cash_group_code">Cash Group Code</Label>
                          <Input
                            type="text"
                            name="cash_group_code"
                            id="cash_group_code"
                            value={System_RecordsData.cash_group_code}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>

                        <FormGroup>
                          <Label for="bank_group_code">Bank Group Code</Label>
                          <Input
                            type="text"
                            name="bank_group_code"
                            id="bank_group_code"
                            value={System_RecordsData.bank_group_code}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>



                        <FormGroup>
                          <Label for="hotel_group_code">Hotel Group Code</Label>
                          <Input
                            type="text"
                            name="hotel_group_code"
                            id="hotel_group_code"
                            value={System_RecordsData.hotel_group_code}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>


                        <FormGroup>
                          <Label for="hotel_expense_comm_group_code">Hotel Expense Commission Group Code</Label>
                          <Input
                            type="text"
                            name="hotel_expense_comm_group_code"
                            id="hotel_expense_comm_group_code"
                            value={System_RecordsData.hotel_expense_comm_group_code}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>



                        <FormGroup>
                          <Label for="sale_group_code">Sale Party Code</Label>
                          <Input
                            type="text"
                            name="sale_group_code"
                            id="sale_group_code"
                            value={System_RecordsData.sale_group_code}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>













                        <FormGroup>
                          <Label for="user_profile_code">User Profile Code</Label>
                          <Input
                            type="number"
                            name="user_profile_code"
                            id="user_profile_code"
                            value={System_RecordsData.user_profile_code}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label for="hotel_direct_group_code">Hotel Direct Group Code</Label>
                          <Input
                            type="number"
                            name="hotel_direct_group_code"
                            id="hotel_direct_group_code"
                            value={System_RecordsData.hotel_direct_group_code}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label for="igst_group_code">IGST Party Code</Label>
                          <Input
                            type="number"
                            name="igst_group_code"
                            id="igst_group_code"
                            value={System_RecordsData.igst_group_code}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label for="cgst_group_code">CGST Party Code</Label>
                          <Input
                            type="number"
                            name="cgst_group_code"
                            id="cgst_group_code"
                            value={System_RecordsData.cgst_group_code}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label for="sgst_group_code">SGST Party Code</Label>
                          <Input
                            type="number"
                            name="sgst_group_code"
                            id="sgst_group_code"
                            value={System_RecordsData.sgst_group_code}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>


                        <FormGroup>
                          <Label for="commission_party_code">Commission Party Code</Label>
                          <Input
                            type="number"
                            name="commission_party_code"
                            id="commission_party_code"
                            value={System_RecordsData.commission_party_code}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>


                        <FormGroup>
                          <Label for="extra_service_party_code">Extra Service Party Code</Label>
                          <Input
                            type="number"
                            name="extra_service_party_code"
                            id="extra_service_party_code"
                            value={System_RecordsData.extra_service_party_code}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>



                        <FormGroup>
                          <Label for="commission_dist_party_code">Commission Distibuted Party Code</Label>
                          <Input
                            type="number"
                            name="commission_dist_party_code"
                            id="commission_dist_party_code"
                            value={System_RecordsData.commission_dist_party_code}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>



                        <FormGroup>
                          <Label for="customer_party_code">Customer Party Code</Label>
                          <Input
                            type="number"
                            name="customer_party_code"
                            id="customer_party_code"
                            value={System_RecordsData.customer_party_code}
                            onChange={onChangeHandle}
                          />
                        </FormGroup>

                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </CardBody>
          )}




          {/* General Challan */}
          {
            slugUiFlag == "challan_old" && <CardBody>
              <Form>
                <div
                  className='accordion accordion-flush'
                  id='accordionFlushExample1'
                >
                  <div className='accordion-item'>
                    <h2 className='accordion-header' id='flush-headingSix1'>
                      <button
                        className='accordion-button collapsed'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#flush-collapseSix1'
                        aria-expanded='false'
                        aria-controls='flush-collapseSix1'
                      >
                        {title}
                      </button>
                    </h2>
                    <div
                      id='flush-collapseSix1'
                      className='accordion-collapse collapse'
                      aria-labelledby='flush-headingSix1'
                      data-bs-parent='#accordionFlushExample1'
                    >
                      <div className='accordion-body'>
                        <FormGroup>

                          <FormGroup row>
                            <Label for="challan_master_method">Challan Master Show Method</Label>
                            <Col >

                              <Input
                                id="challan_master_method"
                                name="challan_master_method"
                                value={genChallanKey.challan_master_method}
                                onChange={onChangeIssueSaleHandle(slugUiFlag)}

                                type="select" className="custom-select"
                              >
                                <option value="">Select</option>
                                <option value="single">Single Entry</option>
                                <option value="aggrement">Aggrement Entry</option>
                                <option value="both">Both</option>


                              </Input>
                            </Col>
                          </FormGroup>

                          <FormGroup>
                            <Col>
                              <Label for="cart_tcs_yn">TCS Value</Label>
                              <Input type="number" name="cart_tcs_value"
                                id="cart_tcs_value"
                                value={typeof genChallanKey.cart_tcs_value === 'number' ? genChallanKey.cart_tcs_value.toFixed(3) : genChallanKey.cart_tcs_value}
                                onChange={onChangeIssueSaleHandle(slugUiFlag)}

                              />
                            </Col>
                          </FormGroup>

                          <FormGroup>
                            <Label for="sale_method_option">Sale Method</Label>
                            <Input
                              type="select" className="custom-select"
                              name="sale_method_option"
                              id="sale_method_option"
                              value={genChallanKey.sale_method_option}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSaleMethodTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <FormGroup>
                            <Label for="current_stock_yn">Current Stock option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="current_stock_yn"
                              id="current_stock_yn"
                              value={genChallanKey.current_stock_yn}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>




                          <FormGroup>
                            <Label for="batch_no">Batch/Serial No</Label>
                            <Input
                              type="select" className="custom-select"
                              name="batch_no"
                              id="batch_no"
                              value={genChallanKey.batch_no}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="style">Style</Label>
                            <Input
                              type="select" className="custom-select"
                              name="style"
                              id="style"
                              value={genChallanKey.style}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="brand">Multiple Brand Allow</Label>
                            <Input
                              type="select" className="custom-select"
                              name="brand"
                              id="brand"
                              value={genChallanKey.brand}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}
                            >

                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                              {/* <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))} */}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="color">Color</Label>
                            <Input
                              type="select" className="custom-select"
                              name="color"
                              id="color"
                              value={genChallanKey.color}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="agent">Agent</Label>
                            <Input
                              type="select" className="custom-select"
                              name="agent"
                              id="agent"
                              value={genChallanKey.agent}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="dealer">Dealer</Label>
                            <Input
                              type="select" className="custom-select"
                              name="dealer"
                              id="dealer"
                              value={genChallanKey.dealer}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>


                          <FormGroup>
                            <Label for="round_off">Round_off</Label>
                            <Input
                              type="select" className="custom-select"
                              name="round_off"
                              id="round_off"
                              value={genChallanKey.round_off}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <FormGroup>
                            <Label for="maintain_accounting_yn">Maintain Accounting Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="maintain_accounting_yn"
                              id="maintain_accounting_yn"
                              value={genChallanKey.maintain_accounting_yn}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <FormGroup>
                            <Label for="transporter_cartage_yn">Transporter cartage in Bill Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="transporter_cartage_yn"
                              id="transporter_cartage_yn"
                              value={genChallanKey.transporter_cartage_yn}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <Label for="purchase_rate_yn">Purchase Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="purchase_rate_yn"
                            id="purchase_rate_yn"
                            value={genChallanKey.purchase_rate_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="profit_yn">Profit Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="profit_yn"
                            id="profit_yn"
                            value={genChallanKey.profit_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="discount_amount_yn">Discount Amount Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_amount_yn"
                            id="discount_amount_yn"
                            value={genChallanKey.discount_amount_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="discount_rate_yn">Discount Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_rate_yn"
                            id="discount_rate_yn"
                            value={genChallanKey.discount_rate_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="gst_amount_yn">Gst Amount Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_amount_yn"
                            id="gst_amount_yn"
                            value={genChallanKey.gst_amount_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="gst_rate_yn">Gst Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_rate_yn"
                            id="gst_rate_yn"
                            value={genChallanKey.gst_rate_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_profit_yn">Total Profit Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_profit_yn"
                            id="total_profit_yn"
                            value={genChallanKey.total_profit_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_weight_yn">Total Weight Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_weight_yn"
                            id="total_weight_yn"
                            value={genChallanKey.total_weight_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>




                        {/* ///////////// new code add  */}
                        <FormGroup>
                          <Label for="hsn_code_yn">HSN Code Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="hsn_code_yn"
                            id="hsn_code_yn"
                            value={genChallanKey.hsn_code_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="packing_type_yn">Packing Type Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="packing_type_yn"
                            id="packing_type_yn"
                            value={genChallanKey.packing_type_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="scheme_type_yn">Scheme Type Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="scheme_type_yn"
                            id="scheme_type_yn"
                            value={genChallanKey.scheme_type_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="remarks_yn">Remark Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="remarks_yn"
                            id="remarks_yn"
                            value={genChallanKey.remarks_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="sale_rate_yn">Sale Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="sale_rate_yn"
                            id="sale_rate_yn"
                            value={genChallanKey.sale_rate_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          {/* //sale_qty_yn */}
                          <Label for="issue_qty_yn"> Issue Qty Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="issue_qty_yn"
                            id="issue_qty_yn"
                            value={genChallanKey.issue_qty_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>




                        <FormGroup>
                          <Label for="recv_qty_yn">Receive Qty Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="recv_qty_yn"
                            id="recv_qty_yn"
                            value={genChallanKey.recv_qty_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="discount_percentage_yn">Discount Percentage Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_percentage_yn"
                            id="discount_percentage_yn"
                            value={genChallanKey.discount_percentage_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="grand_total_yn">Grand Total Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="grand_total_yn"
                            id="grand_total_yn"
                            value={genChallanKey.grand_total_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_percentage_yn"
                            id="gst_percentage_yn"
                            value={genChallanKey.gst_percentage_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <FormGroup>
                          <Label for="rate_after_gst_yn">Rate After gst option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="rate_after_gst_yn"
                            id="rate_after_gst_yn"
                            value={genChallanKey.rate_after_gst_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_amount_yn">Total Amount option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_amount_yn"
                            id="total_amount_yn"
                            value={genChallanKey.total_amount_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_profit_yn">Total Profit option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_profit_yn"
                            id="total_profit_yn"
                            value={genChallanKey.total_profit_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <FormGroup>
                          <Label for="balance_qty_yn">Balance Qty option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="balance_qty_yn"
                            id="balance_qty_yn"
                            value={genChallanKey.balance_qty_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <FormGroup>
                          <Label for="warranty_period">Warranty Period</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_period"
                            id="warranty_period"
                            value={genChallanKey.warranty_period}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_mode">Warranty Mode</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_mode"
                            id="warranty_mode"
                            value={genChallanKey.warranty_mode}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="service_visit_count">Service Visit Count</Label>
                          <Input

                            type="select" className="custom-select"
                            name="service_visit_count"
                            id="service_visit_count"
                            value={genChallanKey.service_visit_count}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_expiry_date">Warranty Expiry Date</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_expiry_date"
                            id="warranty_expiry_date"
                            value={genChallanKey.warranty_expiry_date}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_button">Warranty Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_button"
                            id="warranty_button"
                            value={genChallanKey.warranty_button}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="extra_detail_button">Extra Detail Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="extra_detail_button"
                            id="extra_detail_button"
                            value={genChallanKey.extra_detail_button}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>






                        <FormGroup>
                          <Label for="chl_acc_bill_acc_fixed_open_yn">chl acc bill acc fixed open yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_fixed_open_yn"
                            id="chl_acc_bill_acc_fixed_open_yn"
                            value={genChallanKey.chl_acc_bill_acc_fixed_open_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_acc_last_record_yn">chl acc bill acc last record yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_last_record_yn"
                            id="chl_acc_bill_acc_last_record_yn"
                            value={genChallanKey.chl_acc_bill_acc_last_record_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>




                        <FormGroup>
                          <Label for="ch_man_amt_yn">ch man amt yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_man_amt_yn"
                            id="ch_man_amt_yn"
                            value={genChallanKey.ch_man_amt_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_man_qty_yn">ch man qty yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_man_qty_yn"
                            id="ch_man_qty_yn"
                            value={genChallanKey.ch_man_qty_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_man_item_ct_yn">ch man item ct yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_man_item_ct_yn"
                            id="ch_man_item_ct_yn"
                            value={genChallanKey.ch_man_item_ct_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_bill_mat_yn">ch bill mat yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_bill_mat_yn"
                            id="ch_bill_mat_yn"
                            value={genChallanKey.ch_bill_mat_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_sig_item_qty_man_yn">ch sig item qty man yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_sig_item_qty_man_yn"
                            id="ch_sig_item_qty_man_yn"
                            value={genChallanKey.ch_sig_item_qty_man_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_sig_item_rate_man_yn">ch sig item rate man yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_sig_item_rate_man_yn"
                            id="ch_sig_item_rate_man_yn"
                            value={genChallanKey.ch_sig_item_rate_man_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_status_yn">ch status yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_status_yn"
                            id="ch_status_yn"
                            value={genChallanKey.ch_status_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>






                        <FormGroup>
                          <Label for="bill_delivery_to_yn">bill_delivery_to_yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="bill_delivery_to_yn"
                            id="bill_delivery_to_yn"
                            value={genChallanKey.bill_delivery_to_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="bill_receive_by_yn">bill_receive_by_yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="bill_receive_by_yn"
                            id="bill_receive_by_yn"
                            value={genChallanKey.bill_receive_by_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <h5>Issue Recipted Billing Account Detail</h5>

                        <FormGroup>
                          <Label for="maintain_ledger_ac_post">Maintain Ledger A/c Post</Label>
                          <Input

                            type="select" className="custom-select"
                            name="maintain_ledger_ac_post"
                            id="maintain_ledger_ac_post"
                            value={genChallanKey.maintain_ledger_ac_post}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_bill_val_yn">ch bill val yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_bill_val_yn"
                            id="ch_bill_val_yn"
                            value={genChallanKey.ch_bill_val_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_tot_qty_yn">ch tot qty yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_tot_qty_yn"
                            id="ch_tot_qty_yn"
                            value={genChallanKey.ch_tot_qty_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_aprox_qt_wgt_yn">ch aprox qt wgt yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_aprox_qt_wgt_yn"
                            id="ch_aprox_qt_wgt_yn"
                            value={genChallanKey.ch_aprox_qt_wgt_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_trip_yn">ch trip yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_trip_yn"
                            id="ch_trip_yn"
                            value={genChallanKey.ch_trip_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_cartg_amt_yn">ch cartg amt yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_cartg_amt_yn"
                            id="ch_cartg_amt_yn"
                            value={genChallanKey.ch_cartg_amt_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="mis_exp_tot_yn">mis exp tot yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="mis_exp_tot_yn"
                            id="mis_exp_tot_yn"
                            value={genChallanKey.mis_exp_tot_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_gross_amt_yn">ch gross amt yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_gross_amt_yn"
                            id="ch_gross_amt_yn"
                            value={genChallanKey.ch_gross_amt_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_gst_per_yn">ch gst per yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_gst_per_yn"
                            id="ch_gst_per_yn"
                            value={genChallanKey.ch_gst_per_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_gst_amt_yn">ch gst amt yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_gst_amt_yn"
                            id="ch_gst_amt_yn"
                            value={genChallanKey.ch_gst_amt_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_gst_type_yn">ch gst type yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_gst_type_yn"
                            id="ch_gst_type_yn"
                            value={genChallanKey.ch_gst_type_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_grnd_amt_yn">ch grnd amt yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_grnd_amt_yn"
                            id="ch_grnd_amt_yn"
                            value={genChallanKey.ch_grnd_amt_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_tcs_op_yn">ch tcs op yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_tcs_op_yn"
                            id="ch_tcs_op_yn"
                            value={genChallanKey.ch_tcs_op_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_tcs_per_yn">ch tcs per yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_tcs_per_yn"
                            id="ch_tcs_per_yn"
                            value={genChallanKey.ch_tcs_per_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_tcs_val_yn">ch tcs val yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_tcs_val_yn"
                            id="ch_tcs_val_yn"
                            value={genChallanKey.ch_tcs_val_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_grad_amt_w_tcs_yn">ch grad amt w tcs yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_grad_amt_w_tcs_yn"
                            id="ch_grad_amt_w_tcs_yn"
                            value={genChallanKey.ch_grad_amt_w_tcs_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_fin_amt_yn">ch fin amt yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_fin_amt_yn"
                            id="ch_fin_amt_yn"
                            value={genChallanKey.ch_fin_amt_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <h5>Aggrement Detail</h5>
                        <FormGroup>
                          <Label for="brokage_button">Brokage Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="brokage_button"
                            id="brokage_button"
                            value={genChallanKey.brokage_button}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="mixed_button">Mixed Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="mixed_button"
                            id="mixed_button"
                            value={genChallanKey.mixed_button}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="issuied_qty">Issuied Qty</Label>
                          <Input

                            type="select" className="custom-select"
                            name="issuied_qty"
                            id="issuied_qty"
                            value={genChallanKey.issuied_qty}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        {/* Accordion keyword */}
                        <h4>Accordion Option</h4>
                        <FormGroup>
                          <Label for="chl_acc_addr_yn">Chl Acc Addr Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_addr_yn"
                            id="chl_acc_addr_yn"
                            value={genChallanKey.chl_acc_addr_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_ext_yn">Chl Acc Bill Ext Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_ext_yn"
                            id="chl_acc_bill_ext_yn"
                            value={genChallanKey.chl_acc_bill_ext_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_trans_yn">Chl Acc Trans Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_trans_yn"
                            id="chl_acc_trans_yn"
                            value={genChallanKey.chl_acc_trans_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_misc_yn">Chl Acc Misc Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_misc_yn"
                            id="chl_acc_misc_yn"
                            value={genChallanKey.chl_acc_misc_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_acc_yn">Chl Acc Bill Acc Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_yn"
                            id="chl_acc_bill_acc_yn"
                            value={genChallanKey.chl_acc_bill_acc_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_extra_doc_acc_yn">chl acc extra doc acc yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_extra_doc_acc_yn"
                            id="chl_acc_extra_doc_acc_yn"
                            value={genChallanKey.chl_acc_extra_doc_acc_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>










                      </div>
                    </div>
                  </div>
                </div>


              </Form>
            </CardBody>
          }

          {slugUiFlag === "challan" && (
            <CardBody>
              <Form>
                <div id="accordionExample1">
                  <div className="card">
                    <div className="card-header p-2" id="headingItemDetail">
                      <h2 className="mb-0">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseItemDetail"
                          aria-expanded="false"
                          aria-controls="collapseItemDetail"
                        >
                          <i className="bi bi-list-ul mr-2"></i>
                          {title}
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapseItemDetail"
                      className="collapse"
                      aria-labelledby="headingItemDetail"
                      data-parent="#accordionExample1"
                    >
                      <div className="card-body">
                        <FormGroup>

                          <FormGroup >
                            <Label for="challan_master_method">Challan Master Show Method</Label>
                            <Col >

                              <Input
                                id="challan_master_method"
                                name="challan_master_method"
                                value={genChallanKey.challan_master_method}
                                onChange={onChangeIssueSaleHandle(slugUiFlag)}

                                type="select" className="custom-select"
                              >
                                <option value="">Select</option>
                                <option value="single">Single Entry</option>
                                <option value="aggrement">Aggrement Entry</option>
                                <option value="both">Both</option>


                              </Input>
                            </Col>
                          </FormGroup>

                          <FormGroup>
                            <Col>
                              <Label for="cart_tcs_yn">TCS Value</Label>
                              <Input type="number" name="cart_tcs_value"
                                id="cart_tcs_value"
                                value={typeof genChallanKey.cart_tcs_value === 'number' ? genChallanKey.cart_tcs_value.toFixed(3) : genChallanKey.cart_tcs_value}
                                onChange={onChangeIssueSaleHandle(slugUiFlag)}

                              />
                            </Col>
                          </FormGroup>

                          <FormGroup>
                            <Label for="sale_method_option">Sale Method</Label>
                            <Input
                              type="select" className="custom-select"
                              name="sale_method_option"
                              id="sale_method_option"
                              value={genChallanKey.sale_method_option}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSaleMethodTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <FormGroup>
                            <Label for="current_stock_yn">Current Stock option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="current_stock_yn"
                              id="current_stock_yn"
                              value={genChallanKey.current_stock_yn}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>




                          <FormGroup>
                            <Label for="batch_no">Batch/Serial No</Label>
                            <Input
                              type="select" className="custom-select"
                              name="batch_no"
                              id="batch_no"
                              value={genChallanKey.batch_no}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="style">Style</Label>
                            <Input
                              type="select" className="custom-select"
                              name="style"
                              id="style"
                              value={genChallanKey.style}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="brand">Multiple Brand Allow</Label>
                            <Input
                              type="select" className="custom-select"
                              name="brand"
                              id="brand"
                              value={genChallanKey.brand}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}
                            >

                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                              {/* <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))} */}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="color">Color</Label>
                            <Input
                              type="select" className="custom-select"
                              name="color"
                              id="color"
                              value={genChallanKey.color}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="agent">Agent</Label>
                            <Input
                              type="select" className="custom-select"
                              name="agent"
                              id="agent"
                              value={genChallanKey.agent}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="dealer">Dealer</Label>
                            <Input
                              type="select" className="custom-select"
                              name="dealer"
                              id="dealer"
                              value={genChallanKey.dealer}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>


                          <FormGroup>
                            <Label for="round_off">Round_off</Label>
                            <Input
                              type="select" className="custom-select"
                              name="round_off"
                              id="round_off"
                              value={genChallanKey.round_off}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <FormGroup>
                            <Label for="maintain_accounting_yn">Maintain Accounting Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="maintain_accounting_yn"
                              id="maintain_accounting_yn"
                              value={genChallanKey.maintain_accounting_yn}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <FormGroup>
                            <Label for="transporter_cartage_yn">Transporter cartage in Bill Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="transporter_cartage_yn"
                              id="transporter_cartage_yn"
                              value={genChallanKey.transporter_cartage_yn}
                              onChange={onChangeIssueSaleHandle(slugUiFlag)}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <Label for="purchase_rate_yn">Purchase Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="purchase_rate_yn"
                            id="purchase_rate_yn"
                            value={genChallanKey.purchase_rate_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="profit_yn">Profit Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="profit_yn"
                            id="profit_yn"
                            value={genChallanKey.profit_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="discount_amount_yn">Discount Amount Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_amount_yn"
                            id="discount_amount_yn"
                            value={genChallanKey.discount_amount_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="discount_rate_yn">Discount Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_rate_yn"
                            id="discount_rate_yn"
                            value={genChallanKey.discount_rate_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="gst_amount_yn">Gst Amount Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_amount_yn"
                            id="gst_amount_yn"
                            value={genChallanKey.gst_amount_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="gst_rate_yn">Gst Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_rate_yn"
                            id="gst_rate_yn"
                            value={genChallanKey.gst_rate_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_profit_yn">Total Profit Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_profit_yn"
                            id="total_profit_yn"
                            value={genChallanKey.total_profit_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_weight_yn">Total Weight Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_weight_yn"
                            id="total_weight_yn"
                            value={genChallanKey.total_weight_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>




                        {/* ///////////// new code add  */}
                        <FormGroup>
                          <Label for="hsn_code_yn">HSN Code Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="hsn_code_yn"
                            id="hsn_code_yn"
                            value={genChallanKey.hsn_code_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="packing_type_yn">Packing Type Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="packing_type_yn"
                            id="packing_type_yn"
                            value={genChallanKey.packing_type_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="scheme_type_yn">Scheme Type Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="scheme_type_yn"
                            id="scheme_type_yn"
                            value={genChallanKey.scheme_type_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="remarks_yn">Remark Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="remarks_yn"
                            id="remarks_yn"
                            value={genChallanKey.remarks_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="sale_rate_yn">Sale Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="sale_rate_yn"
                            id="sale_rate_yn"
                            value={genChallanKey.sale_rate_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          {/* //sale_qty_yn */}
                          <Label for="issue_qty_yn"> Issue Qty Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="issue_qty_yn"
                            id="issue_qty_yn"
                            value={genChallanKey.issue_qty_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>




                        <FormGroup>
                          <Label for="recv_qty_yn">Receive Qty Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="recv_qty_yn"
                            id="recv_qty_yn"
                            value={genChallanKey.recv_qty_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="discount_percentage_yn">Discount Percentage Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_percentage_yn"
                            id="discount_percentage_yn"
                            value={genChallanKey.discount_percentage_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="grand_total_yn">Grand Total Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="grand_total_yn"
                            id="grand_total_yn"
                            value={genChallanKey.grand_total_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_percentage_yn"
                            id="gst_percentage_yn"
                            value={genChallanKey.gst_percentage_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <FormGroup>
                          <Label for="rate_after_gst_yn">Rate After gst option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="rate_after_gst_yn"
                            id="rate_after_gst_yn"
                            value={genChallanKey.rate_after_gst_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_amount_yn">Total Amount option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_amount_yn"
                            id="total_amount_yn"
                            value={genChallanKey.total_amount_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_profit_yn">Total Profit option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_profit_yn"
                            id="total_profit_yn"
                            value={genChallanKey.total_profit_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <FormGroup>
                          <Label for="balance_qty_yn">Balance Qty option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="balance_qty_yn"
                            id="balance_qty_yn"
                            value={genChallanKey.balance_qty_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <FormGroup>
                          <Label for="warranty_period">Warranty Period</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_period"
                            id="warranty_period"
                            value={genChallanKey.warranty_period}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_mode">Warranty Mode</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_mode"
                            id="warranty_mode"
                            value={genChallanKey.warranty_mode}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="service_visit_count">Service Visit Count</Label>
                          <Input

                            type="select" className="custom-select"
                            name="service_visit_count"
                            id="service_visit_count"
                            value={genChallanKey.service_visit_count}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_expiry_date">Warranty Expiry Date</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_expiry_date"
                            id="warranty_expiry_date"
                            value={genChallanKey.warranty_expiry_date}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_button">Warranty Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_button"
                            id="warranty_button"
                            value={genChallanKey.warranty_button}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="extra_detail_button">Extra Detail Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="extra_detail_button"
                            id="extra_detail_button"
                            value={genChallanKey.extra_detail_button}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>






                        <FormGroup>
                          <Label for="chl_acc_bill_acc_fixed_open_yn">chl acc bill acc fixed open yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_fixed_open_yn"
                            id="chl_acc_bill_acc_fixed_open_yn"
                            value={genChallanKey.chl_acc_bill_acc_fixed_open_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_acc_last_record_yn">chl acc bill acc last record yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_last_record_yn"
                            id="chl_acc_bill_acc_last_record_yn"
                            value={genChallanKey.chl_acc_bill_acc_last_record_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>




                        <FormGroup>
                          <Label for="ch_man_amt_yn">ch man amt yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_man_amt_yn"
                            id="ch_man_amt_yn"
                            value={genChallanKey.ch_man_amt_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_man_qty_yn">ch man qty yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_man_qty_yn"
                            id="ch_man_qty_yn"
                            value={genChallanKey.ch_man_qty_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_man_item_ct_yn">ch man item ct yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_man_item_ct_yn"
                            id="ch_man_item_ct_yn"
                            value={genChallanKey.ch_man_item_ct_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_bill_mat_yn">ch bill mat yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_bill_mat_yn"
                            id="ch_bill_mat_yn"
                            value={genChallanKey.ch_bill_mat_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_sig_item_qty_man_yn">ch sig item qty man yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_sig_item_qty_man_yn"
                            id="ch_sig_item_qty_man_yn"
                            value={genChallanKey.ch_sig_item_qty_man_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_sig_item_rate_man_yn">ch sig item rate man yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_sig_item_rate_man_yn"
                            id="ch_sig_item_rate_man_yn"
                            value={genChallanKey.ch_sig_item_rate_man_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_status_yn">ch status yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_status_yn"
                            id="ch_status_yn"
                            value={genChallanKey.ch_status_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>






                        <FormGroup>
                          <Label for="bill_delivery_to_yn">bill_delivery_to_yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="bill_delivery_to_yn"
                            id="bill_delivery_to_yn"
                            value={genChallanKey.bill_delivery_to_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="bill_receive_by_yn">bill_receive_by_yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="bill_receive_by_yn"
                            id="bill_receive_by_yn"
                            value={genChallanKey.bill_receive_by_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <h5>Issue Recipted Billing Account Detail</h5>

                        <FormGroup>
                          <Label for="maintain_ledger_ac_post">Maintain Ledger A/c Post</Label>
                          <Input

                            type="select" className="custom-select"
                            name="maintain_ledger_ac_post"
                            id="maintain_ledger_ac_post"
                            value={genChallanKey.maintain_ledger_ac_post}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_bill_val_yn">ch bill val yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_bill_val_yn"
                            id="ch_bill_val_yn"
                            value={genChallanKey.ch_bill_val_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_tot_qty_yn">ch tot qty yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_tot_qty_yn"
                            id="ch_tot_qty_yn"
                            value={genChallanKey.ch_tot_qty_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_aprox_qt_wgt_yn">ch aprox qt wgt yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_aprox_qt_wgt_yn"
                            id="ch_aprox_qt_wgt_yn"
                            value={genChallanKey.ch_aprox_qt_wgt_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_trip_yn">ch trip yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_trip_yn"
                            id="ch_trip_yn"
                            value={genChallanKey.ch_trip_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_cartg_amt_yn">ch cartg amt yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_cartg_amt_yn"
                            id="ch_cartg_amt_yn"
                            value={genChallanKey.ch_cartg_amt_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="mis_exp_tot_yn">mis exp tot yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="mis_exp_tot_yn"
                            id="mis_exp_tot_yn"
                            value={genChallanKey.mis_exp_tot_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_gross_amt_yn">ch gross amt yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_gross_amt_yn"
                            id="ch_gross_amt_yn"
                            value={genChallanKey.ch_gross_amt_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_gst_per_yn">ch gst per yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_gst_per_yn"
                            id="ch_gst_per_yn"
                            value={genChallanKey.ch_gst_per_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_gst_amt_yn">ch gst amt yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_gst_amt_yn"
                            id="ch_gst_amt_yn"
                            value={genChallanKey.ch_gst_amt_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_gst_type_yn">ch gst type yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_gst_type_yn"
                            id="ch_gst_type_yn"
                            value={genChallanKey.ch_gst_type_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_grnd_amt_yn">ch grnd amt yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_grnd_amt_yn"
                            id="ch_grnd_amt_yn"
                            value={genChallanKey.ch_grnd_amt_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_tcs_op_yn">ch tcs op yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_tcs_op_yn"
                            id="ch_tcs_op_yn"
                            value={genChallanKey.ch_tcs_op_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_tcs_per_yn">ch tcs per yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_tcs_per_yn"
                            id="ch_tcs_per_yn"
                            value={genChallanKey.ch_tcs_per_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_tcs_val_yn">ch tcs val yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_tcs_val_yn"
                            id="ch_tcs_val_yn"
                            value={genChallanKey.ch_tcs_val_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_grad_amt_w_tcs_yn">ch grad amt w tcs yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_grad_amt_w_tcs_yn"
                            id="ch_grad_amt_w_tcs_yn"
                            value={genChallanKey.ch_grad_amt_w_tcs_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_fin_amt_yn">ch fin amt yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_fin_amt_yn"
                            id="ch_fin_amt_yn"
                            value={genChallanKey.ch_fin_amt_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <h5>Aggrement Detail</h5>
                        <FormGroup>
                          <Label for="brokage_button">Brokage Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="brokage_button"
                            id="brokage_button"
                            value={genChallanKey.brokage_button}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="mixed_button">Mixed Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="mixed_button"
                            id="mixed_button"
                            value={genChallanKey.mixed_button}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="issuied_qty">Issuied Qty</Label>
                          <Input

                            type="select" className="custom-select"
                            name="issuied_qty"
                            id="issuied_qty"
                            value={genChallanKey.issuied_qty}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        {/* Accordion keyword */}
                        <h4>Accordion Option</h4>
                        <FormGroup>
                          <Label for="chl_acc_addr_yn">Chl Acc Addr Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_addr_yn"
                            id="chl_acc_addr_yn"
                            value={genChallanKey.chl_acc_addr_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_ext_yn">Chl Acc Bill Ext Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_ext_yn"
                            id="chl_acc_bill_ext_yn"
                            value={genChallanKey.chl_acc_bill_ext_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_trans_yn">Chl Acc Trans Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_trans_yn"
                            id="chl_acc_trans_yn"
                            value={genChallanKey.chl_acc_trans_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_misc_yn">Chl Acc Misc Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_misc_yn"
                            id="chl_acc_misc_yn"
                            value={genChallanKey.chl_acc_misc_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_acc_yn">Chl Acc Bill Acc Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_yn"
                            id="chl_acc_bill_acc_yn"
                            value={genChallanKey.chl_acc_bill_acc_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_extra_doc_acc_yn">chl acc extra doc acc yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_extra_doc_acc_yn"
                            id="chl_acc_extra_doc_acc_yn"
                            value={genChallanKey.chl_acc_extra_doc_acc_yn}
                            onChange={onChangeIssueSaleHandle(slugUiFlag)}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>











                        {/* Continue your other <FormGroup> fields here ... */}
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </CardBody>
          )}





          {/* // issue chalan  */}
          {
            flagMaster == "issue_challan_singlewww" && <CardBody>
              <Form>
                <div
                  className='accordion accordion-flush'
                  id='accordionFlushExample1'
                >
                  <div className='accordion-item'>
                    <h2 className='accordion-header' id='flush-headingSix1'>
                      <button
                        className='accordion-button collapsed'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#flush-collapseSix1'
                        aria-expanded='false'
                        aria-controls='flush-collapseSix1'
                      >
                        {"Issue Ch. { General }"} old
                      </button>
                    </h2>
                    <div
                      id='flush-collapseSix1'
                      className='accordion-collapse collapse'
                      aria-labelledby='flush-headingSix1'
                      data-bs-parent='#accordionFlushExample1'
                    >
                      <div className='accordion-body'>
                        <FormGroup>

                          <FormGroup row>
                            <Label for="challan_master_method">Challan Master Show Method</Label>
                            <Col >

                              <Input
                                id="challan_master_method"
                                name="challan_master_method"
                                value={issueChallanSingleKey.challan_master_method}
                                onChange={onChangeIssueSaleHandle("issue_challan_single")}

                                type="select" className="custom-select"
                              >
                                <option value="">Select</option>
                                <option value="single">Single Entry</option>
                                <option value="aggrement">Aggrement Entry</option>
                                <option value="both">Both</option>


                              </Input>
                            </Col>
                          </FormGroup>

                          <FormGroup>
                            <Col>
                              <Label for="cart_tcs_yn">TCS Value</Label>
                              <Input type="number" name="cart_tcs_value"
                                id="cart_tcs_value"
                                value={typeof issueChallanSingleKey.cart_tcs_value === 'number' ? issueChallanSingleKey.cart_tcs_value.toFixed(3) : issueChallanSingleKey.cart_tcs_value}
                                onChange={onChangeIssueSaleHandle("issue_challan_single")}

                              />
                            </Col>
                          </FormGroup>

                          <FormGroup>
                            <Label for="sale_method_option">Sale Method</Label>
                            <Input
                              type="select" className="custom-select"
                              name="sale_method_option"
                              id="sale_method_option"
                              value={issueChallanSingleKey.sale_method_option}
                              onChange={onChangeIssueSaleHandle("issue_challan_single")}

                            >
                              <option value="">select</option>
                              {helperMasterSaleMethodTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>


                          <FormGroup>
                            <Label for="current_stock_yn">Current Stock option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="current_stock_yn"
                              id="current_stock_yn"
                              value={issueChallanSingleKey.current_stock_yn}
                              onChange={onChangeIssueSaleHandle("issue_challan_single")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <FormGroup>
                            <Label for="batch_no">Batch/Serial No</Label>
                            <Input
                              type="select" className="custom-select"
                              name="batch_no"
                              id="batch_no"
                              value={issueChallanSingleKey.batch_no}
                              onChange={onChangeIssueSaleHandle("issue_challan_single")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="style">Style</Label>
                            <Input
                              type="select" className="custom-select"
                              name="style"
                              id="style"
                              value={issueChallanSingleKey.style}
                              onChange={onChangeIssueSaleHandle("issue_challan_single")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="brand">Multiple Brand Allow</Label>
                            <Input
                              type="select" className="custom-select"
                              name="brand"
                              id="brand"
                              value={issueChallanSingleKey.brand}
                              onChange={onChangeIssueSaleHandle("issue_challan_single")}
                            >

                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                              {/* <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))} */}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="color">Color</Label>
                            <Input
                              type="select" className="custom-select"
                              name="color"
                              id="color"
                              value={issueChallanSingleKey.color}
                              onChange={onChangeIssueSaleHandle("issue_challan_single")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="agent">Agent</Label>
                            <Input
                              type="select" className="custom-select"
                              name="agent"
                              id="agent"
                              value={issueChallanSingleKey.agent}
                              onChange={onChangeIssueSaleHandle("issue_challan_single")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="dealer">Dealer</Label>
                            <Input
                              type="select" className="custom-select"
                              name="dealer"
                              id="dealer"
                              value={issueChallanSingleKey.dealer}
                              onChange={onChangeIssueSaleHandle("issue_challan_single")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>


                          <FormGroup>
                            <Label for="round_off">Round_off</Label>
                            <Input
                              type="select" className="custom-select"
                              name="round_off"
                              id="round_off"
                              value={issueChallanSingleKey.round_off}
                              onChange={onChangeIssueSaleHandle("issue_challan_single")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <FormGroup>
                            <Label for="maintain_accounting_yn">Maintain Accounting Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="maintain_accounting_yn"
                              id="maintain_accounting_yn"
                              value={issueChallanSingleKey.maintain_accounting_yn}
                              onChange={onChangeIssueSaleHandle("issue_challan_single")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <FormGroup>
                            <Label for="transporter_cartage_yn">Transporter cartage in Bill Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="transporter_cartage_yn"
                              id="transporter_cartage_yn"
                              value={issueChallanSingleKey.transporter_cartage_yn}
                              onChange={onChangeIssueSaleHandle("issue_challan_single")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <Label for="purchase_rate_yn">Purchase Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="purchase_rate_yn"
                            id="purchase_rate_yn"
                            value={issueChallanSingleKey.purchase_rate_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="profit_yn">Profit Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="profit_yn"
                            id="profit_yn"
                            value={issueChallanSingleKey.profit_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="discount_amount_yn">Discount Amount Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_amount_yn"
                            id="discount_amount_yn"
                            value={issueChallanSingleKey.discount_amount_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="discount_rate_yn">Discount Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_rate_yn"
                            id="discount_rate_yn"
                            value={issueChallanSingleKey.discount_rate_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="gst_amount_yn">Gst Amount Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_amount_yn"
                            id="gst_amount_yn"
                            value={issueChallanSingleKey.gst_amount_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="gst_rate_yn">Gst Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_rate_yn"
                            id="gst_rate_yn"
                            value={issueChallanSingleKey.gst_rate_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_profit_yn">Total Profit Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_profit_yn"
                            id="total_profit_yn"
                            value={issueChallanSingleKey.total_profit_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_weight_yn">Total Weight Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_weight_yn"
                            id="total_weight_yn"
                            value={issueChallanSingleKey.total_weight_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>




                        {/* ///////////// new code add  */}
                        <FormGroup>
                          <Label for="hsn_code_yn">HSN Code Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="hsn_code_yn"
                            id="hsn_code_yn"
                            value={issueChallanSingleKey.hsn_code_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="packing_type_yn">Packing Type Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="packing_type_yn"
                            id="packing_type_yn"
                            value={issueChallanSingleKey.packing_type_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="scheme_type_yn">Scheme Type Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="scheme_type_yn"
                            id="scheme_type_yn"
                            value={issueChallanSingleKey.scheme_type_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="remarks_yn">Remark Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="remarks_yn"
                            id="remarks_yn"
                            value={issueChallanSingleKey.remarks_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="sale_rate_yn">Sale Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="sale_rate_yn"
                            id="sale_rate_yn"
                            value={issueChallanSingleKey.sale_rate_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          {/* //sale_qty_yn */}
                          <Label for="issue_qty_yn"> Issue Qty Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="issue_qty_yn"
                            id="issue_qty_yn"
                            value={issueChallanSingleKey.issue_qty_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>




                        <FormGroup>
                          <Label for="recv_qty_yn">Receive Qty Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="recv_qty_yn"
                            id="recv_qty_yn"
                            value={issueChallanSingleKey.recv_qty_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="discount_percentage_yn">Discount Percentage Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_percentage_yn"
                            id="discount_percentage_yn"
                            value={issueChallanSingleKey.discount_percentage_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="grand_total_yn">Grand Total Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="grand_total_yn"
                            id="grand_total_yn"
                            value={issueChallanSingleKey.grand_total_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_percentage_yn"
                            id="gst_percentage_yn"
                            value={issueChallanSingleKey.gst_percentage_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <FormGroup>
                          <Label for="rate_after_gst_yn">Rate After gst option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="rate_after_gst_yn"
                            id="rate_after_gst_yn"
                            value={issueChallanSingleKey.rate_after_gst_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_amount_yn">Total Amount option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_amount_yn"
                            id="total_amount_yn"
                            value={issueChallanSingleKey.total_amount_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_profit_yn">Total Profit option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_profit_yn"
                            id="total_profit_yn"
                            value={issueChallanSingleKey.total_profit_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <FormGroup>
                          <Label for="balance_qty_yn">Balance Qty option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="balance_qty_yn"
                            id="balance_qty_yn"
                            value={issueChallanSingleKey.balance_qty_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <FormGroup>
                          <Label for="warranty_period">Warranty Period</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_period"
                            id="warranty_period"
                            value={issueChallanSingleKey.warranty_period}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_mode">Warranty Mode</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_mode"
                            id="warranty_mode"
                            value={issueChallanSingleKey.warranty_mode}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="service_visit_count">Service Visit Count</Label>
                          <Input

                            type="select" className="custom-select"
                            name="service_visit_count"
                            id="service_visit_count"
                            value={issueChallanSingleKey.service_visit_count}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_expiry_date">Warranty Expiry Date</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_expiry_date"
                            id="warranty_expiry_date"
                            value={issueChallanSingleKey.warranty_expiry_date}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_button">Warranty Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_button"
                            id="warranty_button"
                            value={issueChallanSingleKey.warranty_button}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="extra_detail_button">Extra Detail Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="extra_detail_button"
                            id="extra_detail_button"
                            value={issueChallanSingleKey.extra_detail_button}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>





                        <h5>Aggrement Detail</h5>
                        <FormGroup>
                          <Label for="brokage_button">Brokage Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="brokage_button"
                            id="brokage_button"
                            value={issueChallanSingleKey.brokage_button}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="mixed_button">Mixed Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="mixed_button"
                            id="mixed_button"
                            value={issueChallanSingleKey.mixed_button}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="issuied_qty">Issuied Qty</Label>
                          <Input

                            type="select" className="custom-select"
                            name="issuied_qty"
                            id="issuied_qty"
                            value={issueChallanSingleKey.issuied_qty}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        {/* Accordion keyword */}
                        <h4>Accordion Option</h4>
                        <FormGroup>
                          <Label for="chl_acc_addr_yn">Chl Acc Addr Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_addr_yn"
                            id="chl_acc_addr_yn"
                            value={issueChallanSingleKey.chl_acc_addr_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_ext_yn">Chl Acc Bill Ext Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_ext_yn"
                            id="chl_acc_bill_ext_yn"
                            value={issueChallanSingleKey.chl_acc_bill_ext_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_trans_yn">Chl Acc Trans Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_trans_yn"
                            id="chl_acc_trans_yn"
                            value={issueChallanSingleKey.chl_acc_trans_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_misc_yn">Chl Acc Misc Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_misc_yn"
                            id="chl_acc_misc_yn"
                            value={issueChallanSingleKey.chl_acc_misc_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_acc_yn">Chl Acc Bill Acc Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_yn"
                            id="chl_acc_bill_acc_yn"
                            value={issueChallanSingleKey.chl_acc_bill_acc_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>









                        <FormGroup>
                          <Label for="chl_acc_bill_acc_fixed_open_yn">chl acc bill acc fixed open yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_fixed_open_yn"
                            id="chl_acc_bill_acc_fixed_open_yn"
                            value={issueChallanSingleKey.chl_acc_bill_acc_fixed_open_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_acc_last_record_yn">chl acc bill acc last record yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_last_record_yn"
                            id="chl_acc_bill_acc_last_record_yn"
                            value={issueChallanSingleKey.chl_acc_bill_acc_last_record_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="chl_acc_extra_doc_acc_yn">chl acc extra doc acc yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_extra_doc_acc_yn"
                            id="chl_acc_extra_doc_acc_yn"
                            value={issueChallanSingleKey.chl_acc_extra_doc_acc_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_man_amt_yn">ch man amt yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_man_amt_yn"
                            id="ch_man_amt_yn"
                            value={issueChallanSingleKey.ch_man_amt_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_man_qty_yn">ch man qty yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_man_qty_yn"
                            id="ch_man_qty_yn"
                            value={issueChallanSingleKey.ch_man_qty_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_man_item_ct_yn">ch man item ct yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_man_item_ct_yn"
                            id="ch_man_item_ct_yn"
                            value={issueChallanSingleKey.ch_man_item_ct_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_bill_mat_yn">ch bill mat yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_bill_mat_yn"
                            id="ch_bill_mat_yn"
                            value={issueChallanSingleKey.ch_bill_mat_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_sig_item_qty_man_yn">ch sig item qty man yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_sig_item_qty_man_yn"
                            id="ch_sig_item_qty_man_yn"
                            value={issueChallanSingleKey.ch_sig_item_qty_man_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_sig_item_rate_man_yn">ch sig item rate man yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_sig_item_rate_man_yn"
                            id="ch_sig_item_rate_man_yn"
                            value={issueChallanSingleKey.ch_sig_item_rate_man_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="ch_status_yn">ch status yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="ch_status_yn"
                            id="ch_status_yn"
                            value={issueChallanSingleKey.ch_status_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_single")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                      </div>
                    </div>
                  </div>
                </div>


              </Form>
            </CardBody>
          }


          {/* // issue chalan Aggrement (HO)  */}
          {flagMaster == "issue_challan_agrww" && <CardBody>
            <Form>
              <div
                className='accordion accordion-flush'
                id='accordionFlushExample1'
              >
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='flush-headingSix1'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#flush-collapseSix1'
                      aria-expanded='false'
                      aria-controls='flush-collapseSix1'
                    >
                      {/* Issue Challan (FH) Agg. */}
                      {"Issue Ch. {FH} { Agrment }"}
                    </button>
                  </h2>
                  <div
                    id='flush-collapseSix1'
                    className='accordion-collapse collapse'
                    aria-labelledby='flush-headingSix1'
                    data-bs-parent='#accordionFlushExample1'
                  >
                    <div className='accordion-body'>
                      <FormGroup>

                        <FormGroup row>
                          <Label for="challan_master_method">Challan Master Show Method</Label>
                          <Col >

                            <Input
                              id="challan_master_method"
                              name="challan_master_method"
                              value={issueChallanAgoKey.challan_master_method}
                              onChange={onChangeIssueSaleHandle("issue_challan_agr")}

                              type="select" className="custom-select"
                            >
                              <option value="">Select</option>
                              <option value="single">Single Entry</option>
                              <option value="aggrement">Aggrement Entry</option>
                              <option value="both">Both</option>


                            </Input>
                          </Col>
                        </FormGroup>

                        <FormGroup>
                          <Col>
                            <Label for="cart_tcs_yn">TCS Value</Label>
                            <Input type="number" name="cart_tcs_value"
                              id="cart_tcs_value"
                              value={typeof issueChallanAgoKey.cart_tcs_value === 'number' ? issueChallanAgoKey.cart_tcs_value.toFixed(3) : issueChallanAgoKey.cart_tcs_value}
                              onChange={onChangeIssueSaleHandle("issue_challan_agr")}

                            />
                          </Col>
                        </FormGroup>

                        <FormGroup>
                          <Label for="sale_method_option">Sale Method</Label>
                          <Input
                            type="select" className="custom-select"
                            name="sale_method_option"
                            id="sale_method_option"
                            value={issueChallanAgoKey.sale_method_option}
                            onChange={onChangeIssueSaleHandle("issue_challan_agr")}

                          >
                            <option value="">select</option>
                            {helperMasterSaleMethodTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <FormGroup>
                          <Label for="batch_no">Batch/Serial No</Label>
                          <Input
                            type="select" className="custom-select"
                            name="batch_no"
                            id="batch_no"
                            value={issueChallanAgoKey.batch_no}
                            onChange={onChangeIssueSaleHandle("issue_challan_agr")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="style">Style</Label>
                          <Input
                            type="select" className="custom-select"
                            name="style"
                            id="style"
                            value={issueChallanAgoKey.style}
                            onChange={onChangeIssueSaleHandle("issue_challan_agr")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="brand">Multiple Brand Allow</Label>
                          <Input
                            type="select" className="custom-select"
                            name="brand"
                            id="brand"
                            value={issueChallanAgoKey.brand}
                            onChange={onChangeIssueSaleHandle("issue_challan_agr")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="color">Color</Label>
                          <Input
                            type="select" className="custom-select"
                            name="color"
                            id="color"
                            value={issueChallanAgoKey.color}
                            onChange={onChangeIssueSaleHandle("issue_challan_agr")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="agent">Agent</Label>
                          <Input
                            type="select" className="custom-select"
                            name="agent"
                            id="agent"
                            value={issueChallanAgoKey.agent}
                            onChange={onChangeIssueSaleHandle("issue_challan_agr")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="dealer">Dealer</Label>
                          <Input
                            type="select" className="custom-select"
                            name="dealer"
                            id="dealer"
                            value={issueChallanAgoKey.dealer}
                            onChange={onChangeIssueSaleHandle("issue_challan_agr")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="round_off">Round_off</Label>
                          <Input
                            type="select" className="custom-select"
                            name="round_off"
                            id="round_off"
                            value={issueChallanAgoKey.round_off}
                            onChange={onChangeIssueSaleHandle("issue_challan_agr")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="maintain_accounting_yn">Maintain Accounting Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="maintain_accounting_yn"
                            id="maintain_accounting_yn"
                            value={issueChallanAgoKey.maintain_accounting_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_agr")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="transporter_cartage_yn">Transporter cartage in Bill Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="transporter_cartage_yn"
                            id="transporter_cartage_yn"
                            value={issueChallanAgoKey.transporter_cartage_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_agr")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <Label for="purchase_rate_yn">Purchase Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="purchase_rate_yn"
                          id="purchase_rate_yn"
                          value={issueChallanAgoKey.purchase_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="profit_yn">Profit Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="profit_yn"
                          id="profit_yn"
                          value={issueChallanAgoKey.profit_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="discount_amount_yn">Discount Amount Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_amount_yn"
                          id="discount_amount_yn"
                          value={issueChallanAgoKey.discount_amount_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="discount_rate_yn">Discount Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_rate_yn"
                          id="discount_rate_yn"
                          value={issueChallanAgoKey.discount_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="gst_amount_yn">Gst Amount Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_amount_yn"
                          id="gst_amount_yn"
                          value={issueChallanAgoKey.gst_amount_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="gst_rate_yn">Gst Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_rate_yn"
                          id="gst_rate_yn"
                          value={issueChallanAgoKey.gst_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_profit_yn">Total Profit Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_profit_yn"
                          id="total_profit_yn"
                          value={issueChallanAgoKey.total_profit_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_weight_yn">Total Weight Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_weight_yn"
                          id="total_weight_yn"
                          value={issueChallanAgoKey.total_weight_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>




                      {/* ///////////// new code add  */}
                      <FormGroup>
                        <Label for="hsn_code_yn">HSN Code Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="hsn_code_yn"
                          id="hsn_code_yn"
                          value={issueChallanAgoKey.hsn_code_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="packing_type_yn">Packing Type Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="packing_type_yn"
                          id="packing_type_yn"
                          value={issueChallanAgoKey.packing_type_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="scheme_type_yn">Scheme Type Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="scheme_type_yn"
                          id="scheme_type_yn"
                          value={issueChallanAgoKey.scheme_type_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="remarks_yn">Remark Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="remarks_yn"
                          id="remarks_yn"
                          value={issueChallanAgoKey.remarks_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="sale_rate_yn">Sale Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="sale_rate_yn"
                          id="sale_rate_yn"
                          value={issueChallanAgoKey.sale_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        {/* //sale_qty_yn */}
                        <Label for="issue_qty_yn"> Issue Qty Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="issue_qty_yn"
                          id="issue_qty_yn"
                          value={issueChallanAgoKey.issue_qty_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="recv_qty_yn">Recipted Qty Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="recv_qty_yn"
                          id="recv_qty_yn"
                          value={issueChallanAgoKey.recv_qty_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="discount_percentage_yn">Discount Percentage Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_percentage_yn"
                          id="discount_percentage_yn"
                          value={issueChallanAgoKey.discount_percentage_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="grand_total_yn">Grand Total Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="grand_total_yn"
                          id="grand_total_yn"
                          value={issueChallanAgoKey.grand_total_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_percentage_yn"
                          id="gst_percentage_yn"
                          value={issueChallanAgoKey.gst_percentage_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                      <FormGroup>
                        <Label for="rate_after_gst_yn">Rate After gst option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="rate_after_gst_yn"
                          id="rate_after_gst_yn"
                          value={issueChallanAgoKey.rate_after_gst_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_amount_yn">Total Amount option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_amount_yn"
                          id="total_amount_yn"
                          value={issueChallanAgoKey.total_amount_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_profit_yn">Total Profit option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_profit_yn"
                          id="total_profit_yn"
                          value={issueChallanAgoKey.total_profit_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="current_stock_yn">Current Stock option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="current_stock_yn"
                          id="current_stock_yn"
                          value={issueChallanAgoKey.current_stock_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="balance_qty_yn">Balance Qty option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="balance_qty_yn"
                          id="balance_qty_yn"
                          value={issueChallanAgoKey.balance_qty_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                      <FormGroup>
                        <Label for="warranty_period">Warranty Period</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_period"
                          id="warranty_period"
                          value={issueChallanAgoKey.warranty_period}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="warranty_mode">Warranty Mode</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_mode"
                          id="warranty_mode"
                          value={issueChallanAgoKey.warranty_mode}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="service_visit_count">Service Visit Count</Label>
                        <Input

                          type="select" className="custom-select"
                          name="service_visit_count"
                          id="service_visit_count"
                          value={issueChallanAgoKey.service_visit_count}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="warranty_expiry_date">Warranty Expiry Date</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_expiry_date"
                          id="warranty_expiry_date"
                          value={issueChallanAgoKey.warranty_expiry_date}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="warranty_button">Warranty Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_button"
                          id="warranty_button"
                          value={issueChallanAgoKey.warranty_button}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="extra_detail_button">Extra Detail Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="extra_detail_button"
                          id="extra_detail_button"
                          value={issueChallanAgoKey.extra_detail_button}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                      <h5>Aggrement Detail</h5>
                      <FormGroup>
                        <Label for="brokage_button">Brokage Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="brokage_button"
                          id="brokage_button"
                          value={issueChallanAgoKey.brokage_button}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="mixed_button">Mixed Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="mixed_button"
                          id="mixed_button"
                          value={issueChallanAgoKey.mixed_button}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="issuied_qty">Issuied Qty</Label>
                        <Input

                          type="select" className="custom-select"
                          name="issuied_qty"
                          id="issuied_qty"
                          value={issueChallanAgoKey.issuied_qty}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      {/* Accordion keyword */}
                      <h4>Accordion Option</h4>

                      <FormGroup>
                        <Label for="chl_acc_addr_yn">Chl Acc Addr Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_addr_yn"
                          id="chl_acc_addr_yn"
                          value={issueChallanAgoKey.chl_acc_addr_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_bill_ext_yn">Chl Acc Bill Ext Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_ext_yn"
                          id="chl_acc_bill_ext_yn"
                          value={issueChallanAgoKey.chl_acc_bill_ext_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_trans_yn">Chl Acc Trans Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_trans_yn"
                          id="chl_acc_trans_yn"
                          value={issueChallanAgoKey.chl_acc_trans_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_misc_yn">Chl Acc Misc Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_misc_yn"
                          id="chl_acc_misc_yn"
                          value={issueChallanAgoKey.chl_acc_misc_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_bill_acc_yn">Chl Acc Bill Acc Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_acc_yn"
                          id="chl_acc_bill_acc_yn"
                          value={issueChallanAgoKey.chl_acc_bill_acc_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_bill_acc_fixed_open_yn">chl acc bill acc fixed open yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_acc_fixed_open_yn"
                          id="chl_acc_bill_acc_fixed_open_yn"
                          value={issueChallanAgoKey.chl_acc_bill_acc_fixed_open_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_bill_acc_last_record_yn">chl acc bill acc last record yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_acc_last_record_yn"
                          id="chl_acc_bill_acc_last_record_yn"
                          value={issueChallanAgoKey.chl_acc_bill_acc_last_record_yn}
                          onChange={onChangeIssueSaleHandle("issue_challan_agr")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                    </div>
                  </div>
                </div>
              </div>


            </Form>
          </CardBody>}

          {/* IssueReceive Single Item  */}
          {flagMaster == "issue_reciptedww" && <CardBody>
            <Form>
              <div
                className='accordion accordion-flush'
                id='accordionFlushExample1'
              >
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='flush-headingSix'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#flush-collapseSix'
                      aria-expanded='false'
                      aria-controls='flush-collapseSix'
                    >
                      {"Receive Ch. { General }"}
                    </button>
                  </h2>
                  <div
                    id='flush-collapseSix'
                    className='accordion-collapse collapse'
                    aria-labelledby='flush-headingSix'
                    data-bs-parent='#accordionFlushExample1'
                  >
                    <div className='accordion-body'>
                      <FormGroup>

                        <FormGroup row>
                          <Label for="challan_master_method">Challan Master Show Method</Label>
                          <Col >

                            <Input
                              id="challan_master_method"
                              name="challan_master_method"
                              value={issueReciptedKey.challan_master_method}
                              onChange={onChangeIssueSaleHandle("issue_recipted")}

                              type="select" className="custom-select"
                            >
                              <option value="">Select</option>
                              <option value="single">Single Entry</option>
                              <option value="aggrement">Aggrement Entry</option>
                              <option value="both">Both</option>


                            </Input>
                          </Col>
                        </FormGroup>

                        <FormGroup>
                          <Col>
                            <Label for="cart_tcs_yn">TCS Value</Label>
                            <Input type="number" name="cart_tcs_value"
                              id="cart_tcs_value"
                              value={typeof issueReciptedKey.cart_tcs_value === 'number' ? issueReciptedKey.cart_tcs_value.toFixed(3) : issueReciptedKey.cart_tcs_value}
                              onChange={onChangeIssueSaleHandle("issue_recipted")}

                            />
                          </Col>
                        </FormGroup>

                        <FormGroup>
                          <Label for="sale_method_option">Sale Method</Label>
                          <Input
                            type="select" className="custom-select"
                            name="sale_method_option"
                            id="sale_method_option"
                            value={issueReciptedKey.sale_method_option}
                            onChange={onChangeIssueSaleHandle("issue_recipted")}

                          >
                            <option value="">select</option>
                            {helperMasterSaleMethodTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="batch_no">Batch/Serial No</Label>
                          <Input
                            type="select" className="custom-select"
                            name="batch_no"
                            id="batch_no"
                            value={issueReciptedKey.batch_no}
                            onChange={onChangeIssueSaleHandle("issue_recipted")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="style">Style</Label>
                          <Input
                            type="select" className="custom-select"
                            name="style"
                            id="style"
                            value={issueReciptedKey.style}
                            onChange={onChangeIssueSaleHandle("issue_recipted")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="brand">Multiple Brand Allow</Label>
                          <Input
                            type="select" className="custom-select"
                            name="brand"
                            id="brand"
                            value={issueReciptedKey.brand}
                            onChange={onChangeIssueSaleHandle("issue_recipted")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="color">Color</Label>
                          <Input
                            type="select" className="custom-select"
                            name="color"
                            id="color"
                            value={issueReciptedKey.color}
                            onChange={onChangeIssueSaleHandle("issue_recipted")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="agent">Agent</Label>
                          <Input
                            type="select" className="custom-select"
                            name="agent"
                            id="agent"
                            value={issueReciptedKey.agent}
                            onChange={onChangeIssueSaleHandle("issue_recipted")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="dealer">Dealer</Label>
                          <Input
                            type="select" className="custom-select"
                            name="dealer"
                            id="dealer"
                            value={issueReciptedKey.dealer}
                            onChange={onChangeIssueSaleHandle("issue_recipted")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="round_off">Round_off</Label>
                          <Input
                            type="select" className="custom-select"
                            name="round_off"
                            id="round_off"
                            value={issueReciptedKey.round_off}
                            onChange={onChangeIssueSaleHandle("issue_recipted")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="maintain_accounting_yn">Maintain Accounting Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="maintain_accounting_yn"
                            id="maintain_accounting_yn"
                            value={issueReciptedKey.maintain_accounting_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="transporter_cartage_yn">Transporter cartage in Bill Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="transporter_cartage_yn"
                            id="transporter_cartage_yn"
                            value={issueReciptedKey.transporter_cartage_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <Label for="purchase_rate_yn">Purchase Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="purchase_rate_yn"
                          id="purchase_rate_yn"
                          value={issueReciptedKey.purchase_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="profit_yn">Profit Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="profit_yn"
                          id="profit_yn"
                          value={issueReciptedKey.profit_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="discount_amount_yn">Discount Amount Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_amount_yn"
                          id="discount_amount_yn"
                          value={issueReciptedKey.discount_amount_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="discount_rate_yn">Discount Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_rate_yn"
                          id="discount_rate_yn"
                          value={issueReciptedKey.discount_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="gst_amount_yn">Gst Amount Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_amount_yn"
                          id="gst_amount_yn"
                          value={issueReciptedKey.gst_amount_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="gst_rate_yn">Gst Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_rate_yn"
                          id="gst_rate_yn"
                          value={issueReciptedKey.gst_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_profit_yn">Total Profit Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_profit_yn"
                          id="total_profit_yn"
                          value={issueReciptedKey.total_profit_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_weight_yn">Total Weight Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_weight_yn"
                          id="total_weight_yn"
                          value={issueReciptedKey.total_weight_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>




                      {/* ///////////// new code add  */}
                      <FormGroup>
                        <Label for="hsn_code_yn">HSN Code Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="hsn_code_yn"
                          id="hsn_code_yn"
                          value={issueReciptedKey.hsn_code_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                          <option value="not_show_in_model">NOT Show in Model</option>

                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="packing_type_yn">Packing Type Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="packing_type_yn"
                          id="packing_type_yn"
                          value={issueReciptedKey.packing_type_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="scheme_type_yn">Scheme Type Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="scheme_type_yn"
                          id="scheme_type_yn"
                          value={issueReciptedKey.scheme_type_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="remarks_yn">Remark Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="remarks_yn"
                          id="remarks_yn"
                          value={issueReciptedKey.remarks_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="sale_rate_yn">Sale Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="sale_rate_yn"
                          id="sale_rate_yn"
                          value={issueReciptedKey.sale_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="recv_qty_yn">Recipted Qty Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="recv_qty_yn"
                          id="recv_qty_yn"
                          value={issueReciptedKey.recv_qty_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="discount_percentage_yn">Discount Percentage Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_percentage_yn"
                          id="discount_percentage_yn"
                          value={issueReciptedKey.discount_percentage_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="grand_total_yn">Grand Total Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="grand_total_yn"
                          id="grand_total_yn"
                          value={issueReciptedKey.grand_total_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_percentage_yn"
                          id="gst_percentage_yn"
                          value={issueReciptedKey.gst_percentage_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                      <FormGroup>
                        <Label for="rate_after_gst_yn">Rate After gst option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="rate_after_gst_yn"
                          id="rate_after_gst_yn"
                          value={issueReciptedKey.rate_after_gst_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_amount_yn">Total Amount option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_amount_yn"
                          id="total_amount_yn"
                          value={issueReciptedKey.total_amount_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_profit_yn">Total Profit option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_profit_yn"
                          id="total_profit_yn"
                          value={issueReciptedKey.total_profit_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="current_stock_yn">Current Stock option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="current_stock_yn"
                          id="current_stock_yn"
                          value={issueReciptedKey.current_stock_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="balance_qty_yn">Balance Qty option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="balance_qty_yn"
                          id="balance_qty_yn"
                          value={issueReciptedKey.balance_qty_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                      <FormGroup>
                        <Label for="warranty_period">Warranty Period</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_period"
                          id="warranty_period"
                          value={issueReciptedKey.warranty_period}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="warranty_mode">Warranty Mode</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_mode"
                          id="warranty_mode"
                          value={issueReciptedKey.warranty_mode}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="service_visit_count">Service Visit Count</Label>
                        <Input

                          type="select" className="custom-select"
                          name="service_visit_count"
                          id="service_visit_count"
                          value={issueReciptedKey.service_visit_count}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="warranty_expiry_date">Warranty Expiry Date</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_expiry_date"
                          id="warranty_expiry_date"
                          value={issueReciptedKey.warranty_expiry_date}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="warranty_button">Warranty Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_button"
                          id="warranty_button"
                          value={issueReciptedKey.warranty_button}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="extra_detail_button">Extra Detail Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="extra_detail_button"
                          id="extra_detail_button"
                          value={issueReciptedKey.extra_detail_button}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <h5>Aggrement Detail</h5>
                      <FormGroup>
                        <Label for="brokage_button">Brokage Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="brokage_button"
                          id="brokage_button"
                          value={issueReciptedKey.brokage_button}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="mixed_button">Mixed Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="mixed_button"
                          id="mixed_button"
                          value={issueReciptedKey.mixed_button}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="issuied_qty">Issuied Qty</Label>
                        <Input

                          type="select" className="custom-select"
                          name="issuied_qty"
                          id="issuied_qty"
                          value={issueReciptedKey.issuied_qty}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                      {/* Accordion keyword */}
                      <h4>Accordion Option</h4>

                      <FormGroup>
                        <Label for="chl_acc_addr_yn">Chl Acc Addr Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_addr_yn"
                          id="chl_acc_addr_yn"
                          value={issueReciptedKey.chl_acc_addr_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_bill_ext_yn">Chl Acc Bill Ext Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_ext_yn"
                          id="chl_acc_bill_ext_yn"
                          value={issueReciptedKey.chl_acc_bill_ext_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_trans_yn">Chl Acc Trans Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_trans_yn"
                          id="chl_acc_trans_yn"
                          value={issueReciptedKey.chl_acc_trans_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_misc_yn">Chl Acc Misc Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_misc_yn"
                          id="chl_acc_misc_yn"
                          value={issueReciptedKey.chl_acc_misc_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_bill_acc_yn">Chl Acc Bill Acc Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_acc_yn"
                          id="chl_acc_bill_acc_yn"
                          value={issueReciptedKey.chl_acc_bill_acc_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="chl_acc_bill_acc_fixed_open_yn">chl acc bill acc fixed open yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_acc_fixed_open_yn"
                          id="chl_acc_bill_acc_fixed_open_yn"
                          value={issueReciptedKey.chl_acc_bill_acc_fixed_open_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_bill_acc_last_record_yn">chl acc bill acc last record yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_acc_last_record_yn"
                          id="chl_acc_bill_acc_last_record_yn"
                          value={issueReciptedKey.chl_acc_bill_acc_last_record_yn}
                          onChange={onChangeIssueSaleHandle("issue_recipted")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                    </div>
                  </div>
                </div>
              </div>

              {/* <Button
                className='mt-2'
                color='primary'
                onClick={System_Records_Add_Edit_Screen}
              >
                Save
              </Button> */}
            </Form>
          </CardBody>}

          {/* IssueReceive Aggrement  */}
          {
            flagMaster == "issue_recipted_agrww" && <CardBody>
              <Form>
                <div
                  className='accordion accordion-flush'
                  id='accordionFlushExample1'
                >
                  <div className='accordion-item'>
                    <h2 className='accordion-header' id='flush-headingSix'>
                      <button
                        className='accordion-button collapsed'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#flush-collapseSix'
                        aria-expanded='false'
                        aria-controls='flush-collapseSix'
                      >
                        {/* Receive Challan (FH) ( Agg. ) */}
                        {"Receive Ch. {FH} { Agrment }"}
                      </button>
                    </h2>
                    <div
                      id='flush-collapseSix'
                      className='accordion-collapse collapse'
                      aria-labelledby='flush-headingSix'
                      data-bs-parent='#accordionFlushExample1'
                    >
                      <div className='accordion-body'>
                        <FormGroup>

                          <FormGroup row>
                            <Label for="challan_master_method">Challan Master Show Method</Label>
                            <Col >

                              <Input
                                id="challan_master_method"
                                name="challan_master_method"
                                value={issueReciptedAgoKey.challan_master_method}
                                onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                                type="select" className="custom-select"
                              >
                                <option value="">Select</option>
                                <option value="single">Single Entry</option>
                                <option value="aggrement">Aggrement Entry</option>
                                <option value="both">Both</option>


                              </Input>
                            </Col>
                          </FormGroup>

                          <FormGroup>
                            <Col>
                              <Label for="cart_tcs_yn">TCS Value</Label>
                              <Input type="number" name="cart_tcs_value"
                                id="cart_tcs_value"
                                value={typeof issueReciptedAgoKey.cart_tcs_value === 'number' ? issueReciptedAgoKey.cart_tcs_value.toFixed(3) : issueReciptedAgoKey.cart_tcs_value}
                                onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                              />
                            </Col>
                          </FormGroup>

                          <FormGroup>
                            <Label for="sale_method_option">Sale Method</Label>
                            <Input
                              type="select" className="custom-select"
                              name="sale_method_option"
                              id="sale_method_option"
                              value={issueReciptedAgoKey.sale_method_option}
                              onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                            >
                              <option value="">select</option>
                              {helperMasterSaleMethodTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>


                          <FormGroup>
                            <Label for="batch_no">Batch/Serial No</Label>
                            <Input
                              type="select" className="custom-select"
                              name="batch_no"
                              id="batch_no"
                              value={issueReciptedAgoKey.batch_no}
                              onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="style">Style</Label>
                            <Input
                              type="select" className="custom-select"
                              name="style"
                              id="style"
                              value={issueReciptedAgoKey.style}
                              onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="brand">Multiple Brand Allow</Label>
                            <Input
                              type="select" className="custom-select"
                              name="brand"
                              id="brand"
                              value={issueReciptedAgoKey.brand}
                              onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="color">Color</Label>
                            <Input
                              type="select" className="custom-select"
                              name="color"
                              id="color"
                              value={issueReciptedAgoKey.color}
                              onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="agent">Agent</Label>
                            <Input
                              type="select" className="custom-select"
                              name="agent"
                              id="agent"
                              value={issueReciptedAgoKey.agent}
                              onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="dealer">Dealer</Label>
                            <Input
                              type="select" className="custom-select"
                              name="dealer"
                              id="dealer"
                              value={issueReciptedAgoKey.dealer}
                              onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>


                          <FormGroup>
                            <Label for="round_off">Round_off</Label>
                            <Input
                              type="select" className="custom-select"
                              name="round_off"
                              id="round_off"
                              value={issueReciptedAgoKey.round_off}
                              onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <FormGroup>
                            <Label for="maintain_accounting_yn">Maintain Accounting Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="maintain_accounting_yn"
                              id="maintain_accounting_yn"
                              value={issueReciptedAgoKey.maintain_accounting_yn}
                              onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <FormGroup>
                            <Label for="transporter_cartage_yn">Transporter cartage in Bill Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="transporter_cartage_yn"
                              id="transporter_cartage_yn"
                              value={issueReciptedAgoKey.transporter_cartage_yn}
                              onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <Label for="purchase_rate_yn">Purchase Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="purchase_rate_yn"
                            id="purchase_rate_yn"
                            value={issueReciptedAgoKey.purchase_rate_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="profit_yn">Profit Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="profit_yn"
                            id="profit_yn"
                            value={issueReciptedAgoKey.profit_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="discount_amount_yn">Discount Amount Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_amount_yn"
                            id="discount_amount_yn"
                            value={issueReciptedAgoKey.discount_amount_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="discount_rate_yn">Discount Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_rate_yn"
                            id="discount_rate_yn"
                            value={issueReciptedAgoKey.discount_rate_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="gst_amount_yn">Gst Amount Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_amount_yn"
                            id="gst_amount_yn"
                            value={issueReciptedAgoKey.gst_amount_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="gst_rate_yn">Gst Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_rate_yn"
                            id="gst_rate_yn"
                            value={issueReciptedAgoKey.gst_rate_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_profit_yn">Total Profit Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_profit_yn"
                            id="total_profit_yn"
                            value={issueReciptedAgoKey.total_profit_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_weight_yn">Total Weight Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_weight_yn"
                            id="total_weight_yn"
                            value={issueReciptedAgoKey.total_weight_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>




                        {/* ///////////// new code add  */}
                        <FormGroup>
                          <Label for="hsn_code_yn">HSN Code Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="hsn_code_yn"
                            id="hsn_code_yn"
                            value={issueReciptedAgoKey.hsn_code_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                            <option value="not_show_in_model">NOT Show in Model</option>

                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="packing_type_yn">Packing Type Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="packing_type_yn"
                            id="packing_type_yn"
                            value={issueReciptedAgoKey.packing_type_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="scheme_type_yn">Scheme Type Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="scheme_type_yn"
                            id="scheme_type_yn"
                            value={issueReciptedAgoKey.scheme_type_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="remarks_yn">Remark Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="remarks_yn"
                            id="remarks_yn"
                            value={issueReciptedAgoKey.remarks_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="sale_rate_yn">Sale Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="sale_rate_yn"
                            id="sale_rate_yn"
                            value={issueReciptedAgoKey.sale_rate_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="recv_qty_yn">Recipted Qty Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="recv_qty_yn"
                            id="recv_qty_yn"
                            value={issueReciptedAgoKey.recv_qty_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="discount_percentage_yn">Discount Percentage Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_percentage_yn"
                            id="discount_percentage_yn"
                            value={issueReciptedAgoKey.discount_percentage_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="grand_total_yn">Grand Total Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="grand_total_yn"
                            id="grand_total_yn"
                            value={issueReciptedAgoKey.grand_total_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_percentage_yn"
                            id="gst_percentage_yn"
                            value={issueReciptedAgoKey.gst_percentage_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <FormGroup>
                          <Label for="rate_after_gst_yn">Rate After gst option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="rate_after_gst_yn"
                            id="rate_after_gst_yn"
                            value={issueReciptedAgoKey.rate_after_gst_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_amount_yn">Total Amount option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_amount_yn"
                            id="total_amount_yn"
                            value={issueReciptedAgoKey.total_amount_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_profit_yn">Total Profit option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_profit_yn"
                            id="total_profit_yn"
                            value={issueReciptedAgoKey.total_profit_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="current_stock_yn">Current Stock option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="current_stock_yn"
                            id="current_stock_yn"
                            value={issueReciptedAgoKey.current_stock_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="balance_qty_yn">Balance Qty option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="balance_qty_yn"
                            id="balance_qty_yn"
                            value={issueReciptedAgoKey.balance_qty_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <FormGroup>
                          <Label for="warranty_period">Warranty Period</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_period"
                            id="warranty_period"
                            value={issueReciptedAgoKey.warranty_period}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_mode">Warranty Mode</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_mode"
                            id="warranty_mode"
                            value={issueReciptedAgoKey.warranty_mode}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="service_visit_count">Service Visit Count</Label>
                          <Input

                            type="select" className="custom-select"
                            name="service_visit_count"
                            id="service_visit_count"
                            value={issueReciptedAgoKey.service_visit_count}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_expiry_date">Warranty Expiry Date</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_expiry_date"
                            id="warranty_expiry_date"
                            value={issueReciptedAgoKey.warranty_expiry_date}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_button">Warranty Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_button"
                            id="warranty_button"
                            value={issueReciptedAgoKey.warranty_button}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="extra_detail_button">Extra Detail Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="extra_detail_button"
                            id="extra_detail_button"
                            value={issueReciptedAgoKey.extra_detail_button}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <h5>Aggrement Detail</h5>
                        <FormGroup>
                          <Label for="brokage_button">Brokage Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="brokage_button"
                            id="brokage_button"
                            value={issueReciptedAgoKey.brokage_button}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="mixed_button">Mixed Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="mixed_button"
                            id="mixed_button"
                            value={issueReciptedAgoKey.mixed_button}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="issuied_qty">Issuied Qty</Label>
                          <Input

                            type="select" className="custom-select"
                            name="issuied_qty"
                            id="issuied_qty"
                            value={issueReciptedAgoKey.issuied_qty}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <h4>Accordion Option</h4>
                        {/* Accordion keyword */}
                        <FormGroup>
                          <Label for="chl_acc_addr_yn">Chl Acc Addr Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_addr_yn"
                            id="chl_acc_addr_yn"
                            value={issueReciptedAgoKey.chl_acc_addr_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_ext_yn">Chl Acc Bill Ext Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_ext_yn"
                            id="chl_acc_bill_ext_yn"
                            value={issueReciptedAgoKey.chl_acc_bill_ext_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_trans_yn">Chl Acc Trans Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_trans_yn"
                            id="chl_acc_trans_yn"
                            value={issueReciptedAgoKey.chl_acc_trans_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_misc_yn">Chl Acc Misc Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_misc_yn"
                            id="chl_acc_misc_yn"
                            value={issueReciptedAgoKey.chl_acc_misc_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_acc_yn">Chl Acc Bill Acc Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_yn"
                            id="chl_acc_bill_acc_yn"
                            value={issueReciptedAgoKey.chl_acc_bill_acc_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_acc_fixed_open_yn">chl acc bill acc fixed open yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_fixed_open_yn"
                            id="chl_acc_bill_acc_fixed_open_yn"
                            value={issueReciptedAgoKey.chl_acc_bill_acc_fixed_open_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_acc_last_record_yn">chl acc bill acc last record yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_last_record_yn"
                            id="chl_acc_bill_acc_last_record_yn"
                            value={issueReciptedAgoKey.chl_acc_bill_acc_last_record_yn}
                            onChange={onChangeIssueSaleHandle("issue_recipted_agr")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                      </div>
                    </div>
                  </div>
                </div>


              </Form>
            </CardBody>
          }

          {/* Issue sale */}
          {flagMaster == "issue_saleww" && <CardBody>
            <Form>
              <div
                className='accordion accordion-flush'
                id='accordionFlushExample1'
              >
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='flush-headingNine'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#flush-collapseFive'
                      aria-expanded='false'
                      aria-controls='flush-collapseFive'
                    >
                      Issue Sale
                    </button>
                  </h2>
                  <div
                    id='flush-collapseFive'
                    className='accordion-collapse collapse'
                    aria-labelledby='flush-headingThree'
                    data-bs-parent='#accordionFlushExample1'
                  >
                    <div className='accordion-body'>

                      <FormGroup>



                        <FormGroup row>

                          <Label for="challan_master_method">Challan Master Show Method</Label>
                          <Col >

                            <Input
                              id="challan_master_method"
                              name="challan_master_method"
                              value={issueSaleKey.challan_master_method}
                              onChange={onChangeIssueSaleHandle("issue_sale")}

                              type="select" className="custom-select"
                            >
                              <option value="">Select</option>
                              <option value="single">Single Entry</option>
                              <option value="aggrement">Aggrement Entry</option>
                              <option value="both">Both</option>


                            </Input>
                          </Col>
                        </FormGroup>

                        <FormGroup>
                          <Col>
                            <Label for="cart_tcs_yn">TCS Value</Label>
                            <Input type="number" name="cart_tcs_value"
                              id="cart_tcs_value"
                              value={typeof issueSaleKey.cart_tcs_value === 'number' ? issueSaleKey.cart_tcs_value.toFixed(3) : issueSaleKey.cart_tcs_value}
                              onChange={onChangeIssueSaleHandle("issue_sale")}

                            />
                          </Col>
                        </FormGroup>

                        <FormGroup>
                          <Label for="sale_method_option">Sale Method</Label>
                          <Input
                            type="select" className="custom-select"
                            name="sale_method_option"
                            id="sale_method_option"
                            value={issueSaleKey.sale_method_option}
                            onChange={onChangeIssueSaleHandle("issue_sale")}

                          >
                            <option value="">select</option>
                            {helperMasterSaleMethodTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="batch_no">Batch/Serial No</Label>
                          <Input
                            type="select" className="custom-select"
                            name="batch_no"
                            id="batch_no"
                            value={issueSaleKey.batch_no}
                            onChange={onChangeIssueSaleHandle("issue_sale")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="style">Style</Label>
                          <Input
                            type="select" className="custom-select"
                            name="style"
                            id="style"
                            value={issueSaleKey.style}
                            onChange={onChangeIssueSaleHandle("issue_sale")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="brand">Multiple Brand Allow</Label>
                          <Input
                            type="select" className="custom-select"
                            name="brand"
                            id="brand"
                            value={issueSaleKey.brand}
                            onChange={onChangeIssueSaleHandle("issue_sale")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="color">Color</Label>
                          <Input
                            type="select" className="custom-select"
                            name="color"
                            id="color"
                            value={issueSaleKey.color}
                            onChange={onChangeIssueSaleHandle("issue_sale")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="agent">Agent</Label>
                          <Input
                            type="select" className="custom-select"
                            name="agent"
                            id="agent"
                            value={issueSaleKey.agent}
                            onChange={onChangeIssueSaleHandle("issue_sale")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="dealer">Dealer</Label>
                          <Input
                            type="select" className="custom-select"
                            name="dealer"
                            id="dealer"
                            value={issueSaleKey.dealer}
                            onChange={onChangeIssueSaleHandle("issue_sale")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="round_off">Round_off</Label>
                          <Input
                            type="select" className="custom-select"
                            name="round_off"
                            id="round_off"
                            value={issueSaleKey.round_off}
                            onChange={onChangeIssueSaleHandle("issue_sale")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="maintain_accounting_yn">Maintain Accounting Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="maintain_accounting_yn"
                            id="maintain_accounting_yn"
                            value={issueSaleKey.maintain_accounting_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="transporter_cartage_yn">Transporter cartage in Bill Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="transporter_cartage_yn"
                            id="transporter_cartage_yn"
                            value={issueSaleKey.transporter_cartage_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <Label for="purchase_rate_yn">Purchase Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="purchase_rate_yn"
                          id="purchase_rate_yn"
                          value={issueSaleKey.purchase_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="profit_yn">Profit Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="profit_yn"
                          id="profit_yn"
                          value={issueSaleKey.profit_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="discount_amount_yn">Discount Amount Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_amount_yn"
                          id="discount_amount_yn"
                          value={issueSaleKey.discount_amount_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="discount_rate_yn">Discount Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_rate_yn"
                          id="discount_rate_yn"
                          value={issueSaleKey.discount_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="gst_amount_yn">Gst Amount Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_amount_yn"
                          id="gst_amount_yn"
                          value={issueSaleKey.gst_amount_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="gst_rate_yn">Gst Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_rate_yn"
                          id="gst_rate_yn"
                          value={issueSaleKey.gst_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_profit_yn">Total Profit Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_profit_yn"
                          id="total_profit_yn"
                          value={issueSaleKey.total_profit_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_weight_yn">Total Weight Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_weight_yn"
                          id="total_weight_yn"
                          value={issueSaleKey.total_weight_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      {/* // =============   add new code ===================== */}





                      <FormGroup>
                        <Label for="hsn_code_yn">HSN Code Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="hsn_code_yn"
                          id="hsn_code_yn"
                          value={issueSaleKey.hsn_code_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="packing_type_yn">Packing Type Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="packing_type_yn"
                          id="packing_type_yn"
                          value={issueSaleKey.packing_type_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="scheme_type_yn">Scheme Type Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="scheme_type_yn"
                          id="scheme_type_yn"
                          value={issueSaleKey.scheme_type_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="remarks_yn">Remark Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="remarks_yn"
                          id="remarks_yn"
                          value={issueSaleKey.remarks_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="sale_rate_yn">Sale Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="sale_rate_yn"
                          id="sale_rate_yn"
                          value={issueSaleKey.sale_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        {/* //sale_qty_yn */}
                        <Label for="issue_qty_yn">Sale Qty Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="issue_qty_yn"
                          id="issue_qty_yn"
                          value={issueSaleKey.issue_qty_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="discount_percentage_yn">Discount Percentage Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_percentage_yn"
                          id="discount_percentage_yn"
                          value={issueSaleKey.discount_percentage_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="grand_total_yn">Grand Total Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="grand_total_yn"
                          id="grand_total_yn"
                          value={issueSaleKey.grand_total_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_percentage_yn"
                          id="gst_percentage_yn"
                          value={issueSaleKey.gst_percentage_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                      <FormGroup>
                        <Label for="rate_after_gst_yn">Rate After gst option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="rate_after_gst_yn"
                          id="rate_after_gst_yn"
                          value={issueSaleKey.rate_after_gst_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_amount_yn">Total Amount option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_amount_yn"
                          id="total_amount_yn"
                          value={issueSaleKey.total_amount_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_profit_yn">Total Profit option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_profit_yn"
                          id="total_profit_yn"
                          value={issueSaleKey.total_profit_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="current_stock_yn">Current Stock option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="current_stock_yn"
                          id="current_stock_yn"
                          value={issueSaleKey.current_stock_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="balance_qty_yn">Balance Qty option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="balance_qty_yn"
                          id="balance_qty_yn"
                          value={issueSaleKey.balance_qty_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>




                      <FormGroup>
                        <Label for="warranty_period">Warranty Period</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_period"
                          id="warranty_period"
                          value={issueSaleKey.warranty_period}
                          onChange={onChangeIssueSaleHandle("issue_sale")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="warranty_mode">Warranty Mode</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_mode"
                          id="warranty_mode"
                          value={issueSaleKey.warranty_mode}
                          onChange={onChangeIssueSaleHandle("issue_sale")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="service_visit_count">Service Visit Count</Label>
                        <Input

                          type="select" className="custom-select"
                          name="service_visit_count"
                          id="service_visit_count"
                          value={issueSaleKey.service_visit_count}
                          onChange={onChangeIssueSaleHandle("issue_sale")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="warranty_expiry_date">Warranty Expiry Date</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_expiry_date"
                          id="warranty_expiry_date"
                          value={issueSaleKey.warranty_expiry_date}
                          onChange={onChangeIssueSaleHandle("issue_sale")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="warranty_button">Warranty Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_button"
                          id="warranty_button"
                          value={issueSaleKey.warranty_button}
                          onChange={onChangeIssueSaleHandle("issue_sale")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="extra_detail_button">Extra Detail Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="extra_detail_button"
                          id="extra_detail_button"
                          value={issueSaleKey.extra_detail_button}
                          onChange={onChangeIssueSaleHandle("issue_sale")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                      <h5>Aggrement Detail</h5>
                      <FormGroup>
                        <Label for="brokage_button">Brokage Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="brokage_button"
                          id="brokage_button"
                          value={issueSaleKey.brokage_button}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="mixed_button">Mixed Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="mixed_button"
                          id="mixed_button"
                          value={issueSaleKey.mixed_button}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="issuied_qty">Issuied Qty</Label>
                        <Input

                          type="select" className="custom-select"
                          name="issuied_qty"
                          id="issuied_qty"
                          value={issueSaleKey.issuied_qty}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <h4>Accordion Option</h4>
                      {/* Accordion keyword */}
                      <FormGroup>
                        <Label for="chl_acc_addr_yn">Chl Acc Addr Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_addr_yn"
                          id="chl_acc_addr_yn"
                          value={issueSaleKey.chl_acc_addr_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_bill_ext_yn">Chl Acc Bill Ext Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_ext_yn"
                          id="chl_acc_bill_ext_yn"
                          value={issueSaleKey.chl_acc_bill_ext_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_trans_yn">Chl Acc Trans Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_trans_yn"
                          id="chl_acc_trans_yn"
                          value={issueSaleKey.chl_acc_trans_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_misc_yn">Chl Acc Misc Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_misc_yn"
                          id="chl_acc_misc_yn"
                          value={issueSaleKey.chl_acc_misc_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_bill_acc_yn">Chl Acc Bill Acc Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_acc_yn"
                          id="chl_acc_bill_acc_yn"
                          value={issueSaleKey.chl_acc_bill_acc_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="chl_acc_bill_acc_fixed_open_yn">chl acc bill acc fixed open yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_acc_fixed_open_yn"
                          id="chl_acc_bill_acc_fixed_open_yn"
                          value={issueSaleKey.chl_acc_bill_acc_fixed_open_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_bill_acc_last_record_yn">chl acc bill acc last record yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_acc_last_record_yn"
                          id="chl_acc_bill_acc_last_record_yn"
                          value={issueSaleKey.chl_acc_bill_acc_last_record_yn}
                          onChange={onChangeIssueSaleHandle("issue_sale")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>








                      {/* <Button
                        className='mt-2'
                        color='primary'
                        onClick={() => { insertIssueDetail("issue_sale") }}
                      >
                        Save
                      </Button> */}
                      {/* <FormGroup>
                        <Label for="transporter_cartage_yn">Transporter cartage in Bill Option</Label>
                        <Input  
                          type="select"  className="custom-select"
                          name="transporter_cartage_yn"
                          id="transporter_cartage_yn"
                          value={System_RecordsData.transporter_cartage_yn}
                          onChange={onChangeHandle}
                        >
                         <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                        </Input>
                      </FormGroup> */}
                    </div>
                  </div>
                </div>
              </div>


            </Form>
          </CardBody>}


          {/* Issue purchase */}
          {flagMaster == "issue_purchaseww" && <CardBody>
            <Form>
              <div
                className='accordion accordion-flush'
                id='accordionFlushExample1'
              >
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='flush-headingFour'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#flush-collapseFour'
                      aria-expanded='false'
                      aria-controls='flush-collapseFour'
                    >
                      Issue Purchase
                    </button>
                  </h2>
                  <div
                    id='flush-collapseFour'
                    className='accordion-collapse collapse'
                    aria-labelledby='flush-headingFour'
                    data-bs-parent='#accordionFlushExample1'
                  >
                    <div className='accordion-body'>


                      <FormGroup row>

                        <Label for="challan_master_method">Challan Master Show Method</Label>
                        <Col >

                          <Input
                            id="challan_master_method"
                            name="challan_master_method"
                            value={issuePurchaseKey.challan_master_method}
                            onChange={onChangeIssueSaleHandle("issue_purchase")}

                            type="select" className="custom-select"
                          >
                            <option value="">Select</option>
                            <option value="single">Single Entry</option>
                            <option value="aggrement">Aggrement Entry</option>
                            <option value="both">Both</option>


                          </Input>
                        </Col>
                      </FormGroup>

                      <FormGroup>
                        <Col>
                          <Label for="cart_tcs_yn">TCS Value</Label>
                          <Input type="number" name="cart_tcs_value"
                            id="cart_tcs_value"
                            value={typeof issuePurchaseKey.cart_tcs_value === 'number' ? issuePurchaseKey.cart_tcs_value.toFixed(3) : issuePurchaseKey.cart_tcs_value}
                            onChange={onChangeIssueSaleHandle("issue_purchase")}
                          />
                        </Col>
                      </FormGroup>

                      <FormGroup>
                        <Label for="sale_method_option">Sale Method</Label>
                        <Input
                          type="select" className="custom-select"
                          name="sale_method_option"
                          id="sale_method_option"
                          value={issuePurchaseKey.sale_method_option}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}

                        >
                          <option value="">select</option>
                          {helperMasterSaleMethodTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="batch_no">Batch/Serial No</Label>
                        <Input
                          type="select" className="custom-select"
                          name="batch_no"
                          id="batch_no"
                          value={issuePurchaseKey.batch_no}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                      <FormGroup>
                        <Label for="style">Style</Label>
                        <Input
                          type="select" className="custom-select"
                          name="style"
                          id="style"
                          value={issuePurchaseKey.style}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                      <FormGroup>
                        <Label for="brand">Multiple Brand Allow</Label>
                        <Input
                          type="select" className="custom-select"
                          name="brand"
                          id="brand"
                          value={issuePurchaseKey.brand}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                      <FormGroup>
                        <Label for="color">Color</Label>
                        <Input
                          type="select" className="custom-select"
                          name="color"
                          id="color"
                          value={issuePurchaseKey.color}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                      <FormGroup>
                        <Label for="agent">Agent</Label>
                        <Input
                          type="select" className="custom-select"
                          name="agent"
                          id="agent"
                          value={issuePurchaseKey.agent}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                      <FormGroup>
                        <Label for="dealer">Dealer</Label>
                        <Input
                          type="select" className="custom-select"
                          name="dealer"
                          id="dealer"
                          value={issuePurchaseKey.dealer}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="round_off">Round_off</Label>
                        <Input
                          type="select" className="custom-select"
                          name="round_off"
                          id="round_off"
                          value={issuePurchaseKey.round_off}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="maintain_accounting_yn">Maintain Accounting Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="maintain_accounting_yn"
                          id="maintain_accounting_yn"
                          value={issuePurchaseKey.maintain_accounting_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="transporter_cartage_yn">Transporter cartage in Bill Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="transporter_cartage_yn"
                          id="transporter_cartage_yn"
                          value={issuePurchaseKey.transporter_cartage_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>






                      <FormGroup>
                        <Label for="purchase_rate_yn">Purchase Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="purchase_rate_yn"
                          id="purchase_rate_yn"
                          value={issuePurchaseKey.purchase_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="profit_yn">Profit Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="profit_yn"
                          id="profit_yn"
                          value={issuePurchaseKey.profit_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="discount_amount_yn">Discount Amount Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_amount_yn"
                          id="discount_amount_yn"
                          value={issuePurchaseKey.discount_amount_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="discount_rate_yn">Discount Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_rate_yn"
                          id="discount_rate_yn"
                          value={issuePurchaseKey.discount_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="gst_amount_yn">Gst Amount Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_amount_yn"
                          id="gst_amount_yn"
                          value={issuePurchaseKey.gst_amount_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="gst_rate_yn">Gst Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_rate_yn"
                          id="gst_rate_yn"
                          value={issuePurchaseKey.gst_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_profit_yn">Total Profit Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_profit_yn"
                          id="total_profit_yn"
                          value={issuePurchaseKey.total_profit_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_weight_yn">Total Weight Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_weight_yn"
                          id="total_weight_yn"
                          value={issuePurchaseKey.total_weight_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                      {/* ////  ====================    addd new code =======================    */}


                      <FormGroup>
                        <Label for="hsn_code_yn">HSN Code Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="hsn_code_yn"
                          id="hsn_code_yn"
                          value={issuePurchaseKey.hsn_code_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="packing_type_yn">Packing Type Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="packing_type_yn"
                          id="packing_type_yn"
                          value={issuePurchaseKey.packing_type_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="scheme_type_yn">Scheme Type Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="scheme_type_yn"
                          id="scheme_type_yn"
                          value={issuePurchaseKey.scheme_type_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="remarks_yn">Remark Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="remarks_yn"
                          id="remarks_yn"
                          value={issuePurchaseKey.remarks_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="sale_rate_yn">Sale Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="sale_rate_yn"
                          id="sale_rate_yn"
                          value={issuePurchaseKey.sale_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        {/* purchase_qty_yn */}
                        <Label for="issue_qty_yn">Purchase Qty Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="issue_qty_yn"
                          id="issue_qty_yn"
                          value={issuePurchaseKey.issue_qty_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="discount_percentage_yn">Discount Percentage Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_percentage_yn"
                          id="discount_percentage_yn"
                          value={issuePurchaseKey.discount_percentage_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="grand_total_yn">Grand Total Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="grand_total_yn"
                          id="grand_total_yn"
                          value={issuePurchaseKey.grand_total_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_percentage_yn"
                          id="gst_percentage_yn"
                          value={issuePurchaseKey.gst_percentage_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                      <FormGroup>
                        <Label for="rate_after_gst_yn">Rate After gst option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="rate_after_gst_yn"
                          id="rate_after_gst_yn"
                          value={issuePurchaseKey.rate_after_gst_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_amount_yn">Total Amount option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_amount_yn"
                          id="total_amount_yn"
                          value={issuePurchaseKey.total_amount_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_profit_yn">Total Profit option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_profit_yn"
                          id="total_profit_yn"
                          value={issuePurchaseKey.total_profit_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="current_stock_yn">Current Stock option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="current_stock_yn"
                          id="current_stock_yn"
                          value={issuePurchaseKey.current_stock_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="balance_qty_yn">Balance Qty option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="balance_qty_yn"
                          id="balance_qty_yn"
                          value={issuePurchaseKey.balance_qty_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>




                      <FormGroup>
                        <Label for="warranty_period">Warranty Period</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_period"
                          id="warranty_period"
                          value={issuePurchaseKey.warranty_period}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="warranty_mode">Warranty Mode</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_mode"
                          id="warranty_mode"
                          value={issuePurchaseKey.warranty_mode}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="service_visit_count">Service Visit Count</Label>
                        <Input

                          type="select" className="custom-select"
                          name="service_visit_count"
                          id="service_visit_count"
                          value={issuePurchaseKey.service_visit_count}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="warranty_expiry_date">Warranty Expiry Date</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_expiry_date"
                          id="warranty_expiry_date"
                          value={issuePurchaseKey.warranty_expiry_date}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="warranty_button">Warranty Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_button"
                          id="warranty_button"
                          value={issuePurchaseKey.warranty_button}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="extra_detail_button">Extra Detail Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="extra_detail_button"
                          id="extra_detail_button"
                          value={issuePurchaseKey.extra_detail_button}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <h5>Aggrement Detail</h5>
                      <FormGroup>
                        <Label for="brokage_button">Brokage Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="brokage_button"
                          id="brokage_button"
                          value={issuePurchaseKey.brokage_button}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="mixed_button">Mixed Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="mixed_button"
                          id="mixed_button"
                          value={issuePurchaseKey.mixed_button}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="issuied_qty">Issuied Qty</Label>
                        <Input

                          type="select" className="custom-select"
                          name="issuied_qty"
                          id="issuied_qty"
                          value={issuePurchaseKey.issuied_qty}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <h4>Accordion Option</h4>
                      {/* Accordion keyword */}
                      <FormGroup>
                        <Label for="chl_acc_addr_yn">Chl Acc Addr Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_addr_yn"
                          id="chl_acc_addr_yn"
                          value={issuePurchaseKey.chl_acc_addr_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_bill_ext_yn">Chl Acc Bill Ext Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_ext_yn"
                          id="chl_acc_bill_ext_yn"
                          value={issuePurchaseKey.chl_acc_bill_ext_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_trans_yn">Chl Acc Trans Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_trans_yn"
                          id="chl_acc_trans_yn"
                          value={issuePurchaseKey.chl_acc_trans_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_misc_yn">Chl Acc Misc Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_misc_yn"
                          id="chl_acc_misc_yn"
                          value={issuePurchaseKey.chl_acc_misc_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_bill_acc_yn">Chl Acc Bill Acc Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_acc_yn"
                          id="chl_acc_bill_acc_yn"
                          value={issuePurchaseKey.chl_acc_bill_acc_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="chl_acc_bill_acc_fixed_open_yn">chl acc bill acc fixed open yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_acc_fixed_open_yn"
                          id="chl_acc_bill_acc_fixed_open_yn"
                          value={issuePurchaseKey.chl_acc_bill_acc_fixed_open_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_bill_acc_last_record_yn">chl acc bill acc last record yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_acc_last_record_yn"
                          id="chl_acc_bill_acc_last_record_yn"
                          value={issuePurchaseKey.chl_acc_bill_acc_last_record_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                    </div>
                  </div>
                </div>
              </div>


            </Form>
          </CardBody>}

          {/* Issue  sale return  */}
          {flagMaster == "issue_sale_returnww" &&
            <CardBody>
              <Form>
                <div
                  className='accordion accordion-flush'
                  id='accordionFlushExample1'
                >
                  <div className='accordion-item'>
                    <h2 className='accordion-header' id='flush-headingNine'>
                      <button
                        className='accordion-button collapsed'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#flush-collapseNine'
                        aria-expanded='false'
                        aria-controls='flush-collapseNine'
                      >
                        Issue Sale Return
                      </button>
                    </h2>
                    <div
                      id='flush-collapseNine'
                      className='accordion-collapse collapse'
                      aria-labelledby='flush-headingNine'
                      data-bs-parent='#accordionFlushExample1'
                    >
                      <div className='accordion-body'>

                        <FormGroup>
                          <FormGroup row>
                            <Label for="challan_master_method">Challan Master Show Method</Label>
                            <Col >

                              <Input
                                id="challan_master_method"
                                name="challan_master_method"
                                value={issueSaleReturnKey.challan_master_method}
                                onChange={onChangeIssueSaleHandle("issue_sale_return")}

                                type="select" className="custom-select"
                              >
                                <option value="">Select</option>
                                <option value="single">Single Entry</option>
                                <option value="aggrement">Aggrement Entry</option>
                                <option value="both">Both</option>


                              </Input>
                            </Col>
                          </FormGroup>

                          <FormGroup>
                            <Col>
                              <Label for="cart_tcs_yn">TCS Value</Label>
                              <Input type="number" name="cart_tcs_value"
                                id="cart_tcs_value"
                                value={typeof issueSaleReturnKey.cart_tcs_value === 'number' ? issueSaleReturnKey.cart_tcs_value.toFixed(3) : issueSaleReturnKey.cart_tcs_value}
                                onChange={onChangeIssueSaleHandle("issue_sale_return")} />
                            </Col>
                          </FormGroup>

                          <FormGroup>
                            <Label for="sale_method_option">Sale Method</Label>
                            <Input
                              type="select" className="custom-select"
                              name="sale_method_option"
                              id="sale_method_option"
                              value={issueSaleReturnKey.sale_method_option}
                              onChange={onChangeIssueSaleHandle("issue_sale_return")}

                            >
                              <option value="">select</option>
                              {helperMasterSaleMethodTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>


                          <FormGroup>
                            <Label for="batch_no">Batch/Serial No</Label>
                            <Input
                              type="select" className="custom-select"
                              name="batch_no"
                              id="batch_no"
                              value={issueSaleReturnKey.batch_no}
                              onChange={onChangeIssueSaleHandle("issue_sale_return")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="style">Style</Label>
                            <Input
                              type="select" className="custom-select"
                              name="style"
                              id="style"
                              value={issueSaleReturnKey.style}
                              onChange={onChangeIssueSaleHandle("issue_sale_return")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="brand">Multiple Brand Allow</Label>
                            <Input
                              type="select" className="custom-select"
                              name="brand"
                              id="brand"
                              value={issueSaleReturnKey.brand}
                              onChange={onChangeIssueSaleHandle("issue_sale_return")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="color">Color</Label>
                            <Input
                              type="select" className="custom-select"
                              name="color"
                              id="color"
                              value={issueSaleReturnKey.color}
                              onChange={onChangeIssueSaleHandle("issue_sale_return")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="agent">Agent</Label>
                            <Input
                              type="select" className="custom-select"
                              name="agent"
                              id="agent"
                              value={issueSaleReturnKey.agent}
                              onChange={onChangeIssueSaleHandle("issue_sale_return")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="dealer">Dealer</Label>
                            <Input
                              type="select" className="custom-select"
                              name="dealer"
                              id="dealer"
                              value={issueSaleReturnKey.dealer}
                              onChange={onChangeIssueSaleHandle("issue_sale_return")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>


                          <FormGroup>
                            <Label for="round_off">Round_off</Label>
                            <Input
                              type="select" className="custom-select"
                              name="round_off"
                              id="round_off"
                              value={issueSaleReturnKey.round_off}
                              onChange={onChangeIssueSaleHandle("issue_sale_return")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <FormGroup>
                            <Label for="maintain_accounting_yn">Maintain Accounting Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="maintain_accounting_yn"
                              id="maintain_accounting_yn"
                              value={issueSaleReturnKey.maintain_accounting_yn}
                              onChange={onChangeIssueSaleHandle("issue_sale_return")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <FormGroup>
                            <Label for="transporter_cartage_yn">Transporter cartage in Bill Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="transporter_cartage_yn"
                              id="transporter_cartage_yn"
                              value={issueSaleReturnKey.transporter_cartage_yn}
                              onChange={onChangeIssueSaleHandle("issue_sale_return")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <Label for="purchase_rate_yn">Purchase Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="purchase_rate_yn"
                            id="purchase_rate_yn"
                            value={issueSaleReturnKey.purchase_rate_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="profit_yn">Profit Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="profit_yn"
                            id="profit_yn"
                            value={issueSaleReturnKey.profit_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="discount_amount_yn">Discount Amount Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_amount_yn"
                            id="discount_amount_yn"
                            value={issueSaleReturnKey.discount_amount_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="discount_rate_yn">Discount Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_rate_yn"
                            id="discount_rate_yn"
                            value={issueSaleReturnKey.discount_rate_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="gst_amount_yn">Gst Amount Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_amount_yn"
                            id="gst_amount_yn"
                            value={issueSaleReturnKey.gst_amount_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="gst_rate_yn">Gst Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_rate_yn"
                            id="gst_rate_yn"
                            value={issueSaleReturnKey.gst_rate_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_profit_yn">Total Profit Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_profit_yn"
                            id="total_profit_yn"
                            value={issueSaleReturnKey.total_profit_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_weight_yn">Total Weight Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_weight_yn"
                            id="total_weight_yn"
                            value={issueSaleReturnKey.total_weight_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        {/* // =============   add new code ===================== */}





                        <FormGroup>
                          <Label for="hsn_code_yn">HSN Code Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="hsn_code_yn"
                            id="hsn_code_yn"
                            value={issueSaleReturnKey.hsn_code_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="packing_type_yn">Packing Type Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="packing_type_yn"
                            id="packing_type_yn"
                            value={issueSaleReturnKey.packing_type_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="scheme_type_yn">Scheme Type Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="scheme_type_yn"
                            id="scheme_type_yn"
                            value={issueSaleReturnKey.scheme_type_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="remarks_yn">Remark Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="remarks_yn"
                            id="remarks_yn"
                            value={issueSaleReturnKey.remarks_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="sale_rate_yn">Sale Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="sale_rate_yn"
                            id="sale_rate_yn"
                            value={issueSaleReturnKey.sale_rate_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          {/* //sale_qty_yn */}
                          <Label for="issue_qty_yn">Sale Qty Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="issue_qty_yn"
                            id="issue_qty_yn"
                            value={issueSaleReturnKey.issue_qty_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="discount_percentage_yn">Discount Percentage Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_percentage_yn"
                            id="discount_percentage_yn"
                            value={issueSaleReturnKey.discount_percentage_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="grand_total_yn">Grand Total Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="grand_total_yn"
                            id="grand_total_yn"
                            value={issueSaleReturnKey.grand_total_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_percentage_yn"
                            id="gst_percentage_yn"
                            value={issueSaleReturnKey.gst_percentage_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <FormGroup>
                          <Label for="rate_after_gst_yn">Rate After gst option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="rate_after_gst_yn"
                            id="rate_after_gst_yn"
                            value={issueSaleReturnKey.rate_after_gst_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_amount_yn">Total Amount option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_amount_yn"
                            id="total_amount_yn"
                            value={issueSaleReturnKey.total_amount_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_profit_yn">Total Profit option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_profit_yn"
                            id="total_profit_yn"
                            value={issueSaleReturnKey.total_profit_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="current_stock_yn">Current Stock option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="current_stock_yn"
                            id="current_stock_yn"
                            value={issueSaleReturnKey.current_stock_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="balance_qty_yn">Balance Qty option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="balance_qty_yn"
                            id="balance_qty_yn"
                            value={issueSaleReturnKey.balance_qty_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="warranty_period">Warranty Period</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_period"
                            id="warranty_period"
                            value={issueSaleReturnKey.warranty_period}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_mode">Warranty Mode</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_mode"
                            id="warranty_mode"
                            value={issueSaleReturnKey.warranty_mode}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="service_visit_count">Service Visit Count</Label>
                          <Input

                            type="select" className="custom-select"
                            name="service_visit_count"
                            id="service_visit_count"
                            value={issueSaleReturnKey.service_visit_count}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_expiry_date">Warranty Expiry Date</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_expiry_date"
                            id="warranty_expiry_date"
                            value={issueSaleReturnKey.warranty_expiry_date}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_button">Warranty Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_button"
                            id="warranty_button"
                            value={issueSaleReturnKey.warranty_button}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="extra_detail_button">Extra Detail Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="extra_detail_button"
                            id="extra_detail_button"
                            value={issueSaleReturnKey.extra_detail_button}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <h5>Aggrement Detail</h5>
                        <FormGroup>
                          <Label for="brokage_button">Brokage Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="brokage_button"
                            id="brokage_button"
                            value={issueSaleReturnKey.brokage_button}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="mixed_button">Mixed Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="mixed_button"
                            id="mixed_button"
                            value={issueSaleReturnKey.mixed_button}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="issuied_qty">Issuied Qty</Label>
                          <Input

                            type="select" className="custom-select"
                            name="issuied_qty"
                            id="issuied_qty"
                            value={issueSaleReturnKey.issuied_qty}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <h4>Accordion Option</h4>
                        {/* Accordion keyword */}
                        <FormGroup>
                          <Label for="chl_acc_addr_yn">Chl Acc Addr Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_addr_yn"
                            id="chl_acc_addr_yn"
                            value={issueSaleReturnKey.chl_acc_addr_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_ext_yn">Chl Acc Bill Ext Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_ext_yn"
                            id="chl_acc_bill_ext_yn"
                            value={issueSaleReturnKey.chl_acc_bill_ext_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_trans_yn">Chl Acc Trans Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_trans_yn"
                            id="chl_acc_trans_yn"
                            value={issueSaleReturnKey.chl_acc_trans_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_misc_yn">Chl Acc Misc Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_misc_yn"
                            id="chl_acc_misc_yn"
                            value={issueSaleReturnKey.chl_acc_misc_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_acc_yn">Chl Acc Bill Acc Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_yn"
                            id="chl_acc_bill_acc_yn"
                            value={issueSaleReturnKey.chl_acc_bill_acc_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="chl_acc_bill_acc_fixed_open_yn">chl acc bill acc fixed open yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_fixed_open_yn"
                            id="chl_acc_bill_acc_fixed_open_yn"
                            value={issueSaleReturnKey.chl_acc_bill_acc_fixed_open_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_acc_last_record_yn">chl acc bill acc last record yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_last_record_yn"
                            id="chl_acc_bill_acc_last_record_yn"
                            value={issueSaleReturnKey.chl_acc_bill_acc_last_record_yn}
                            onChange={onChangeIssueSaleHandle("issue_sale_return")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>





                        {/* <Button
                        className='mt-2'
                        color='primary'
                        onClick={() => { insertIssueDetail("issue_sale") }}
                      >
                        Save
                      </Button> */}
                        {/* <FormGroup>
                        <Label for="transporter_cartage_yn">Transporter cartage in Bill Option</Label>
                        <Input  
                          type="select"  className="custom-select"
                          name="transporter_cartage_yn"
                          id="transporter_cartage_yn"
                          value={System_RecordsData.transporter_cartage_yn}
                          onChange={onChangeHandle}
                        >
                         <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                        </Input>
                      </FormGroup> */}
                      </div>
                    </div>
                  </div>
                </div>


              </Form>
            </CardBody>}

          {/* Issue  purchase return  */}
          {flagMaster == "issue_purchase_returnww" && <CardBody>
            <Form>
              <div
                className='accordion accordion-flush'
                id='accordionFlushExample1'
              >
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='flush-headingTen'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#flush-collapseTen'
                      aria-expanded='false'
                      aria-controls='flush-collapseTen'
                    >
                      Issue Purchase Return
                    </button>
                  </h2>
                  <div
                    id='flush-collapseTen'
                    className='accordion-collapse collapse'
                    aria-labelledby='flush-headingTen'
                    data-bs-parent='#accordionFlushExample1'
                  >
                    <div className='accordion-body'>

                      <FormGroup>
                        <FormGroup row>
                          <Label for="challan_master_method">Challan Master Show Method</Label>
                          <Col >

                            <Input
                              id="challan_master_method"
                              name="challan_master_method"
                              value={issuePurchaseReturnKey.challan_master_method}
                              onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                              type="select" className="custom-select"
                            >
                              <option value="">Select</option>
                              <option value="single">Single Entry</option>
                              <option value="aggrement">Aggrement Entry</option>
                              <option value="both">Both</option>


                            </Input>
                          </Col>
                        </FormGroup>

                        <FormGroup>
                          <Col>
                            <Label for="cart_tcs_yn">TCS Value</Label>
                            <Input type="number" name="cart_tcs_value"
                              id="cart_tcs_value"
                              value={typeof issuePurchaseReturnKey.cart_tcs_value === 'number' ? issuePurchaseReturnKey.cart_tcs_value.toFixed(3) : issuePurchaseReturnKey.cart_tcs_value}
                              onChange={onChangeIssueSaleHandle("issue_purchase_return")} />
                          </Col>
                        </FormGroup>

                        <FormGroup>
                          <Label for="sale_method_option">Sale Method</Label>
                          <Input
                            type="select" className="custom-select"
                            name="sale_method_option"
                            id="sale_method_option"
                            value={issuePurchaseReturnKey.sale_method_option}
                            onChange={onChangeIssueSaleHandle("issue_purchase_return")}

                          >
                            <option value="">select</option>
                            {helperMasterSaleMethodTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="batch_no">Batch/Serial No</Label>
                          <Input
                            type="select" className="custom-select"
                            name="batch_no"
                            id="batch_no"
                            value={issuePurchaseReturnKey.batch_no}
                            onChange={onChangeIssueSaleHandle("issue_purchase_return")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="style">Style</Label>
                          <Input
                            type="select" className="custom-select"
                            name="style"
                            id="style"
                            value={issuePurchaseReturnKey.style}
                            onChange={onChangeIssueSaleHandle("issue_purchase_return")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="brand">Multiple Brand Allow</Label>
                          <Input
                            type="select" className="custom-select"
                            name="brand"
                            id="brand"
                            value={issuePurchaseReturnKey.brand}
                            onChange={onChangeIssueSaleHandle("issue_purchase_return")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="color">Color</Label>
                          <Input
                            type="select" className="custom-select"
                            name="color"
                            id="color"
                            value={issuePurchaseReturnKey.color}
                            onChange={onChangeIssueSaleHandle("issue_purchase_return")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="agent">Agent</Label>
                          <Input
                            type="select" className="custom-select"
                            name="agent"
                            id="agent"
                            value={issuePurchaseReturnKey.agent}
                            onChange={onChangeIssueSaleHandle("issue_purchase_return")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="dealer">Dealer</Label>
                          <Input
                            type="select" className="custom-select"
                            name="dealer"
                            id="dealer"
                            value={issuePurchaseReturnKey.dealer}
                            onChange={onChangeIssueSaleHandle("issue_purchase_return")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="round_off">Round_off</Label>
                          <Input
                            type="select" className="custom-select"
                            name="round_off"
                            id="round_off"
                            value={issuePurchaseReturnKey.round_off}
                            onChange={onChangeIssueSaleHandle("issue_purchase_return")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="maintain_accounting_yn">Maintain Accounting Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="maintain_accounting_yn"
                            id="maintain_accounting_yn"
                            value={issuePurchaseReturnKey.maintain_accounting_yn}
                            onChange={onChangeIssueSaleHandle("issue_purchase_return")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="transporter_cartage_yn">Transporter cartage in Bill Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="transporter_cartage_yn"
                            id="transporter_cartage_yn"
                            value={issuePurchaseReturnKey.transporter_cartage_yn}
                            onChange={onChangeIssueSaleHandle("issue_purchase_return")}

                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <Label for="purchase_rate_yn">Purchase Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="purchase_rate_yn"
                          id="purchase_rate_yn"
                          value={issuePurchaseReturnKey.purchase_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="profit_yn">Profit Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="profit_yn"
                          id="profit_yn"
                          value={issuePurchaseReturnKey.profit_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="discount_amount_yn">Discount Amount Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_amount_yn"
                          id="discount_amount_yn"
                          value={issuePurchaseReturnKey.discount_amount_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="discount_rate_yn">Discount Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_rate_yn"
                          id="discount_rate_yn"
                          value={issuePurchaseReturnKey.discount_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="gst_amount_yn">Gst Amount Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_amount_yn"
                          id="gst_amount_yn"
                          value={issuePurchaseReturnKey.gst_amount_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="gst_rate_yn">Gst Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_rate_yn"
                          id="gst_rate_yn"
                          value={issuePurchaseReturnKey.gst_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_profit_yn">Total Profit Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_profit_yn"
                          id="total_profit_yn"
                          value={issuePurchaseReturnKey.total_profit_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_weight_yn">Total Weight Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_weight_yn"
                          id="total_weight_yn"
                          value={issuePurchaseReturnKey.total_weight_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      {/* // =============   add new code ===================== */}





                      <FormGroup>
                        <Label for="hsn_code_yn">HSN Code Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="hsn_code_yn"
                          id="hsn_code_yn"
                          value={issuePurchaseReturnKey.hsn_code_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="packing_type_yn">Packing Type Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="packing_type_yn"
                          id="packing_type_yn"
                          value={issuePurchaseReturnKey.packing_type_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="scheme_type_yn">Scheme Type Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="scheme_type_yn"
                          id="scheme_type_yn"
                          value={issuePurchaseReturnKey.scheme_type_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="remarks_yn">Remark Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="remarks_yn"
                          id="remarks_yn"
                          value={issuePurchaseReturnKey.remarks_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="sale_rate_yn">Sale Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="sale_rate_yn"
                          id="sale_rate_yn"
                          value={issuePurchaseReturnKey.sale_rate_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        {/* //sale_qty_yn */}
                        <Label for="issue_qty_yn">Sale Qty Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="issue_qty_yn"
                          id="issue_qty_yn"
                          value={issuePurchaseReturnKey.issue_qty_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="discount_percentage_yn">Discount Percentage Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_percentage_yn"
                          id="discount_percentage_yn"
                          value={issuePurchaseReturnKey.discount_percentage_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="grand_total_yn">Grand Total Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="grand_total_yn"
                          id="grand_total_yn"
                          value={issuePurchaseReturnKey.grand_total_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_percentage_yn"
                          id="gst_percentage_yn"
                          value={issuePurchaseReturnKey.gst_percentage_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                      <FormGroup>
                        <Label for="rate_after_gst_yn">Rate After gst option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="rate_after_gst_yn"
                          id="rate_after_gst_yn"
                          value={issuePurchaseReturnKey.rate_after_gst_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_amount_yn">Total Amount option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_amount_yn"
                          id="total_amount_yn"
                          value={issuePurchaseReturnKey.total_amount_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_profit_yn">Total Profit option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_profit_yn"
                          id="total_profit_yn"
                          value={issuePurchaseReturnKey.total_profit_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="current_stock_yn">Current Stock option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="current_stock_yn"
                          id="current_stock_yn"
                          value={issuePurchaseReturnKey.current_stock_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="balance_qty_yn">Balance Qty option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="balance_qty_yn"
                          id="balance_qty_yn"
                          value={issuePurchaseReturnKey.balance_qty_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                      <FormGroup>
                        <Label for="warranty_period">Warranty Period</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_period"
                          id="warranty_period"
                          value={issuePurchaseReturnKey.warranty_period}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="warranty_mode">Warranty Mode</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_mode"
                          id="warranty_mode"
                          value={issuePurchaseReturnKey.warranty_mode}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="service_visit_count">Service Visit Count</Label>
                        <Input

                          type="select" className="custom-select"
                          name="service_visit_count"
                          id="service_visit_count"
                          value={issuePurchaseReturnKey.service_visit_count}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="warranty_expiry_date">Warranty Expiry Date</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_expiry_date"
                          id="warranty_expiry_date"
                          value={issuePurchaseReturnKey.warranty_expiry_date}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="warranty_button">Warranty Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="warranty_button"
                          id="warranty_button"
                          value={issuePurchaseReturnKey.warranty_button}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="extra_detail_button">Extra Detail Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="extra_detail_button"
                          id="extra_detail_button"
                          value={issuePurchaseReturnKey.extra_detail_button}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}

                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>




                      <h5>Aggrement Detail</h5>
                      <FormGroup>
                        <Label for="brokage_button">Brokage Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="brokage_button"
                          id="brokage_button"
                          value={issuePurchaseReturnKey.brokage_button}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="mixed_button">Mixed Button</Label>
                        <Input

                          type="select" className="custom-select"
                          name="mixed_button"
                          id="mixed_button"
                          value={issuePurchaseReturnKey.mixed_button}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="issuied_qty">Issuied Qty</Label>
                        <Input

                          type="select" className="custom-select"
                          name="issuied_qty"
                          id="issuied_qty"
                          value={issuePurchaseReturnKey.issuied_qty}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                      <h4>Accordion Option</h4>
                      {/* Accordion keyword */}
                      <FormGroup>
                        <Label for="chl_acc_addr_yn">Chl Acc Addr Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_addr_yn"
                          id="chl_acc_addr_yn"
                          value={issuePurchaseReturnKey.chl_acc_addr_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_bill_ext_yn">Chl Acc Bill Ext Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_ext_yn"
                          id="chl_acc_bill_ext_yn"
                          value={issuePurchaseReturnKey.chl_acc_bill_ext_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_trans_yn">Chl Acc Trans Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_trans_yn"
                          id="chl_acc_trans_yn"
                          value={issuePurchaseReturnKey.chl_acc_trans_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_misc_yn">Chl Acc Misc Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_misc_yn"
                          id="chl_acc_misc_yn"
                          value={issuePurchaseReturnKey.chl_acc_misc_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_bill_acc_yn">Chl Acc Bill Acc Yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_acc_yn"
                          id="chl_acc_bill_acc_yn"
                          value={issuePurchaseReturnKey.chl_acc_bill_acc_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="chl_acc_bill_acc_fixed_open_yn">chl acc bill acc fixed open yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_acc_fixed_open_yn"
                          id="chl_acc_bill_acc_fixed_open_yn"
                          value={issuePurchaseReturnKey.chl_acc_bill_acc_fixed_open_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="chl_acc_bill_acc_last_record_yn">chl acc bill acc last record yn</Label>
                        <Input

                          type="select" className="custom-select"
                          name="chl_acc_bill_acc_last_record_yn"
                          id="chl_acc_bill_acc_last_record_yn"
                          value={issuePurchaseReturnKey.chl_acc_bill_acc_last_record_yn}
                          onChange={onChangeIssueSaleHandle("issue_purchase_return")}
                        >
                          <option value="">Select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>





                      {/* <Button
                        className='mt-2'
                        color='primary'
                        onClick={() => { insertIssueDetail("issue_sale") }}
                      >
                        Save
                      </Button> */}
                      {/* <FormGroup>
                        <Label for="transporter_cartage_yn">Transporter cartage in Bill Option</Label>
                        <Input  
                          type="select"  className="custom-select"
                          name="transporter_cartage_yn"
                          id="transporter_cartage_yn"
                          value={System_RecordsData.transporter_cartage_yn}
                          onChange={onChangeHandle}
                        >
                         <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                        </Input>
                      </FormGroup> */}
                    </div>
                  </div>
                </div>
              </div>


            </Form>
          </CardBody>}

          {/* Issue challan Optical Single */}
          {
            flagMaster == "issue_challan_opticalww" && <CardBody>
              <Form>

                <div
                  className='accordion accordion-flush'
                  id='accordionFlushExample1'
                >
                  <div className='accordion-item'>
                    <h2 className='accordion-header' id='flush-headingSix1'>
                      <button
                        className='accordion-button collapsed'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#flush-collapseSix1'
                        aria-expanded='false'
                        aria-controls='flush-collapseSix1'
                      >
                        {"Optical Ch. { General }"}
                      </button>
                    </h2>
                    <div
                      id='flush-collapseSix1'
                      className='accordion-collapse collapse'
                      aria-labelledby='flush-headingSix1'
                      data-bs-parent='#accordionFlushExample1'
                    >
                      <div className='accordion-body'>
                        <FormGroup>

                          <FormGroup row>
                            <Label for="challan_master_method">Challan Master Show Method</Label>
                            <Col >

                              <Input
                                id="challan_master_method"
                                name="challan_master_method"
                                value={issueChallanOpticalKey.challan_master_method}
                                onChange={onChangeIssueSaleHandle("issue_challan_optical")}

                                type="select" className="custom-select"
                              >
                                <option value="">Select</option>
                                <option value="single">Single Entry</option>
                                <option value="aggrement">Aggrement Entry</option>
                                <option value="both">Both</option>


                              </Input>
                            </Col>
                          </FormGroup>

                          <FormGroup>
                            <Col>
                              <Label for="cart_tcs_yn">TCS Value</Label>
                              <Input type="number" name="cart_tcs_value"
                                id="cart_tcs_value"
                                value={typeof issueChallanOpticalKey.cart_tcs_value === 'number' ? issueChallanOpticalKey.cart_tcs_value.toFixed(3) : issueChallanOpticalKey.cart_tcs_value}
                                onChange={onChangeIssueSaleHandle("issue_challan_optical")}

                              />
                            </Col>
                          </FormGroup>

                          <FormGroup>
                            <Label for="sale_method_option">Sale Method</Label>
                            <Input
                              type="select" className="custom-select"
                              name="sale_method_option"
                              id="sale_method_option"
                              value={issueChallanOpticalKey.sale_method_option}
                              onChange={onChangeIssueSaleHandle("issue_challan_optical")}

                            >
                              <option value="">select</option>
                              {helperMasterSaleMethodTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>




                          <FormGroup>
                            <Label for="batch_no">Batch/Serial No</Label>
                            <Input
                              type="select" className="custom-select"
                              name="batch_no"
                              id="batch_no"
                              value={issueChallanOpticalKey.batch_no}
                              onChange={onChangeIssueSaleHandle("issue_challan_optical")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="style">Style</Label>
                            <Input
                              type="select" className="custom-select"
                              name="style"
                              id="style"
                              value={issueChallanOpticalKey.style}
                              onChange={onChangeIssueSaleHandle("issue_challan_optical")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="brand">Multiple Brand Allow</Label>
                            <Input
                              type="select" className="custom-select"
                              name="brand"
                              id="brand"
                              value={issueChallanOpticalKey.brand}
                              onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                            >

                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                              {/* <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))} */}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="color">Color</Label>
                            <Input
                              type="select" className="custom-select"
                              name="color"
                              id="color"
                              value={issueChallanOpticalKey.color}
                              onChange={onChangeIssueSaleHandle("issue_challan_optical")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="agent">Agent</Label>
                            <Input
                              type="select" className="custom-select"
                              name="agent"
                              id="agent"
                              value={issueChallanOpticalKey.agent}
                              onChange={onChangeIssueSaleHandle("issue_challan_optical")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label for="dealer">Dealer</Label>
                            <Input
                              type="select" className="custom-select"
                              name="dealer"
                              id="dealer"
                              value={issueChallanOpticalKey.dealer}
                              onChange={onChangeIssueSaleHandle("issue_challan_optical")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>


                          <FormGroup>
                            <Label for="round_off">Round_off</Label>
                            <Input
                              type="select" className="custom-select"
                              name="round_off"
                              id="round_off"
                              value={issueChallanOpticalKey.round_off}
                              onChange={onChangeIssueSaleHandle("issue_challan_optical")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <FormGroup>
                            <Label for="maintain_accounting_yn">Maintain Accounting Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="maintain_accounting_yn"
                              id="maintain_accounting_yn"
                              value={issueChallanOpticalKey.maintain_accounting_yn}
                              onChange={onChangeIssueSaleHandle("issue_challan_optical")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <FormGroup>
                            <Label for="transporter_cartage_yn">Transporter cartage in Bill Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="transporter_cartage_yn"
                              id="transporter_cartage_yn"
                              value={issueChallanOpticalKey.transporter_cartage_yn}
                              onChange={onChangeIssueSaleHandle("issue_challan_optical")}

                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                          <Label for="purchase_rate_yn">Purchase Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="purchase_rate_yn"
                            id="purchase_rate_yn"
                            value={issueChallanOpticalKey.purchase_rate_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="profit_yn">Profit Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="profit_yn"
                            id="profit_yn"
                            value={issueChallanOpticalKey.profit_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="discount_amount_yn">Discount Amount Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_amount_yn"
                            id="discount_amount_yn"
                            value={issueChallanOpticalKey.discount_amount_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="discount_rate_yn">Discount Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_rate_yn"
                            id="discount_rate_yn"
                            value={issueChallanOpticalKey.discount_rate_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="gst_amount_yn">Gst Amount Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_amount_yn"
                            id="gst_amount_yn"
                            value={issueChallanOpticalKey.gst_amount_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="gst_rate_yn">Gst Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_rate_yn"
                            id="gst_rate_yn"
                            value={issueChallanOpticalKey.gst_rate_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_profit_yn">Total Profit Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_profit_yn"
                            id="total_profit_yn"
                            value={issueChallanOpticalKey.total_profit_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_weight_yn">Total Weight Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_weight_yn"
                            id="total_weight_yn"
                            value={issueChallanOpticalKey.total_weight_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>




                        {/* ///////////// new code add  */}
                        <FormGroup>
                          <Label for="hsn_code_yn">HSN Code Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="hsn_code_yn"
                            id="hsn_code_yn"
                            value={issueChallanOpticalKey.hsn_code_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="packing_type_yn">Packing Type Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="packing_type_yn"
                            id="packing_type_yn"
                            value={issueChallanOpticalKey.packing_type_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="scheme_type_yn">Scheme Type Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="scheme_type_yn"
                            id="scheme_type_yn"
                            value={issueChallanOpticalKey.scheme_type_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="remarks_yn">Remark Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="remarks_yn"
                            id="remarks_yn"
                            value={issueChallanOpticalKey.remarks_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="sale_rate_yn">Sale Rate Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="sale_rate_yn"
                            id="sale_rate_yn"
                            value={issueChallanOpticalKey.sale_rate_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          {/* //sale_qty_yn */}
                          <Label for="issue_qty_yn"> Issue Qty Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="issue_qty_yn"
                            id="issue_qty_yn"
                            value={issueChallanOpticalKey.issue_qty_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>




                        <FormGroup>
                          <Label for="recv_qty_yn">Receive Qty Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="recv_qty_yn"
                            id="recv_qty_yn"
                            value={issueChallanOpticalKey.recv_qty_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="discount_percentage_yn">Discount Percentage Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="discount_percentage_yn"
                            id="discount_percentage_yn"
                            value={issueChallanOpticalKey.discount_percentage_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="grand_total_yn">Grand Total Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="grand_total_yn"
                            id="grand_total_yn"
                            value={issueChallanOpticalKey.grand_total_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="gst_percentage_yn"
                            id="gst_percentage_yn"
                            value={issueChallanOpticalKey.gst_percentage_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <FormGroup>
                          <Label for="rate_after_gst_yn">Rate After gst option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="rate_after_gst_yn"
                            id="rate_after_gst_yn"
                            value={issueChallanOpticalKey.rate_after_gst_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_amount_yn">Total Amount option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_amount_yn"
                            id="total_amount_yn"
                            value={issueChallanOpticalKey.total_amount_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="total_profit_yn">Total Profit option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="total_profit_yn"
                            id="total_profit_yn"
                            value={issueChallanOpticalKey.total_profit_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="current_stock_yn">Current Stock option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="current_stock_yn"
                            id="current_stock_yn"
                            value={issueChallanOpticalKey.current_stock_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="balance_qty_yn">Balance Qty option</Label>
                          <Input
                            type="select" className="custom-select"
                            name="balance_qty_yn"
                            id="balance_qty_yn"
                            value={issueChallanOpticalKey.balance_qty_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <FormGroup>
                          <Label for="warranty_period">Warranty Period</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_period"
                            id="warranty_period"
                            value={issueChallanOpticalKey.warranty_period}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_mode">Warranty Mode</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_mode"
                            id="warranty_mode"
                            value={issueChallanOpticalKey.warranty_mode}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="service_visit_count">Service Visit Count</Label>
                          <Input

                            type="select" className="custom-select"
                            name="service_visit_count"
                            id="service_visit_count"
                            value={issueChallanOpticalKey.service_visit_count}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_expiry_date">Warranty Expiry Date</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_expiry_date"
                            id="warranty_expiry_date"
                            value={issueChallanOpticalKey.warranty_expiry_date}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="warranty_button">Warranty Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="warranty_button"
                            id="warranty_button"
                            value={issueChallanOpticalKey.warranty_button}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="extra_detail_button">Extra Detail Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="extra_detail_button"
                            id="extra_detail_button"
                            value={issueChallanOpticalKey.extra_detail_button}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>



                        <h5>Aggrement Detail</h5>
                        <FormGroup>
                          <Label for="brokage_button">Brokage Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="brokage_button"
                            id="brokage_button"
                            value={issueChallanOpticalKey.brokage_button}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="mixed_button">Mixed Button</Label>
                          <Input

                            type="select" className="custom-select"
                            name="mixed_button"
                            id="mixed_button"
                            value={issueChallanOpticalKey.mixed_button}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="issuied_qty">Issuied Qty</Label>
                          <Input

                            type="select" className="custom-select"
                            name="issuied_qty"
                            id="issuied_qty"
                            value={issueChallanOpticalKey.issuied_qty}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        {/* Accordion keyword */}
                        <h4>Accordion Option</h4>
                        <FormGroup>
                          <Label for="chl_acc_addr_yn">Chl Acc Addr Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_addr_yn"
                            id="chl_acc_addr_yn"
                            value={issueChallanOpticalKey.chl_acc_addr_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_ext_yn">Chl Acc Bill Ext Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_ext_yn"
                            id="chl_acc_bill_ext_yn"
                            value={issueChallanOpticalKey.chl_acc_bill_ext_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_trans_yn">Chl Acc Trans Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_trans_yn"
                            id="chl_acc_trans_yn"
                            value={issueChallanOpticalKey.chl_acc_trans_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_misc_yn">Chl Acc Misc Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_misc_yn"
                            id="chl_acc_misc_yn"
                            value={issueChallanOpticalKey.chl_acc_misc_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_acc_yn">Chl Acc Bill Acc Yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_yn"
                            id="chl_acc_bill_acc_yn"
                            value={issueChallanOpticalKey.chl_acc_bill_acc_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>


                        <FormGroup>
                          <Label for="chl_acc_bill_acc_fixed_open_yn">chl acc bill acc fixed open yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_fixed_open_yn"
                            id="chl_acc_bill_acc_fixed_open_yn"
                            value={issueChallanOpticalKey.chl_acc_bill_acc_fixed_open_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label for="chl_acc_bill_acc_last_record_yn">chl acc bill acc last record yn</Label>
                          <Input

                            type="select" className="custom-select"
                            name="chl_acc_bill_acc_last_record_yn"
                            id="chl_acc_bill_acc_last_record_yn"
                            value={issueChallanOpticalKey.chl_acc_bill_acc_last_record_yn}
                            onChange={onChangeIssueSaleHandle("issue_challan_optical")}
                          >
                            <option value="">Select</option>
                            {helperMasterSystemMasterYNTable.map((option) => (
                              <option key={option.id} value={option.field_data}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                      </div>
                    </div>
                  </div>
                </div>


              </Form>
            </CardBody>
          }


          {/* party aggrement */}
          {flagMaster == "system_party_aggrement" && <CardBody>
            <Form>
              <div
                className='accordion accordion-flush'
                id='accordionFlushExample1'
              >
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='flush-headingSeven'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#flush-collapseSeven'
                      aria-expanded='false'
                      aria-controls='flush-collapseSeven'
                    >
                      Party Aggrement Item Detail
                    </button>
                  </h2>
                  <div
                    id='flush-collapseSeven'
                    className='accordion-collapse collapse'
                    aria-labelledby='flush-headingSeven'
                    data-bs-parent='#accordionFlushExample1'
                  >
                    <div className='accordion-body'>

                      <FormGroup>
                        <Label for="pc_rmt_pp_yn">Pc/Rmt/Pp Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="pc_rmt_pp_yn"
                          id="pc_rmt_pp_yn"
                          value={System_RecordsData.pc_rmt_pp_yn}
                          onChange={onChangeHandle}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="agr_qty_yn">Agr Qty Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="agr_qty_yn"
                          id="agr_qty_yn"
                          value={System_RecordsData.agr_qty_yn}
                          onChange={onChangeHandle}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="rent_rate_yn">Rent Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="rent_rate_yn"
                          id="rent_rate_yn"
                          value={System_RecordsData.rent_rate_yn}
                          onChange={onChangeHandle}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="missing_yn">Missing Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="missing_yn"
                          id="missing_yn"
                          value={System_RecordsData.missing_yn}
                          onChange={onChangeHandle}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="damage_yn">Damage Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="damage_yn"
                          id="damage_yn"
                          value={System_RecordsData.damage_yn}
                          onChange={onChangeHandle}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="opening_yn">Opening Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="opening_yn"
                          id="opening_yn"
                          value={System_RecordsData.opening_yn}
                          onChange={onChangeHandle}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                    </div>
                  </div>
                </div>
              </div>

              {/* <Button
                className='mt-2'
                color='primary'
                onClick={System_Records_Add_Edit_Screen}
              >
                {System_RecordsData.id ? "Update" : "Save"}
              </Button> */}
            </Form>
          </CardBody>}

          {/* party master */}
          {flagMaster == "party_detail" && <CardBody>
            <Form>
              <div id="accordionExample1">
                <div className="card">
                  <div className="card-header p-2" id="headingPartyDetail">
                    <h2 className="mb-0">
                      <button
                        className="btn btn-black btn-block text-left collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapsePartyDetail"
                        aria-expanded="false"
                        aria-controls="collapsePartyDetail"
                      >
                        <i className="bi bi-list-ul mr-2"></i>
                        Party Detail
                      </button>
                    </h2>

                  </div>



                  <div
                    id="collapsePartyDetail"
                    className="collapse"
                    aria-labelledby="headingPartyDetail"
                    data-parent="#accordionExample1"
                  >
                    <div className="card-body">

                      <Row>

                        <Col>

                          <FormGroup>
                            <Label for="pty_acc_fin_doc_yn">Pty Acc Fin Doc Yn</Label>
                            <Input

                              type="select" className="custom-select"
                              name="pty_acc_fin_doc_yn"
                              id="pty_acc_fin_doc_yn"
                              value={partyDetail.pty_acc_fin_doc_yn}
                              onChange={onChangeIssueSaleHandle("party_detail")}
                            >
                              <option value="">Select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label for="pty_acc_stf_yn">Pty Acc Stf Yn</Label>
                            <Input

                              type="select" className="custom-select"
                              name="pty_acc_stf_yn"
                              id="pty_acc_stf_yn"
                              value={partyDetail.pty_acc_stf_yn}
                              onChange={onChangeIssueSaleHandle("party_detail")}
                            >
                              <option value="">Select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label for="pty_acc_ext_yn">Pty Acc Ext Yn</Label>
                            <Input

                              type="select" className="custom-select"
                              name="pty_acc_ext_yn"
                              id="pty_acc_ext_yn"
                              value={partyDetail.pty_acc_ext_yn}
                              onChange={onChangeIssueSaleHandle("party_detail")}
                            >
                              <option value="">Select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label for="pty_acc_agr_yn">Pty Acc Agr Yn</Label>
                            <Input

                              type="select" className="custom-select"
                              name="pty_acc_agr_yn"
                              id="pty_acc_agr_yn"
                              value={partyDetail.pty_acc_agr_yn}
                              onChange={onChangeIssueSaleHandle("party_detail")}
                            >
                              <option value="">Select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label for="pty_acc_addr_yn">Pty Acc Addr Yn</Label>
                            <Input

                              type="select" className="custom-select"
                              name="pty_acc_addr_yn"
                              id="pty_acc_addr_yn"
                              value={partyDetail.pty_acc_addr_yn}
                              onChange={onChangeIssueSaleHandle("party_detail")}
                            >
                              <option value="">Select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col>

                          <FormGroup>
                            <Label for="pty_acc_cont_yn">Pty Acc Cont Yn</Label>
                            <Input

                              type="select" className="custom-select"
                              name="pty_acc_cont_yn"
                              id="pty_acc_cont_yn"
                              value={partyDetail.pty_acc_cont_yn}
                              onChange={onChangeIssueSaleHandle("party_detail")}
                            >
                              <option value="">Select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label for="pty_acc_rem_doc_yn">Pty Acc Rem Doc Yn</Label>
                            <Input

                              type="select" className="custom-select"
                              name="pty_acc_rem_doc_yn"
                              id="pty_acc_rem_doc_yn"
                              value={partyDetail.pty_acc_rem_doc_yn}
                              onChange={onChangeIssueSaleHandle("party_detail")}
                            >
                              <option value="">Select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>

                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>







            </Form>
          </CardBody>}


          {/* item master */}
          {flagMaster == "item_detail_old" &&
            <div
              className='accordion accordion-flush'
              id='accordionFlushExample1'
            >
              <div className='accordion-item'>
                <h2 className='accordion-header' id='flush-heading13'>
                  <button
                    className='accordion-button collapsed'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#flush-collapse13'
                    aria-expanded='false'
                    aria-controls='flush-collapse13'
                  >
                    Item Detail
                  </button>
                </h2>
                <div
                  id='flush-collapse13'
                  className='accordion-collapse collapse'
                  aria-labelledby='flush-heading13'
                  data-bs-parent='#accordionFlushExample1'
                >
                  <div className='accordion-body'>

                    <h4>Item Accordion Option</h4>

                    <FormGroup>
                      <Label for="item_acc_mixed_yn">Item Acc Mixed Yn</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_acc_mixed_yn"
                        id="item_acc_mixed_yn"
                        value={itemDetail.item_acc_mixed_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">Select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup>
                      <Label for="item_acc_website_yn">Item Acc Website Yn</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_acc_website_yn"
                        id="item_acc_website_yn"
                        value={itemDetail.item_acc_website_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">Select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup>
                      <Label for="item_acc_convertion_yn">Item Acc Convertion Yn</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_acc_convertion_yn"
                        id="item_acc_convertion_yn"
                        value={itemDetail.item_acc_convertion_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">Select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup>
                      <Label for="item_acc_price_yn">Item Acc Price Yn</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_acc_price_yn"
                        id="item_acc_price_yn"
                        value={itemDetail.item_acc_price_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">Select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup>
                      <Label for="item_acc_stock_yn">Item Acc Stock Yn</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_acc_stock_yn"
                        id="item_acc_stock_yn"
                        value={itemDetail.item_acc_stock_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">Select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup>
                      <Label for="item_acc_remark_upload_yn">Item Acc Remark Upload Yn</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_acc_remark_upload_yn"
                        id="item_acc_remark_upload_yn"
                        value={itemDetail.item_acc_remark_upload_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">Select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>


                    <h4>Stock Detail Acc Keyword</h4>
                    <FormGroup>
                      <Label for="batch_no">Batch/Serial No</Label>
                      <Input
                        type="select" className="custom-select"
                        name="batch_no"
                        id="batch_no"
                        value={itemDetail.batch_no}
                        onChange={onChangeIssueSaleHandle("item_detail")}


                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Label for="style">Style</Label>
                      <Input
                        type="select" className="custom-select"
                        name="style"
                        id="style"
                        value={itemDetail.style}
                        onChange={onChangeIssueSaleHandle("item_detail")}


                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup>
                      <Label for="size">Size</Label>
                      <Input
                        type="select" className="custom-select"
                        name="size"
                        id="size"
                        value={itemDetail.size}
                        onChange={onChangeIssueSaleHandle("item_detail")}


                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Label for="brand">Multiple Brand Allow</Label>
                      <Input
                        type="select" className="custom-select"
                        name="brand"
                        id="brand"
                        value={itemDetail.brand}
                        onChange={onChangeIssueSaleHandle("item_detail")}

                      >

                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}

                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Label for="color">Color</Label>
                      <Input
                        type="select" className="custom-select"
                        name="color"
                        id="color"
                        value={itemDetail.color}
                        onChange={onChangeIssueSaleHandle("item_detail")}


                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Label for="agent">Agent</Label>
                      <Input
                        type="select" className="custom-select"
                        name="agent"
                        id="agent"
                        value={itemDetail.agent}
                        onChange={onChangeIssueSaleHandle("item_detail")}


                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Label for="dealer">Dealer</Label>
                      <Input
                        type="select" className="custom-select"
                        name="dealer"
                        id="dealer"
                        value={itemDetail.dealer}
                        onChange={onChangeIssueSaleHandle("item_detail")}


                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>


                    <h4>Item Master Main Keyword</h4>


                    <FormGroup>
                      <Label for="item_inventory_type_yn">Inventory Type</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_inventory_type_yn"
                        id="item_inventory_type_yn"
                        value={itemDetail.item_inventory_type_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup>
                      <Label for="item_proces_type_yn">Process Type</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_proces_type_yn"
                        id="item_proces_type_yn"
                        value={itemDetail.item_proces_type_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup>
                      <Label for="item_pack_type_yn">Pack Type</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_pack_type_yn"
                        id="item_pack_type_yn"
                        value={itemDetail.item_pack_type_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup>
                      <Label for="item_classify_yn">Classify</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_classify_yn"
                        id="item_classify_yn"
                        value={itemDetail.item_classify_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup>
                      <Label for="item_barcode_yn">Barcode</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_barcode_yn"
                        id="item_barcode_yn"
                        value={itemDetail.item_barcode_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup>
                      <Label for="item_gst_per_yn">GST Percentage</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_gst_per_yn"
                        id="item_gst_per_yn"
                        value={itemDetail.item_gst_per_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>


                    <FormGroup>
                      <Label for="item_remark_yn">Remark</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_remark_yn"
                        id="item_remark_yn"
                        value={itemDetail.item_remark_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup>
                      <Label for="item_reorder_qty_yn">Reorder Qty</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_reorder_qty_yn"
                        id="item_reorder_qty_yn"
                        value={itemDetail.item_reorder_qty_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup>
                      <Label for="item_min_qty_yn">Min Qty</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_min_qty_yn"
                        id="item_min_qty_yn"
                        value={itemDetail.item_min_qty_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup>
                      <Label for="item_max_qty_yn">Max Qty</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_max_qty_yn"
                        id="item_max_qty_yn"
                        value={itemDetail.item_max_qty_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup>
                      <Label for="item_warnty_available_yn">Warranty Available</Label>
                      <Input

                        type="select" className="custom-select"
                        name="item_warnty_available_yn"
                        id="item_warnty_available_yn"
                        value={itemDetail.item_warnty_available_yn}
                        onChange={onChangeIssueSaleHandle("item_detail")}
                      >
                        <option value="">select</option>
                        {helperMasterSystemMasterYNTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>


                  </div>
                </div>
              </div>
            </div>}


          {flagMaster === "item_detail" && (
            <CardBody>
              <Form>
                <div id="accordionExample1">
                  <div className="card">
                    <div className="card-header p-2" id="headingItemDetail">
                      <h2 className="mb-0">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseItemDetail"
                          aria-expanded="false"
                          aria-controls="collapseItemDetail"
                        >
                          <i className="bi bi-list-ul mr-2"></i>
                          Item Details
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapseItemDetail"
                      className="collapse"
                      aria-labelledby="headingItemDetail"
                      data-parent="#accordionExample1"
                    >
                      <div className="card-body">

                        <Row>

                          <Col sm={3}>
                            <FormGroup>
                              <Label for="item_acc_mixed_yn">Item Acc Mixed Yn</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_acc_mixed_yn"
                                id="item_acc_mixed_yn"
                                value={itemDetail.item_acc_mixed_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">Select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>
                            <FormGroup>
                              <Label for="item_acc_website_yn">Item Acc Website Yn</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_acc_website_yn"
                                id="item_acc_website_yn"
                                value={itemDetail.item_acc_website_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">Select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>

                            <FormGroup>
                              <Label for="item_acc_convertion_yn">Item Acc Convertion Yn</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_acc_convertion_yn"
                                id="item_acc_convertion_yn"
                                value={itemDetail.item_acc_convertion_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">Select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>

                            <FormGroup>
                              <Label for="item_acc_price_yn">Item Acc Price Yn</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_acc_price_yn"
                                id="item_acc_price_yn"
                                value={itemDetail.item_acc_price_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">Select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>

                            <FormGroup>
                              <Label for="item_acc_stock_yn">Item Acc Stock Yn</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_acc_stock_yn"
                                id="item_acc_stock_yn"
                                value={itemDetail.item_acc_stock_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">Select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>

                            <FormGroup>
                              <Label for="item_acc_remark_upload_yn">Item Acc Remark Upload Yn</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_acc_remark_upload_yn"
                                id="item_acc_remark_upload_yn"
                                value={itemDetail.item_acc_remark_upload_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">Select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                        </Row>

                        <h4>Stock Detail Acc Keyword</h4>

                        <Row>

                          <Col sm={3}>

                            <FormGroup>
                              <Label for="batch_no">Batch/Serial No</Label>
                              <Input
                                type="select" className="custom-select"
                                name="batch_no"
                                id="batch_no"
                                value={itemDetail.batch_no}
                                onChange={onChangeIssueSaleHandle("item_detail")}


                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>
                            <FormGroup>
                              <Label for="style">Style</Label>
                              <Input
                                type="select" className="custom-select"
                                name="style"
                                id="style"
                                value={itemDetail.style}
                                onChange={onChangeIssueSaleHandle("item_detail")}


                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>

                            <FormGroup>
                              <Label for="size">Size</Label>
                              <Input
                                type="select" className="custom-select"
                                name="size"
                                id="size"
                                value={itemDetail.size}
                                onChange={onChangeIssueSaleHandle("item_detail")}


                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>
                            <FormGroup>
                              <Label for="brand">Multiple Brand Allow</Label>
                              <Input
                                type="select" className="custom-select"
                                name="brand"
                                id="brand"
                                value={itemDetail.brand}
                                onChange={onChangeIssueSaleHandle("item_detail")}

                              >

                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}

                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>
                            <FormGroup>
                              <Label for="color">Color</Label>
                              <Input
                                type="select" className="custom-select"
                                name="color"
                                id="color"
                                value={itemDetail.color}
                                onChange={onChangeIssueSaleHandle("item_detail")}


                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>
                            <FormGroup>
                              <Label for="agent">Agent</Label>
                              <Input
                                type="select" className="custom-select"
                                name="agent"
                                id="agent"
                                value={itemDetail.agent}
                                onChange={onChangeIssueSaleHandle("item_detail")}


                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>
                            <FormGroup>
                              <Label for="dealer">Dealer</Label>
                              <Input
                                type="select" className="custom-select"
                                name="dealer"
                                id="dealer"
                                value={itemDetail.dealer}
                                onChange={onChangeIssueSaleHandle("item_detail")}


                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                        </Row>

                        <h4>Item Master Main Keyword</h4>

                        <Row>

                          <Col sm={3}>
                            <FormGroup>
                              <Label for="item_inventory_type_yn">Inventory Type</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_inventory_type_yn"
                                id="item_inventory_type_yn"
                                value={itemDetail.item_inventory_type_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>

                            <FormGroup>
                              <Label for="item_proces_type_yn">Process Type</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_proces_type_yn"
                                id="item_proces_type_yn"
                                value={itemDetail.item_proces_type_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>

                            <FormGroup>
                              <Label for="item_pack_type_yn">Pack Type</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_pack_type_yn"
                                id="item_pack_type_yn"
                                value={itemDetail.item_pack_type_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>

                            <FormGroup>
                              <Label for="item_classify_yn">Classify</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_classify_yn"
                                id="item_classify_yn"
                                value={itemDetail.item_classify_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>

                            <FormGroup>
                              <Label for="item_barcode_yn">Barcode</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_barcode_yn"
                                id="item_barcode_yn"
                                value={itemDetail.item_barcode_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>

                            <FormGroup>
                              <Label for="item_gst_per_yn">GST Percentage</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_gst_per_yn"
                                id="item_gst_per_yn"
                                value={itemDetail.item_gst_per_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>


                            <FormGroup>
                              <Label for="item_remark_yn">Remark</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_remark_yn"
                                id="item_remark_yn"
                                value={itemDetail.item_remark_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>

                            <FormGroup>
                              <Label for="item_reorder_qty_yn">Reorder Qty</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_reorder_qty_yn"
                                id="item_reorder_qty_yn"
                                value={itemDetail.item_reorder_qty_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>

                            <FormGroup>
                              <Label for="item_min_qty_yn">Min Qty</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_min_qty_yn"
                                id="item_min_qty_yn"
                                value={itemDetail.item_min_qty_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>

                            <FormGroup>
                              <Label for="item_max_qty_yn">Max Qty</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_max_qty_yn"
                                id="item_max_qty_yn"
                                value={itemDetail.item_max_qty_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col sm={3}>

                            <FormGroup>
                              <Label for="item_warnty_available_yn">Warranty Available</Label>
                              <Input

                                type="select" className="custom-select"
                                name="item_warnty_available_yn"
                                id="item_warnty_available_yn"
                                value={itemDetail.item_warnty_available_yn}
                                onChange={onChangeIssueSaleHandle("item_detail")}
                              >
                                <option value="">select</option>
                                {helperMasterSystemMasterYNTable.map((option) => (
                                  <option key={option.id} value={option.field_data}>
                                    {option.field_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>

                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </CardBody>
          )}



          {/* Voucher Master */}
          {flagMaster == "voucher" && <CardBody>
            <Form>
              <div
                className='accordion accordion-flush'
                id='accordionFlushExample1'
              >
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='flush-headingEight'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#flush-collapseEight'
                      aria-expanded='false'
                      aria-controls='flush-collapseEight'
                    >
                      Voucher Master
                    </button>
                  </h2>
                  <div
                    id='flush-collapseEight'
                    className='accordion-collapse collapse'
                    aria-labelledby='flush-headingEight'
                    data-bs-parent='#accordionFlushExample1'
                  >
                    <div className='accordion-body'>

                      {/* Recipted */}
                      <Row>
                        <h5>Voucher Type ( Recipted )</h5>
                        <Col>
                          <FormGroup>
                            <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="gst_percentage_yn"
                              id="gst_percentage_yn"
                              value={voucherRecipted.gst_percentage_yn}
                              onChange={onChangeIssueSaleHandle("voucher_recipted")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label for="gst_amount_yn">Gst Amount Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="gst_amount_yn"
                              id="gst_amount_yn"
                              value={voucherRecipted.gst_amount_yn}
                              onChange={onChangeIssueSaleHandle("voucher_recipted")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label for="grand_total_yn">Grand Total Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="grand_total_yn"
                              id="grand_total_yn"
                              value={voucherRecipted.grand_total_yn}
                              onChange={onChangeIssueSaleHandle("voucher_recipted")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>

                      {/* Payment */}
                      <Row>
                        <h5>Voucher Type ( Payment )</h5>
                        <Col>
                          <FormGroup>
                            <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="gst_percentage_yn"
                              id="gst_percentage_yn"
                              value={voucherPayment.gst_percentage_yn}
                              onChange={onChangeIssueSaleHandle("voucher_payment")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label for="gst_amount_yn">Gst Amount Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="gst_amount_yn"
                              id="gst_amount_yn"
                              value={voucherPayment.gst_amount_yn}
                              onChange={onChangeIssueSaleHandle("voucher_payment")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label for="grand_total_yn">Grand Total Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="grand_total_yn"
                              id="grand_total_yn"
                              value={voucherPayment.grand_total_yn}
                              onChange={onChangeIssueSaleHandle("voucher_payment")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>

                      {/* Contra */}
                      <Row>
                        <h5>Voucher Type ( Contra )</h5>
                        <Col>
                          <FormGroup>
                            <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="gst_percentage_yn"
                              id="gst_percentage_yn"
                              value={voucherContra.gst_percentage_yn}
                              onChange={onChangeIssueSaleHandle("voucher_contra")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label for="gst_amount_yn">Gst Amount Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="gst_amount_yn"
                              id="gst_amount_yn"
                              value={voucherContra.gst_amount_yn}
                              onChange={onChangeIssueSaleHandle("voucher_contra")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label for="grand_total_yn">Grand Total Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="grand_total_yn"
                              id="grand_total_yn"
                              value={voucherContra.grand_total_yn}
                              onChange={onChangeIssueSaleHandle("voucher_contra")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>

                      {/* Journal */}
                      <Row>
                        <h5>Voucher Type ( Journal )</h5>
                        <Col>
                          <FormGroup>
                            <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="gst_percentage_yn"
                              id="gst_percentage_yn"
                              value={voucherJournal.gst_percentage_yn}
                              onChange={onChangeIssueSaleHandle("voucher_journal")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label for="gst_amount_yn">Gst Amount Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="gst_amount_yn"
                              id="gst_amount_yn"
                              value={voucherJournal.gst_amount_yn}
                              onChange={onChangeIssueSaleHandle("voucher_journal")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label for="grand_total_yn">Grand Total Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="grand_total_yn"
                              id="grand_total_yn"
                              value={voucherJournal.grand_total_yn}
                              onChange={onChangeIssueSaleHandle("voucher_journal")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>

                      {/* Credit */}
                      <Row>
                        <h5>Voucher Type ( Credit )</h5>
                        <Col>
                          <FormGroup>
                            <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="gst_percentage_yn"
                              id="gst_percentage_yn"
                              value={voucherCredit.gst_percentage_yn}
                              onChange={onChangeIssueSaleHandle("voucher_credit")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label for="gst_amount_yn">Gst Amount Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="gst_amount_yn"
                              id="gst_amount_yn"
                              value={voucherCredit.gst_amount_yn}
                              onChange={onChangeIssueSaleHandle("voucher_credit")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label for="grand_total_yn">Grand Total Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="grand_total_yn"
                              id="grand_total_yn"
                              value={voucherCredit.grand_total_yn}
                              onChange={onChangeIssueSaleHandle("voucher_credit")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>

                      {/* Debit */}
                      <Row>
                        <h5>Voucher Type ( Debit )</h5>
                        <Col>
                          <FormGroup>
                            <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="gst_percentage_yn"
                              id="gst_percentage_yn"
                              value={voucherDebit.gst_percentage_yn}
                              onChange={onChangeIssueSaleHandle("voucher_debit")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label for="gst_amount_yn">Gst Amount Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="gst_amount_yn"
                              id="gst_amount_yn"
                              value={voucherDebit.gst_amount_yn}
                              onChange={onChangeIssueSaleHandle("voucher_debit")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label for="grand_total_yn">Grand Total Option</Label>
                            <Input
                              type="select" className="custom-select"
                              name="grand_total_yn"
                              id="grand_total_yn"
                              value={voucherDebit.grand_total_yn}
                              onChange={onChangeIssueSaleHandle("voucher_debit")}
                            >
                              <option value="">select</option>
                              {helperMasterSystemMasterYNTable.map((option) => (
                                <option key={option.id} value={option.field_data}>
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>

                    </div>
                  </div>
                </div>
              </div>

              {/* <Button
                className='mt-2'
                color='primary'
                onClick={System_Records_Add_Edit_Screen}
              >
                {System_RecordsData.id ? "Update" : "Save"}
              </Button> */}
            </Form>
          </CardBody>}

          {/* Internal HouseKeeper Master */}
          {flagMaster == "housekeeper" && <CardBody>
            <Form>
              <div
                className='accordion accordion-flush'
                id='accordionFlushExample1'
              >
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='flush-heading11'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#flush-collapse11'
                      aria-expanded='false'
                      aria-controls='flush-collapse11'
                    >
                      Housekeeper Master
                    </button>
                  </h2>
                  <div
                    id='flush-collapse11'
                    className='accordion-collapse collapse'
                    aria-labelledby='flush-heading11'
                    data-bs-parent='#accordionFlushExample1'
                  >
                    <div className='accordion-body'>

                      <FormGroup>
                        <Label for="purchase_rate_yn">Purchase Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="purchase_rate_yn"
                          id="purchase_rate_yn"
                          value={housekeeper.purchase_rate_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="profit_yn">Profit Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="profit_yn"
                          id="profit_yn"
                          value={housekeeper.profit_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="discount_amount_yn">Discount Amount Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_amount_yn"
                          id="discount_amount_yn"
                          value={housekeeper.discount_amount_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="discount_rate_yn">Discount Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_rate_yn"
                          id="discount_rate_yn"
                          value={housekeeper.discount_rate_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="gst_amount_yn">Gst Amount Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_amount_yn"
                          id="gst_amount_yn"
                          value={housekeeper.gst_amount_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="gst_rate_yn">Gst Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_rate_yn"
                          id="gst_rate_yn"
                          value={housekeeper.gst_rate_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_profit_yn">Total Profit Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_profit_yn"
                          id="total_profit_yn"
                          value={housekeeper.total_profit_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_weight_yn">Total Weight Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_weight_yn"
                          id="total_weight_yn"
                          value={housekeeper.total_weight_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="hsn_code_yn">HSN Code Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="hsn_code_yn"
                          id="hsn_code_yn"
                          value={housekeeper.hsn_code_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="packing_type_yn">Packing Type Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="packing_type_yn"
                          id="packing_type_yn"
                          value={housekeeper.packing_type_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="scheme_type_yn">Scheme Type Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="scheme_type_yn"
                          id="scheme_type_yn"
                          value={housekeeper.scheme_type_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="remarks_yn">Remark Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="remarks_yn"
                          id="remarks_yn"
                          value={housekeeper.remarks_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="sale_rate_yn">Sale Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="sale_rate_yn"
                          id="sale_rate_yn"
                          value={housekeeper.sale_rate_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        {/* //sale_qty_yn */}
                        <Label for="issue_qty_yn">Sale Qty Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="issue_qty_yn"
                          id="issue_qty_yn"
                          value={housekeeper.issue_qty_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="discount_percentage_yn">Discount Percentage Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_percentage_yn"
                          id="discount_percentage_yn"
                          value={housekeeper.discount_percentage_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="grand_total_yn">Grand Total Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="grand_total_yn"
                          id="grand_total_yn"
                          value={housekeeper.grand_total_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_percentage_yn"
                          id="gst_percentage_yn"
                          value={housekeeper.gst_percentage_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                      <FormGroup>
                        <Label for="rate_after_gst_yn">Rate After gst option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="rate_after_gst_yn"
                          id="rate_after_gst_yn"
                          value={housekeeper.rate_after_gst_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_amount_yn">Total Amount option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_amount_yn"
                          id="total_amount_yn"
                          value={housekeeper.total_amount_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_profit_yn">Total Profit option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_profit_yn"
                          id="total_profit_yn"
                          value={housekeeper.total_profit_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="current_stock_yn">Current Stock option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="current_stock_yn"
                          id="current_stock_yn"
                          value={housekeeper.current_stock_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="balance_qty_yn">Balance Qty option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="balance_qty_yn"
                          id="balance_qty_yn"
                          value={housekeeper.balance_qty_yn}
                          onChange={onChangeIssueSaleHandle("housekeeper")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                    </div>
                  </div>
                </div>
              </div>


            </Form>
          </CardBody>}

          {/* Book Room Service */}
          {flagMaster == "book_room_service" && <CardBody>
            <Form>
              <div
                className='accordion accordion-flush'
                id='accordionFlushExample1'
              >
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='flush-heading12'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#flush-collapse12'
                      aria-expanded='false'
                      aria-controls='flush-collapse12'
                    >
                      Room Service Master
                    </button>
                  </h2>
                  <div
                    id='flush-collapse12'
                    className='accordion-collapse collapse'
                    aria-labelledby='flush-heading12'
                    data-bs-parent='#accordionFlushExample1'
                  >
                    <div className='accordion-body'>

                      <FormGroup>
                        <Label for="purchase_rate_yn">Purchase Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="purchase_rate_yn"
                          id="purchase_rate_yn"
                          value={bookRoomService.purchase_rate_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="profit_yn">Profit Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="profit_yn"
                          id="profit_yn"
                          value={bookRoomService.profit_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="discount_amount_yn">Discount Amount Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_amount_yn"
                          id="discount_amount_yn"
                          value={bookRoomService.discount_amount_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="discount_rate_yn">Discount Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_rate_yn"
                          id="discount_rate_yn"
                          value={bookRoomService.discount_rate_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="gst_amount_yn">Gst Amount Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_amount_yn"
                          id="gst_amount_yn"
                          value={bookRoomService.gst_amount_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="gst_rate_yn">Gst Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_rate_yn"
                          id="gst_rate_yn"
                          value={bookRoomService.gst_rate_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_profit_yn">Total Profit Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_profit_yn"
                          id="total_profit_yn"
                          value={bookRoomService.total_profit_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_weight_yn">Total Weight Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_weight_yn"
                          id="total_weight_yn"
                          value={bookRoomService.total_weight_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="hsn_code_yn">HSN Code Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="hsn_code_yn"
                          id="hsn_code_yn"
                          value={bookRoomService.hsn_code_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="packing_type_yn">Packing Type Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="packing_type_yn"
                          id="packing_type_yn"
                          value={bookRoomService.packing_type_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="scheme_type_yn">Scheme Type Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="scheme_type_yn"
                          id="scheme_type_yn"
                          value={bookRoomService.scheme_type_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="remarks_yn">Remark Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="remarks_yn"
                          id="remarks_yn"
                          value={bookRoomService.remarks_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="sale_rate_yn">Sale Rate Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="sale_rate_yn"
                          id="sale_rate_yn"
                          value={bookRoomService.sale_rate_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        {/* //sale_qty_yn */}
                        <Label for="issue_qty_yn">Sale Qty Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="issue_qty_yn"
                          id="issue_qty_yn"
                          value={bookRoomService.issue_qty_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="discount_percentage_yn">Discount Percentage Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="discount_percentage_yn"
                          id="discount_percentage_yn"
                          value={bookRoomService.discount_percentage_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="grand_total_yn">Grand Total Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="grand_total_yn"
                          id="grand_total_yn"
                          value={bookRoomService.grand_total_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label for="gst_percentage_yn">Gst Percentage Option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="gst_percentage_yn"
                          id="gst_percentage_yn"
                          value={bookRoomService.gst_percentage_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                      <FormGroup>
                        <Label for="rate_after_gst_yn">Rate After gst option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="rate_after_gst_yn"
                          id="rate_after_gst_yn"
                          value={bookRoomService.rate_after_gst_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_amount_yn">Total Amount option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_amount_yn"
                          id="total_amount_yn"
                          value={bookRoomService.total_amount_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="total_profit_yn">Total Profit option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="total_profit_yn"
                          id="total_profit_yn"
                          value={bookRoomService.total_profit_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="current_stock_yn">Current Stock option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="current_stock_yn"
                          id="current_stock_yn"
                          value={bookRoomService.current_stock_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      <FormGroup>
                        <Label for="balance_qty_yn">Balance Qty option</Label>
                        <Input
                          type="select" className="custom-select"
                          name="balance_qty_yn"
                          id="balance_qty_yn"
                          value={bookRoomService.balance_qty_yn}
                          onChange={onChangeIssueSaleHandle("book_room_service")}
                        >
                          <option value="">select</option>
                          {helperMasterSystemMasterYNTable.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>



                    </div>
                  </div>


                </div>
              </div>


            </Form>
          </CardBody>}

          <Col>
            <Button
              className='mt-2'
              color='primary'
              onClick={System_Records_Add_Edit_Screen}
            >
              {System_RecordsData.id ? "Update" : "Save"}
            </Button>
          </Col>
        </Card>
      </Col>
    </Row>
  );
};

export default AddSystemRecordsMaster;



